import React from 'react';

export const ICONS = {
  ADD: {
    format: 'data',
    class: 'icon-add',
    path: 'M7.5 5.5h4.056c.535 0 .944.46.944 1s-.41 1-.944 1H7.5v4.056c0 .535-.46.944-1 .944s-1-.41-1-.944V7.5H1.444C.91 7.5.5 7.04.5 6.5s.41-1 .944-1H5.5V1.444C5.5.91 5.96.5 6.5.5s1 .41 1 .944V5.5zm4.056 1H11.5c0-.012.01 0 .056 0zM6.5 11.556c0-.045-.012-.056 0-.056v.056zM1.444 6.5H1.5c0 .012-.01 0-.056 0zm10.056 0h-5v-5c-.012 0 0-.01 0-.056V6.5H1.444c.045 0 .056-.012.056 0h5v5c.012 0 0 .01 0 .056V6.5h5.056c-.045 0-.056.012-.056 0z',
    viewBox: '0 0 12 12',
  },

  ADD_CIRCLE: {
    format: 'markup',
    class: 'icon-add-circle',
    markup: (
      <g>
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z" />
      </g>
    ),
    viewBox: '0 0 24 24',
  },

  ANGLE_LEFT: {
    format: 'data',
    class: 'icon-angle-left',
    path: 'M9 13.23L3.435 7.5 9 1.77 7.283 0 0 7.5 7.283 15z',
    viewBox: '0 0 9 15',
  },

  ARROW_BACKWARD: {
    format: 'markup',
    class: 'icon-arrow-backward',
    markup: (
      <g>
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M0 0h24v24H0z"
          fill="none"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },

  ARROW_FORWARD: {
    format: 'markup',
    class: 'icon-arrow-forward',
    markup: (
      <g>
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M0 0h24v24H0z"
          fill="none"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },

  ARROW_UP: {
    format: 'markup',
    class: 'icon-arrow-up',
    markup: (
      <g>
        <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </g>
    ),
    viewBox: '0 0 24 24',
  },

  ARROW_DOWN: {
    format: 'markup',
    class: 'icon-arrow-down',
    markup: (
      <g>
        <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
        <path fill="none" d="M0 0h24v24H0V0z" />
      </g>
    ),
    viewBox: '0 0 24 24',
  },

  BACK: {
    format: 'data',
    class: 'icon-back',
    path: 'M 21 11 H 6.83 l 3.58 -3.59 L 9 6 l -6 6 l 6 6 l 1.41 -1.41 L 6.83 13 H 21 Z',
    viewBox: '0 0 24 24',
  },

  BULLET: {
    format: 'markup',
    class: 'icon-bullet',
    markup: (
      <g>
        <path fill="none" d="M24 24H0V0h24v24z" />
        <circle cx="12" cy="12" r="8" />
      </g>
    ),
    viewBox: '0 0 24 24',
  },

  BULLSEYE: {
    format: 'data',
    class: 'icon-bullseye',
    path: 'M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12zm0 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z',
    viewBox: '0 0 24 24',
  },

  BURGER: {
    format: 'data',
    class: 'icon-burger',
    path: 'M1 0h18a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm0 6h18a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm0 6h18a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z',
    viewBox: '0 0 20 15',
  },

  CAMERA: {
    format: 'data',
    class: 'icon-camera',
    path: 'M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z',
    viewBox: '0 0 24 24',
  },

  CARD: {
    format: 'markup',
    class: 'icon-card',
    viewBox: '0 0 21 21',
    markup: (
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h21v21H0z" />
        <path
          fill="#1286C8"
          fillRule="nonzero"
          d="M11.92 6.08c.662 0 1.207.559 1.21 1.256v8.408c0 .697-.545 1.256-1.21 1.256H6.21C5.545 17 5 16.44 5 15.744V7.336c0-.697.545-1.256 1.21-1.256h5.71zm.05 9.661V7.336c0-.018-.02-.04-.052-.04h-5.71c-.032 0-.053.022-.053.04v8.405c0 .018.02.04.053.04h5.71c.032 0 .052-.022.052-.04zM14.79 4c.665 0 1.21.56 1.21 1.256v8.408c0 .697-.545 1.256-1.21 1.256a.592.592 0 0 1-.579-.608c0-.341.261-.609.579-.609.032 0 .053-.021.053-.04V5.257c0-.018-.021-.04-.053-.04H9.08c-.032 0-.053.022-.053.04 0 .341-.261.609-.579.609a.592.592 0 0 1-.578-.609C7.87 4.56 8.415 4 9.08 4h5.71z"
        />
      </g>
    ),
  },

  COLLECTION: {
    format: 'markup',
    class: 'icon-collection',
    markup: (
      <g>
        <rect
          x="5"
          y="8"
          width="9"
          height="13"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 5V3H19V16H17"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },

  CLOSE: {
    format: 'data',
    class: 'icon-close',
    path: 'M5.5 4.44L1.257.196a.75.75 0 1 0-1.06 1.06L4.44 5.5.196 9.743a.75.75 0 1 0 1.06 1.06L5.5 6.56l4.243 4.243a.75.75 0 1 0 1.06-1.06L6.56 5.5l4.243-4.243a.75.75 0 1 0-1.06-1.06L5.5 4.44z',
    viewBox: '0 0 11 11',
  },

  COPY: {
    format: 'data',
    class: 'icon-copy',
    path: 'M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z',
    viewBox: '0 0 24 24',
  },

  DROPDOWN: {
    format: 'data',
    class: 'icon-drop-down',
    path: 'M7 10l5 5 5-5z',
    viewBox: '0 0 24 24',
  },

  EMAIL: {
    format: 'data',
    class: 'icon-email',
    path: 'M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z',
    viewBox: '0 0 24 24',
  },

  ESCALATED: {
    format: 'data',
    class: 'icon-angle-left',
    path: 'M8.144 4.432h-1.82a.425.425 0 0 1-.3-.725L8.7 1.025a.424.424 0 0 1 .6 0l2.675 2.682a.425.425 0 0 1-.3.725h-1.82v8.243c0 .235-.19.425-.423.425h-.864a.425.425 0 0 1-.424-.425V4.432zM3.5 6.5h2.028c.268 0 .472.23.472.5s-.204.5-.472.5H3.5v2.028c0 .268-.23.472-.5.472s-.5-.204-.5-.472V7.5H.472C.204 7.5 0 7.27 0 7s.204-.5.472-.5H2.5V4.472C2.5 4.204 2.73 4 3 4s.5.204.5.472V6.5z',
    viewBox: '0 0 12 12',
  },

  FACEBOOK: {
    format: 'data',
    class: 'icon-facebook',
    path: 'M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M18,5H15.5A3.5,3.5 0 0,0 12,8.5V11H10V14H12V21H15V14H18V11H15V9A1,1 0 0,1 16,8H18V5Z',
    viewBox: '0 0 24 24',
  },

  FULLSCREEN: {
    format: 'markup',
    class: 'icon-fullscreen',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" />
      </g>
    ),
  },

  FULLSCREEN_EXIT: {
    format: 'markup',
    class: 'icon-fullscreen-exit',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z" />
      </g>
    ),
  },

  GLOBE: {
    format: 'data',
    class: 'icon-globe',
    path: 'M20 10c0 5.514-4.486 10-10 10S0 15.514 0 10a9.983 9.983 0 0 1 3.836-7.866l.3-.235.166-.116.066-.043c.167-.112.333-.22.507-.323l.174-.1c.16-.092.297-.166.437-.237l.056-.03c.057-.03.057-.03.12-.06a9.747 9.747 0 0 1 .763-.327c.16-.062.323-.12.487-.173l.173-.056c.178-.054.362-.104.555-.15.1-.025.1-.025.203-.047.22-.05.42-.088.622-.12.253-.037.46-.06.683-.078l.176-.015a9.263 9.263 0 0 1 1.39.004l.08.005A10.05 10.05 0 0 1 12.65.36l.16.045c.164.048.326.1.486.156l.114.04c.18.065.36.136.542.215l.14.063.063.03a9.663 9.663 0 0 1 .57.28 10.244 10.244 0 0 1 .52.298L16.4 2.2l-.084.054A9.984 9.984 0 0 1 20 10zm-5.334-7.576l-.07-.04a9.117 9.117 0 0 0-.965-.504l-.115-.052a8.807 8.807 0 0 0-.54-.212 9.93 9.93 0 0 0-.476-.154l-.14-.04a8.623 8.623 0 0 0-1.09-.227l-.053-.007-.07-.008a8.932 8.932 0 0 0-.44-.046l-.08-.006-.072-.005a8.224 8.224 0 0 0-1.157.002l-.157.012a8.595 8.595 0 0 0-1.16.176l-.18.042a8.84 8.84 0 0 0-.493.134l-.105.032a9.265 9.265 0 0 0-1.16.46l-.083.044-.073.037a8.68 8.68 0 0 0-.367.197l-.18.103a9.06 9.06 0 0 0-.664.442A8.885 8.885 0 0 0 1.102 10c0 4.906 3.992 8.898 8.898 8.898s8.898-3.992 8.898-8.898c0-2.955-1.46-5.67-3.855-7.324L14.79 2.5l-.124-.077zM8.812 6.69a.888.888 0 0 1-.112-.24l.528-.156-.132.535a1.404 1.404 0 0 1-.245-.087l-.038-.053zm.658-.254l.548.058-.016.55a1.657 1.657 0 0 0-.31.027l-.122.02a1.302 1.302 0 0 1-.1-.654zm.73 1.168l-.002-.006a.385.385 0 0 0 .17.202l-.016-.005a1.263 1.263 0 0 1-.1-.035 1.825 1.825 0 0 1-.052-.156zm1.093 2.1c-.288.704-.024 1.55.71 2.157.868.72.846 1.73.26 3.076.18-.125.367-.27.566-.443.21-.182.39-.382.585-.644.07-.094.123-.17.246-.345l.19-.268c.282-.39.537-.682.855-.946l.058-.152c.07-.18.102-.27.144-.388.043-.124.08-.238.112-.345.055-.194.09-.354.097-.467-.405-.25-.674-.596-1.044-1.222l-.066-.113c-.214-.365-.338-.56-.47-.716a3.04 3.04 0 0 1-.752-.244l-.182-.086c-.202-.098-.1-.083-.037-.13-.376.283-.832.388-1.263.285.12.31.124.66-.01.99zm-3.33-4.41c.043-.948.458-1.203 1.5-1.32.545-.223 1.028-.256 1.443-.063.592-.754 1.158-1.285 1.85-1.704a7.844 7.844 0 0 0-.305-.102l-.045-.013a8.267 8.267 0 0 0-.403-.11l-.076-.018-.047-.01a8.385 8.385 0 0 0-.33-.07c-.07-.015-.07-.015-.146-.027a7.797 7.797 0 0 0-.32-.05l-.033-.003-.115-.015a8.37 8.37 0 0 0-.335-.03l-.053-.005-.08-.005a8.19 8.19 0 0 0-1.003.004l-.15.013a8.483 8.483 0 0 0-.423.045l-.065.01-.05.005a8.316 8.316 0 0 0-.5.09l-.116.028-.045.01a8.133 8.133 0 0 0-.358.094L7.7 2.06l-.113.032a7.91 7.91 0 0 0-.453.153c-.055.02-.055.02-.12.047l-.052.02a8.688 8.688 0 0 0-.312.132l-.044.02-.14.063c-.15.07-.286.14-.415.21l-.107.063-.054.03.03.068c.838 1.913 1.373 2.788 2.02 3.036.05.02.103.037.16.052a1.5 1.5 0 0 1-.138-.692zm2.53 2.89a1.454 1.454 0 0 0 .81.528 1.43 1.43 0 0 0-.687-.763l-.255.487.427-.35c.036.044.048.03.05.003.004-.03-.006-.078-.005-.07a3.205 3.205 0 0 0-.128-.63 1.92 1.92 0 0 0-.24-.495 1.477 1.477 0 0 0-.543-.462c-.384-.19-.68-.258-1.272-.344l-.03-.005a4.012 4.012 0 0 1-.517-.098 1.527 1.527 0 0 0 .75.756l.1.14.202.278.418-.07a1.253 1.253 0 0 0 .683.67c.06.156.142.298.24.424zm1.41-.637c.373-.283.637-.245 1.18.017l.16.076c.206.094.374.148.558.172.167.02.32.08.44.205.25.265.41.502.717 1.028l.065.11c.314.53.5.758.754.89.56.29.544.834.3 1.668a7.77 7.77 0 0 1-.13.402c-.045.13-.08.227-.153.415a13.4 13.4 0 0 0-.104.28l-.184.252c-.283.217-.5.46-.763.82l-.18.254c-.127.185-.185.266-.264.372-.24.322-.47.58-.752.82-.664.572-1.242.925-1.916 1.164a.695.695 0 0 1-.79-.213.687.687 0 0 1-.08-.81c.796-1.427 1.008-2.37.54-2.76-1.09-.9-1.51-2.247-1.03-3.423.052-.128-.01-.278-.167-.36l-.17-.14c-.133-.16-.138-.19-.195-.623a2.318 2.318 0 0 0-.085-.434.826.826 0 0 0-.1-.213.43.43 0 0 0-.118-.093c-.253-.125-.462-.174-.948-.244a5.132 5.132 0 0 1-.684-.13 2.873 2.873 0 0 1-.26-.086c-1.06-.406-1.65-1.372-2.637-3.624l-.222-.5-.197-.434.403-.257.114-.074c.11-.07.22-.135.33-.198l.046-.027.138-.08c.15-.08.306-.16.473-.24.086-.04.086-.04.166-.074l.042-.02c.114-.05.23-.1.35-.147l.036-.015.163-.064c.17-.06.34-.12.514-.172L7.4 1l.058-.016C7.596.944 7.73.91 7.86.88l.043-.01.143-.033c.192-.04.38-.075.566-.103l.075-.01.055-.007c.16-.02.32-.04.48-.052l.173-.013a9.256 9.256 0 0 1 1.132-.005l.108.008.046.003a9.417 9.417 0 0 1 1.073.14c.12.023.246.05.376.08l.04.01.1.023a9.376 9.376 0 0 1 .985.305l.132.052.055.022a9.206 9.206 0 0 1 .512.22c.106.05.106.05.205.1.082.04.082.04.157.08l1.06.553-1.11.445c-1.1.44-1.77.964-2.558 1.988a.282.282 0 0 0-.06.18l.08 2.78a.517.517 0 0 0 .173-.088zM10.59 5.08a.304.304 0 0 0-.112-.15c-.11-.07-.302-.065-.64.086l-.163.044-.09.01c-.57.064-.51.028-.522.275a.433.433 0 0 0 .208.376.33.33 0 0 0 .09.04l.308.075.036.122c.118-.012.23-.016.33-.013l.595.017-.064.593a.2.2 0 0 0 .02.107.15.15 0 0 0 .09.082l.058.018c.288.102.448.274.522.526l.003.01c.05.18.154.296.275.336a.313.313 0 0 0 .12.015L10.59 5.08zm1.184 1.8c.505-.276.956-.186 1.583.117.268.13.385.173.528.19.318.042.6.177.81.397.292.306.475.58.806 1.143.103.173.145.244.198.327.16.254.274.383.37.432.797.415.927 1.215.663 2.236-.06.228-.134.46-.236.737l-.112.295c-.072.19-.096.254-.12.33a.924.924 0 0 1-.33.445c-.3.22-.473.427-.85.968a7.912 7.912 0 0 1-.635.83c-.152.17-.312.328-.488.48-.728.624-1.365 1.01-2.116 1.28a1.347 1.347 0 0 1-1.484-.403 1.338 1.338 0 0 1-.148-1.523c.425-.762.643-1.327.69-1.702.026-.198.008-.255-.002-.264-1.22-1.01-1.728-2.5-1.313-3.862-.258-.213-.38-.51-.445-.9l-.027-.187a4.98 4.98 0 0 0-.047-.298c-.15-.06-.32-.095-.67-.146-.496-.072-.747-.124-1.08-.25-1.21-.465-1.862-1.435-2.862-3.68A8.246 8.246 0 0 0 1.732 10c0 4.558 3.71 8.268 8.268 8.268 4.558 0 8.268-3.71 8.268-8.268a8.264 8.264 0 0 0-3.576-6.802c-1.072.4-1.675.84-2.38 1.728.097.468.025.882-.252 1.2a1.164 1.164 0 0 1-.57.36c.12.113.214.245.284.394zm-1.75-.966l-.013.49.76.112c.15.022.29.03.425.02.005.05 0 .098-.01.143.018-.057.03-.1.037-.147a1.44 1.44 0 0 0 .267-.048 1.367 1.367 0 0 0-.253-.185.978.978 0 0 0-.224-.578c-.173-.21-.412-.33-.702-.382a.936.936 0 0 0-.005-.006l-.218-.2-.3-.276-.564.332a.38.38 0 0 1 .377-.007.185.185 0 0 1 .088.12l-.533-.092.155.53a5.16 5.16 0 0 1 .346-.044l.192-.022.17-.048.046-.02c.117-.056.192-.07.07-.147-.1-.067-.095-.053-.1.175l-.007.22.5-.112a.86.86 0 0 0-.216-.403l-.285.574zm1.205-.512c.03-.035.04-.137-.023-.354a.75.75 0 0 1 .128-.662c.938-1.22 1.76-1.806 3.252-2.32l.254-.09.226.146A9.37 9.37 0 0 1 19.37 10c0 5.167-4.203 9.37-9.37 9.37C4.833 19.37.63 15.167.63 10a9.358 9.358 0 0 1 3.7-7.454l.555-.422.283.636.174.392c.937 2.138 1.513 3.042 2.372 3.37.233.09.422.13.843.19.53.078.772.133 1.087.288a.913.913 0 0 1 .3.25c.16.237.208.43.264.852.01.08.01.08.022.153.03.176.055.23.085.245.337.18.563.55.394.966-.395.968-.058 2.095.893 2.88.667.554.53 1.637-.43 3.353-.05.09-.04.193.028.272a.244.244 0 0 0 .275.075c.615-.218 1.136-.535 1.765-1.076.138-.118.264-.242.384-.376.175-.196.295-.358.553-.727.428-.613.66-.892 1.06-1.193.024-.07.053-.148.115-.31.053-.14.078-.205.107-.286.09-.245.155-.445.204-.633.15-.58.103-.872-.106-.98-.312-.162-.537-.417-.793-.823-.06-.096-.106-.173-.214-.357-.29-.49-.44-.716-.653-.942-.027-.028-.077-.052-.152-.062-.292-.036-.5-.113-.837-.276-.422-.204-.536-.22-.72-.08-.226.17-.495.257-.802.157-.294-.098-.492-.347-.58-.652-.037-.128-.08-.177-.274-.237a.622.622 0 0 1-.37-.32.666.666 0 0 1-.05-.45 1.398 1.398 0 0 0-.13-.006l-.436-.007-.038-.172a.742.742 0 0 1-.478-.108.905.905 0 0 1-.438-.803c.004-.085.01-.152.02-.207l.058-.338L9 4.68c.11-.033.218-.047.533-.082l.103-.012c.428-.193.794-.252 1.102-.052.24.16.373.458.395.9.052-.004.08-.018.096-.034z',
    viewBox: '0 0 20 20',
  },

  GRID: {
    format: 'data',
    class: 'icon-grid',
    path: 'M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z',
    viewBox: '0 0 24 24',
  },

  HELP: {
    format: 'data',
    class: 'icon-help',
    path: 'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z',
    viewBox: '0 0 24 24',
  },

  HOME: {
    format: 'markup',
    class: 'icon-home',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </g>
    ),
  },

  IMPORT: {
    format: 'data',
    class: 'icon-import',
    path: 'M7.985 2.75c.692 0 1.262.538 1.265 1.208v8.084c0 .67-.57 1.208-1.265 1.208h-5.97c-.695 0-1.265-.538-1.265-1.208V3.958c0-.67.57-1.208 1.265-1.208h5.97zm.052 9.29V3.957c0-.017-.02-.038-.055-.038h-5.97c-.033 0-.055.02-.055.037v8.08c0 .02.022.04.055.04h5.97c.034 0 .055-.02.055-.04zM10.985.75c.695 0 1.265.538 1.265 1.208v8.084c0 .67-.57 1.208-1.265 1.208a.594.594 0 0 1-.605-.585c0-.328.273-.585.605-.585.033 0 .055-.02.055-.038V1.958c0-.017-.022-.038-.055-.038h-5.97c-.033 0-.055.02-.055.038a.594.594 0 0 1-.605.585.594.594 0 0 1-.605-.585c0-.67.57-1.208 1.265-1.208h5.97z',
    viewBox: '0 0 13 14',
  },

  INFO: {
    format: 'markup',
    class: 'icon-info',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
      </g>
    ),
  },

  INVITE: {
    format: 'data',
    class: 'icon-invite',
    path: 'M12.525 5.333c.437 0 .808.305.808.71 0 .402-.37.707-.808.707H11.5v1.025c0 .437-.305.808-.708.808-.404 0-.71-.37-.71-.808V6.75H9.06c-.437 0-.81-.305-.81-.708 0-.404.373-.71.81-.71h1.024V4.31c0-.437.305-.81.71-.81.402 0 .707.373.707.81v1.024h1.026zm-1.025 5.53v.578a.796.796 0 0 1-.784.81.796.796 0 0 1-.783-.81v-.576c0-.45-.373-.944-1.05-1.34-.818-.475-1.932-.74-3.133-.74s-2.315.265-3.132.74c-.678.396-1.05.89-1.05 1.34v.577a.796.796 0 0 1-.784.81.796.796 0 0 1-.784-.81v-.576c0-1.08.664-2.057 1.847-2.746 1.054-.615 2.44-.95 3.903-.95s2.85.335 3.903.95c1.183.69 1.847 1.665 1.847 2.746zM6.19 6.718a2.98 2.98 0 0 1-2.227-.558 2.982 2.982 0 0 1-1.18-1.97A3.003 3.003 0 0 1 6.19.783a2.98 2.98 0 0 1 1.68.847 2.98 2.98 0 0 1 .847 1.68A3.003 3.003 0 0 1 6.19 6.718zm-.23-1.553A1.43 1.43 0 0 0 7.164 3.54 1.42 1.42 0 0 0 5.54 2.336a1.43 1.43 0 0 0-.64 2.562c.307.227.683.322 1.06.266z',
    viewBox: '0 0 13 11',
  },

  LINK: {
    format: 'markup',
    class: 'icon-link',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" />
      </g>
    ),
  },

  LIST: {
    format: 'data',
    class: 'icon-list',
    path: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z',
    viewBox: '0 0 24 24',
  },

  LOCK: {
    format: 'data',
    class: 'icon-lock',
    path: 'M9.82 4.5h-.784V3.408C9.036 1.542 7.464.005 5.51 0 3.555-.005 1.964 1.512 1.964 3.375V4.5H1.18C.528 4.5 0 5.004 0 5.625v5.25C0 11.495.528 12 1.18 12h8.64c.65 0 1.18-.504 1.18-1.125v-5.25c0-.62-.53-1.125-1.18-1.125zM3.144 3.375c0-1.24 1.058-2.25 2.357-2.25 1.3 0 2.357 1.01 2.357 2.25V4.5H3.143V3.375zm6.678 7.5H1.18v-5.25h8.64v5.25z',
    viewBox: '0 0 11 12',
  },

  LOGO: {
    format: 'markup',
    class: 'icon-logo',
    viewBox: '0 0 113 28',
    markup: (
      <g fill="none" fillRule="evenodd">
        <path
          d="M42.248 16.112l-2.944-6.48-2.96 6.48h5.904zM38.92 8.72h.8L44.936 20h-.912L42.6 16.864h-6.608L34.568 20h-.864L38.92 8.72zm6.676 3.12h.912l3.088 7.28 3.12-7.28h.88l-3.664 8.224h-.672l-3.664-8.224zm16.132 3.696c-.032-.416-.115-.813-.248-1.192-.133-.38-.32-.715-.56-1.008-.24-.293-.536-.528-.888-.704-.352-.176-.763-.264-1.232-.264-.405 0-.784.08-1.136.24-.352.16-.66.38-.92.664-.26.283-.477.62-.648 1.008-.17.39-.272.808-.304 1.256h5.936zm-2.768 4.656c-.533 0-1.043-.1-1.528-.304-.485-.203-.912-.49-1.28-.864-.368-.373-.66-.82-.872-1.344-.213-.523-.32-1.104-.32-1.744v-.032c0-.597.1-1.155.296-1.672.197-.517.47-.968.816-1.352.347-.384.755-.685 1.224-.904.47-.22.98-.328 1.536-.328.576 0 1.093.11 1.552.328.46.22.85.52 1.176.904.325.384.576.835.752 1.352.176.517.264 1.08.264 1.688v.168c0 .037-.005.088-.016.152h-6.768c.032.512.144.965.336 1.36.192.395.432.73.72 1.008.288.277.62.488.992.632.373.144.757.216 1.152.216.64 0 1.18-.123 1.624-.368.443-.245.835-.55 1.176-.912l.544.48c-.203.224-.42.43-.656.616-.235.187-.488.35-.76.488-.272.14-.568.245-.888.32-.32.075-.677.112-1.072.112zm6.164-8.352h.784v2.32c.16-.363.363-.7.608-1.008.245-.31.523-.573.832-.792.31-.22.648-.387 1.016-.504.368-.117.755-.165 1.16-.144v.864h-.08c-.47 0-.917.088-1.344.264-.427.176-.803.435-1.128.776-.325.34-.584.768-.776 1.28-.192.512-.288 1.1-.288 1.76V20h-.784v-8.16zm10.74 3.216c.523 0 .997-.067 1.424-.2.427-.133.792-.32 1.096-.56.304-.24.54-.528.712-.864.17-.336.256-.712.256-1.128v-.032c0-.448-.083-.84-.248-1.176-.165-.336-.397-.616-.696-.84-.3-.224-.656-.395-1.072-.512-.416-.117-.875-.176-1.376-.176h-3.168v5.488h3.072zM71.96 8.8h4.064c.62 0 1.18.077 1.688.232.507.155.944.38 1.312.672.368.293.653.65.856 1.072.203.42.304.904.304 1.448v.032c0 .587-.117 1.104-.352 1.552-.235.448-.552.82-.952 1.12-.4.3-.864.523-1.392.672-.528.15-1.085.224-1.672.224h-3.024V20h-.832V8.8zM86.3 19.456c.48 0 .925-.093 1.336-.28.41-.187.763-.437 1.056-.752.293-.315.523-.685.688-1.112.165-.427.248-.88.248-1.36v-.032c0-.49-.085-.952-.256-1.384-.17-.432-.408-.808-.712-1.128-.304-.32-.66-.57-1.072-.752-.41-.18-.85-.272-1.32-.272-.48 0-.925.093-1.336.28-.41.187-.763.437-1.056.752-.293.315-.523.685-.688 1.112-.165.427-.248.88-.248 1.36v.032c0 .49.085.952.256 1.384.17.432.408.808.712 1.128.304.32.66.57 1.072.752.41.18.85.272 1.32.272zm-.032.736c-.608 0-1.165-.115-1.672-.344-.507-.23-.947-.536-1.32-.92-.373-.384-.664-.832-.872-1.344-.208-.512-.312-1.056-.312-1.632v-.032c0-.576.104-1.12.312-1.632.208-.512.5-.965.88-1.36.38-.395.824-.707 1.336-.936.512-.23 1.072-.344 1.68-.344.608 0 1.165.115 1.672.344.507.23.947.536 1.32.92.373.384.664.832.872 1.344.208.512.312 1.056.312 1.632v.032c0 .576-.104 1.12-.312 1.632-.208.512-.5.965-.88 1.36-.38.395-.824.707-1.336.936-.512.23-1.072.344-1.68.344zm6.996-8.352h.784V20h-.784v-8.16zm-.096-3.2h.976v1.072h-.976V8.64zm4.228 3.2h.784v1.52c.277-.48.65-.885 1.12-1.216.47-.33 1.077-.496 1.824-.496.512 0 .97.083 1.376.248.405.165.75.397 1.032.696.283.3.496.653.64 1.064.144.41.216.86.216 1.352V20h-.784v-4.848c0-.843-.224-1.517-.672-2.024-.448-.507-1.088-.76-1.92-.76-.395 0-.765.072-1.112.216-.347.144-.648.344-.904.6s-.456.563-.6.92c-.144.357-.216.75-.216 1.176V20h-.784v-8.16zm12.788 8.304c-.32 0-.62-.043-.896-.128-.277-.085-.52-.22-.728-.408-.208-.187-.37-.42-.488-.704-.117-.283-.176-.616-.176-1V12.56h-1.184v-.72h1.184V9.232h.784v2.608h2.864v.72h-2.864v5.264c0 .587.152.997.456 1.232.304.235.696.352 1.176.352.203 0 .395-.02.576-.064.18-.043.39-.117.624-.224v.736c-.213.096-.424.168-.632.216-.208.048-.44.072-.696.072z"
          fill="#000000"
          className="logo-averpoint-text"
        />
        <circle fill="#1286C8" cx="14" cy="14" r="14" className="logo-circle" />
        <path
          d="M14.44 7c-.085 0-.173.02-.253.067-.035.02-.067.044-.097.073-.038.037-.067.076-.09.118L7.004 19.374c-.138.24-.056.545.183.683.24.14.545.057.683-.183L14.437 8.5l6.567 11.374c.138.24.444.322.683.183.24-.138.32-.443.183-.683L14.875 7.258c-.02-.038-.047-.073-.078-.105-.034-.036-.07-.064-.11-.086-.08-.046-.167-.068-.254-.067z"
          fill="#FFFFFF"
          className="logo-circle-center"
        />
        <circle
          fill="#FFFFFF"
          cx="14.5"
          cy="15.5"
          r="1.5"
          className="logo-circle-center"
        />
      </g>
    ),
  },

  LOGO_NO_TEXT: {
    format: 'markup',
    class: 'icon-logo-no-text',
    viewBox: '0 0 100 100',
    markup: (
      <g
        id="White-symbol---blue-circle"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <circle id="Backgroud" fill="#1286C8" cx="50" cy="50" r="50" />
        <path
          d="M49.9992295,32.1365999 L26.3439035,73.1064978 C25.8504843,73.9610764 24.7577313,74.2538781 23.903129,73.7605001 C23.0486311,73.2671824 22.7558366,72.174562 23.2491543,71.3200642 C23.2491865,71.3200084 23.2492187,71.3199526 23.2492509,71.3198968 L49.1242148,26.5118908 C49.199303,26.3818596 49.2991849,26.2750716 49.41444,26.1940502 C49.7244426,25.9657535 50.1525221,25.9282095 50.5074247,26.1328 C50.659698,26.2205809 50.7861454,26.3469456 50.8740259,26.4991615 L76.7508002,71.319742 C77.2441866,72.1743257 76.9513824,73.2670712 76.0968021,73.7604634 C75.2422107,74.2538619 74.14945,73.9610874 73.6560079,73.1065212 L49.9992295,32.1365999 Z M49.3720998,62.7098037 C46.4117525,62.7098037 44.0119169,60.3116219 44.0119169,57.3533148 C44.0119169,54.3950077 46.4117525,51.996826 49.3720998,51.996826 C52.3324471,51.996826 54.7322827,54.3950077 54.7322827,57.3533148 C54.7322827,60.3116219 52.3324471,62.7098037 49.3720998,62.7098037 Z"
          id="Symbol"
          fill="#FFFFFF"
        />
      </g>
    ),
  },

  MORE: {
    format: 'data',
    class: 'icon-more',
    viewBox: '0 0 24 24',
    path: 'M12,8c1.1,0,2-0.9,2-2s-0.9-2-2-2s-2,0.9-2,2S10.9,8,12,8z M12,10c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S13.1,10,12,10z M12,16c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S13.1,16,12,16z',
  },

  NOTIFICATIONS: {
    format: 'data',
    class: 'icon-notifications',
    path: 'M19.192 13.427c-1.075 0-1.95-.852-1.95-1.9V7.053C17.242 3.164 13.992 0 10 0S2.758 3.164 2.758 7.052v4.476c0 1.047-.875 1.9-1.95 1.9a.798.798 0 0 0-.808.785c0 .435.362.787.808.787h18.384a.797.797 0 0 0 .808-.787.798.798 0 0 0-.808-.786zm-15.4 0a3.387 3.387 0 0 0 .58-1.9V7.053c0-3.02 2.525-5.48 5.628-5.48 3.102 0 5.627 2.46 5.627 5.48v4.476c0 .7.214 1.353.58 1.9H3.793zm8.788 4.702c.403.265.54.85.306 1.308-.51 1.002-1.438 1.562-2.39 1.562-.47 0-.946-.136-1.38-.423a2.98 2.98 0 0 1-1.002-1.14c-.234-.456-.097-1.042.306-1.308.402-.266.917-.11 1.15.347.094.184.23.337.39.444.513.34 1.172.14 1.47-.443.233-.457.748-.613 1.15-.348z',
    viewBox: '0 0 20 21',
  },

  PENCIL: {
    format: 'data',
    class: 'icon-pencil',
    path: 'M0 9.906v1.6a1 1 0 0 0 1 1h1.6l7.4-7.4-2.6-2.6-7.4 7.4zM12.3 1.83L10.675.207a.69.69 0 0 0-.983 0l-1.36 1.367 2.6 2.6L12.3 2.815a.69.69 0 0 0 0-.984z',
    viewBox: '0 0 12.5 12.5',
  },

  REFRESH: {
    format: 'data',
    class: 'icon-refresh',
    path: 'M11.504.496l-1.262 1.262A5.98 5.98 0 0 0 6 0C2.694 0-.002 2.698 0 6.004a6 6 0 0 0 10.02 4.45.29.29 0 0 0 .012-.422l-.477-.477a.29.29 0 0 0-.4-.014A4.725 4.725 0 0 1 6 10.74 4.74 4.74 0 0 1 1.258 6 4.74 4.74 0 0 1 6 1.258c1.31 0 2.496.53 3.354 1.388l-1.31 1.31a.29.29 0 0 0 .205.496h3.46c.16 0 .29-.13.29-.29V.7a.29.29 0 0 0-.496-.205z',
    viewBox: '0 0 12 12',
  },

  REJECTED: {
    format: 'markup',
    class: 'icon-rejected',
    markup: (
      <g>
        <circle cx="8" cy="8" r="7" strokeWidth="2" />
        <path d="M3 3L13 13" strokeWidth="2" />
      </g>
    ),
    viewBox: '0 0 16 16',
  },

  REMOVE: {
    format: 'data',
    class: 'icon-remove',
    path: 'M19 13H5v-2h14v2z',
    viewBox: '0 0 24 24',
  },

  RESPOND: {
    format: 'data',
    class: 'icon-share-respond',
    path: 'M17 12.26c0 .76-.307 1.794-.921 3.1a19.178 19.178 0 0 1-.174.372.767.767 0 0 1-.095.151c-.058.078-.125.117-.203.117a.217.217 0 0 1-.17-.069.248.248 0 0 1-.062-.172c0-.04.006-.102.018-.182a1.35 1.35 0 0 0 .018-.161c.024-.312.037-.594.037-.846 0-.463-.043-.878-.127-1.244a3.609 3.609 0 0 0-.352-.953 2.42 2.42 0 0 0-.58-.694 3.43 3.43 0 0 0-.766-.478 4.317 4.317 0 0 0-.965-.292 9.673 9.673 0 0 0-1.117-.148c-.375-.027-.8-.041-1.273-.041H8.643v1.76c0 .12-.046.222-.138.31a.459.459 0 0 1-.326.13.459.459 0 0 1-.327-.13L4.138 9.27A.412.412 0 0 1 4 8.96c0-.12.046-.222.138-.31l3.714-3.52c.092-.086.2-.13.327-.13.125 0 .234.044.326.13.092.088.138.19.138.31V7.2h1.625c3.448 0 5.564.924 6.348 2.77.256.615.384 1.378.384 2.29z',
    viewBox: '0 0 16 14',
  },
  REVIEW: {
    format: 'markup',
    class: 'icon-review',
    path: 'M14.533 1.984A12.107 12.107 0 0 0 11.5 1.6c-1.034 0-2.05.13-3.033.384.56.79.89 1.764.89 2.816 0 2.65-2.095 4.8-4.68 4.8S0 7.45 0 4.8 2.094 0 4.678 0c.902 0 1.744.262 2.458.715A13.6 13.6 0 0 1 11.5 0c1.5 0 2.97.244 4.364.715A4.57 4.57 0 0 1 18.322 0C20.906 0 23 2.15 23 4.8s-2.094 4.8-4.678 4.8-4.678-2.15-4.678-4.8c0-1.052.33-2.025.89-2.816zM4.678 8c1.722 0 3.12-1.433 3.12-3.2 0-1.767-1.398-3.2-3.12-3.2-1.722 0-3.12 1.433-3.12 3.2C1.56 6.567 2.957 8 4.68 8zm13.644 0c1.722 0 3.12-1.433 3.12-3.2 0-1.767-1.398-3.2-3.12-3.2-1.722 0-3.12 1.433-3.12 3.2 0 1.767 1.398 3.2 3.12 3.2z',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <circle cx="5.5" cy="15.5" r="4.5" strokeWidth="2" />
        <circle cx="18.5" cy="15.5" r="4.5" strokeWidth="2" />
        <path d="M9 13C11.5072 11.6461 12.8127 11.6874 15 13" strokeWidth="2" />
        <path
          d="M1.00012 15.5C1.00011 12.5 2.80569 8.74698 5.57793 5.45283C5.95047 5.22786 6.94743 4.84671 7.955 5.12189"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M22.9234 14.4043C21.8741 11.502 18.323 8.73847 14.3343 7.11766C13.8998 7.09242 12.8402 7.22028 12.0773 7.93365"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
    ),
  },
  SEARCH: {
    format: 'data',
    class: 'icon-search',
    path: 'M5.95 11.903A5.922 5.922 0 0 0 9.4 10.8l3.91 3.91a.978.978 0 0 0 1.385 0 .98.98 0 0 0 .017-1.4l-3.91-3.91a5.952 5.952 0 1 0-4.85 2.503zM1.4 5.95a4.552 4.552 0 1 1 9.104 0 4.552 4.552 0 0 1-9.104 0z',
    viewBox: '0 0 15 15',
  },

  SHARE: {
    format: 'data',
    class: 'icon-share',
    path: 'M6 3C6 1.76 7.01.75 8.25.75S10.5 1.76 10.5 3 9.49 5.25 8.25 5.25c-.66 0-1.274-.288-1.696-.773L4.256 5.98a2.238 2.238 0 0 1 .237 1.194l2.06 1.35A2.246 2.246 0 0 1 8.25 7.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25a2.252 2.252 0 0 1-2.243-2.424l-2.06-1.35a2.246 2.246 0 0 1-1.697.774C1.01 9.25 0 8.24 0 7a2.252 2.252 0 0 1 3.25-2.016.665.665 0 0 1 .066-.05l2.69-1.76A2.268 2.268 0 0 1 6 3zM3.094 7a.845.845 0 0 0-1.688 0c0 .465.38.844.844.844.336 0 .637-.2.75-.41a.75.75 0 0 1 .087-.326A.85.85 0 0 0 3.094 7zm4.312 3a.845.845 0 0 0 1.688 0 .845.845 0 0 0-.844-.844c-.336 0-.637.2-.75.41a.75.75 0 0 1-.087.327.85.85 0 0 0-.007.107zm.844-6.156a.845.845 0 0 0 0-1.688.845.845 0 0 0 0 1.688z',
    viewBox: '0 0 11 12',
  },

  SORT: {
    format: 'data',
    class: 'icon-sort',
    path: 'M.673 6.384h6.654c.598 0 .898.716.475 1.133l-3.327 3.288a.674.674 0 0 1-.948 0L.197 7.517c-.42-.417-.12-1.133.477-1.133zm7.13-2.9L4.473.193a.674.674 0 0 0-.947 0l-3.33 3.29c-.42.416-.12 1.132.478 1.132h6.654c.598 0 .898-.716.475-1.133z',
    viewBox: '0 0 8 11',
  },

  SUCCESS: {
    format: 'data',
    class: 'icon-success',
    viewBox: '0 0 60 58',
    path: 'M54.592 24.096c1.33 0 2.408 1.097 2.408 2.45v2.47c-.004 7.747-2.973 15.028-8.359 20.502C43.259 54.988 36.106 58 28.501 58h-.017c-7.613-.005-14.768-3.025-20.148-8.506C2.956 44.014-.004 36.73 0 28.984c.004-7.747 2.973-15.028 8.359-20.502C13.741 3.012 20.894 0 28.499 0h.017C32.533.002 36.43.847 40.1 2.51c1.214.551 1.76 2 1.22 3.236a2.391 2.391 0 0 1-3.18 1.24A23.193 23.193 0 0 0 28.514 4.9H28.5c-6.321 0-12.265 2.503-16.738 7.049-4.476 4.55-6.943 10.6-6.946 17.037-.008 13.289 10.61 24.106 23.67 24.114h.014c6.322 0 12.265-2.503 16.738-7.05 4.476-4.548 6.943-10.599 6.946-17.036v-2.468c0-1.353 1.078-2.45 2.408-2.45zm4.709-20.38c.932.953.932 2.5 0 3.454L30.839 36.285a2.353 2.353 0 0 1-3.377 0l-7.763-7.94a2.482 2.482 0 0 1 0-3.455 2.35 2.35 0 0 1 3.377 0l6.074 6.213L55.924 3.715a2.35 2.35 0 0 1 3.377 0z',
  },

  TRASH: {
    format: 'data',
    class: 'icon-trash',
    path: 'M10.646 2.52a.71.71 0 0 1 .708.714v.258a.457.457 0 0 1-.454.458h-.164l-.65 7.132a1.222 1.222 0 0 1-1.21 1.118H3.28a1.222 1.222 0 0 1-1.21-1.12l-.652-7.13h-.164A.457.457 0 0 1 .8 3.492v-.258a.71.71 0 0 1 .708-.715h1.798l.66-1.12c.22-.373.616-.6 1.045-.6h2.133c.43 0 .824.227 1.044.6l.66 1.12h1.8zm-5.69 0H7.2l-.17-.29H5.124l-.17.29zM9.31 3.95H2.84l.623 6.82H8.69l.62-6.82z',
    viewBox: '0 0 11 12',
  },

  TWITTER: {
    format: 'markup',
    class: 'icon-twitter',
    markup: (
      <g>
        <g clipPath="url(#clip0)">
          <path
            d="M24 4.56869C23.0558 4.97481 22.1114 5.22844 21.1676 5.33031C22.2336 4.69073 22.9546 3.78718 23.3303 2.6197C22.3552 3.19827 21.3148 3.59409 20.2083 3.80739C19.2336 2.77188 18.0358 2.25391 16.6142 2.25391C15.254 2.25391 14.0942 2.73353 13.1344 3.69298C12.1752 4.65238 11.6955 5.81217 11.6955 7.17252C11.6955 7.53794 11.736 7.91371 11.8173 8.29946C9.80708 8.19795 7.92135 7.69289 6.1598 6.78427C4.39835 5.87554 2.90343 4.66486 1.67504 3.15223C1.22833 3.91348 1.0049 4.74103 1.0049 5.6344C1.0049 6.47704 1.20284 7.25887 1.59898 7.97969C1.99486 8.7004 2.52798 9.28409 3.19807 9.73085C2.40605 9.70034 1.66496 9.49216 0.974708 9.10636V9.16727C0.974708 10.3552 1.34781 11.3981 2.09391 12.2969C2.84011 13.1955 3.78181 13.7612 4.91877 13.9948C4.49233 14.1063 4.06077 14.1622 3.6243 14.1622C3.34 14.1622 3.03032 14.1368 2.69535 14.0864C3.01005 15.071 3.58877 15.8804 4.43131 16.5152C5.274 17.1497 6.22834 17.4768 7.29436 17.4976C5.50763 18.8984 3.47212 19.5987 1.18785 19.5987C0.751219 19.5987 0.355394 19.5789 0 19.538C2.28433 21.0099 4.80206 21.7459 7.55337 21.7459C9.29957 21.7459 10.9392 21.4695 12.4717 20.9161C14.005 20.363 15.3145 19.6217 16.4009 18.6926C17.487 17.7637 18.4238 16.6952 19.2104 15.4871C19.9972 14.279 20.5833 13.0177 20.9694 11.703C21.355 10.388 21.548 9.07105 21.548 7.75103C21.548 7.46674 21.5429 7.25365 21.5327 7.11145C22.4974 6.41127 23.3197 5.5634 24 4.56869Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  USER: {
    format: 'markup',
    class: 'icon-user',
    markup: (
      <g>
        <circle
          cx="12"
          cy="7"
          r="4"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 21C4.82895 16.992 8.09599 14 12 14C15.904 14 19.1711 16.992 20 21"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },

  VERIFIED: {
    format: 'data',
    class: 'icon-verified',
    path: 'M11.34 1.11a.792.792 0 0 1 1.1-.23l.45.297c.368.237.47.732.23 1.098l-6.3 9.618a.79.79 0 0 1-1.097.226L1.11 9.097a.792.792 0 0 1-.23-1.1l.297-.45a.792.792 0 0 1 1.098-.23l3.495 2.29 5.57-8.497z',
    viewBox: '0 0 14 13',
  },

  STAR: {
    format: 'data',
    class: 'icon-star',
    path: 'M20 2L25.2262 12.8067L37.119 14.4377L28.4562 22.7476L30.5801 34.5623L20 28.8914L9.41987 34.5623L11.5438 22.7476L2.88098 14.4377L14.7738 12.8067L20 2Z',
    viewBox: '0 0 40 37',
  },

  CARDVIEW: {
    format: 'data',
    class: 'icon-cardview',
    path: 'M2 7V2H7V7H2ZM0 1C0 0.447715 0.447715 0 1 0H8C8.55229 0 9 0.447715 9 1V8C9 8.55229 8.55229 9 8 9H1C0.447715 9 0 8.55229 0 8V1ZM13 7V2H18V7H13ZM11 1C11 0.447715 11.4477 0 12 0H19C19.5523 0 20 0.447715 20 1V8C20 8.55229 19.5523 9 19 9H12C11.4477 9 11 8.55229 11 8V1ZM2 13V18H7V13H2ZM1 11C0.447715 11 0 11.4477 0 12V19C0 19.5523 0.447715 20 1 20H8C8.55229 20 9 19.5523 9 19V12C9 11.4477 8.55229 11 8 11H1ZM13 18V13H18V18H13ZM11 12C11 11.4477 11.4477 11 12 11H19C19.5523 11 20 11.4477 20 12V19C20 19.5523 19.5523 20 19 20H12C11.4477 20 11 19.5523 11 19V12Z',
    viewBox: '0 0 20 20',
  },

  LISTVIEW: {
    format: 'data',
    class: 'icon-cardview',
    path: 'M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447716 2 1 2H21C21.5523 2 22 1.55228 22 1C22 0.447715 21.5523 0 21 0H1ZM1 6C0.447715 6 0 6.44772 0 7C0 7.55228 0.447716 8 1 8H21C21.5523 8 22 7.55228 22 7C22 6.44772 21.5523 6 21 6H1ZM0 13C0 12.4477 0.447715 12 1 12H21C21.5523 12 22 12.4477 22 13C22 13.5523 21.5523 14 21 14H1C0.447716 14 0 13.5523 0 13ZM1 18C0.447715 18 0 18.4477 0 19C0 19.5523 0.447716 20 1 20H21C21.5523 20 22 19.5523 22 19C22 18.4477 21.5523 18 21 18H1Z',
    viewBox: '0 0 22 20',
  },

  ARROW_FORWARD_ROUND: {
    format: 'data',
    class: 'icon-arrow-forward-round',
    path: 'M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM9.29289 7.70711C8.90237 7.31658 8.90237 6.68342 9.29289 6.29289C9.68342 5.90237 10.3166 5.90237 10.7071 6.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L10.7071 17.7071C10.3166 18.0976 9.68342 18.0976 9.29289 17.7071C8.90237 17.3166 8.90237 16.6834 9.29289 16.2929L13.5858 12L9.29289 7.70711Z',
    viewBox: '0 0 24 24',
  },

  ARROW_BACKWARD_ROUND: {
    format: 'data',
    class: 'icon-arrow-backward-round',
    path: 'M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM13.7071 6.70711C14.0976 6.31658 14.0976 5.68342 13.7071 5.29289C13.3166 4.90237 12.6834 4.90237 12.2929 5.29289L7.29289 10.2929C6.90237 10.6834 6.90237 11.3166 7.29289 11.7071L12.2929 16.7071C12.6834 17.0976 13.3166 17.0976 13.7071 16.7071C14.0976 16.3166 14.0976 15.6834 13.7071 15.2929L9.41421 11L13.7071 6.70711Z',
    viewBox: '0  0 24 24',
  },
  ARROW_DOWN_ROUND: {
    format: 'markup',
    class: 'icon-arrow-down-round',
    markup: (
      <g>
        <circle cx="12" cy="12" r="12" className="fill" />
        <path
          d="M8 11L12 15L16 11"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0  0 24 24',
  },
  ARROW_RIGHT_ROUND: {
    format: 'markup',
    class: 'icon-arrow-right-round',
    markup: (
      <g>
        <circle cx="12" cy="12" r="12" transform="rotate(-90 12 12)" />
        <path
          d="M11 16L15 12L11 8"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0  0 24 24',
  },
  PROFILE: {
    format: 'data',
    class: 'icon-profile',
    path: 'M18 7L21 3H11.5C7.91015 3 5 5.91015 5 9.5V12M18 7H14C11.7909 7 10 8.79086 10 11V11C10 11.5523 9.55228 12 9 12H5M18 7V8.76393C18 8.91918 18.0361 9.07229 18.1056 9.21115L20 13H18V16C18 17.1046 17.1046 18 16 18H13V20C13 20.5523 12.5523 21 12 21H5V12',
    viewBox: '0 0 24 24',
  },
  ANALYTICS: {
    format: 'markup',
    class: 'icon-analytics',
    path: '',
    markup: (
      <g>
        <path
          d="M11 21C15.4183 21 19 17.4183 19 13H11V5C6.58172 5 3 8.58172 3 13C3 17.4183 6.58172 21 11 21Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 10C21 6.13401 17.866 3 14 3V10H21Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  ANNOUNCEMENTS: {
    format: 'markup',
    class: 'icon-announcements',
    markup: (
      <g>
        <path
          d="M12 16H5.5L5 20H2V16V6H12V11"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 6L17 2V20L12 16"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 14C20.8304 13.2671 21.3542 12.1947 21.3542 11C21.3542 9.80531 20.8304 8.73294 20 8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  CHEVRON_LEFT: {
    format: 'data',
    class: 'icon-chevron-left',
    path: 'M15 19L8 12L15 5',
    viewBox: '0 0 24 24',
  },
  CHEVRON_RIGHT: {
    format: 'data',
    class: 'icon-chevron-right',
    path: 'M9 19L16 12L9 5',
    viewBox: '0 0 24 24',
  },
  CHEVRON_DOWN: {
    format: 'data',
    class: 'icon-chevron-down',
    path: 'M5.5 9.5L12.5 16.5L19.5 9.5',
    viewBox: '0 0 24 24',
  },
  CHEVRON_UP: {
    format: 'data',
    class: 'icon-chevron-up',
    path: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z',
    viewBox: '0 0 24 24',
  },
  USERS: {
    format: 'data',
    class: 'icon-users',
    path: 'M16 8.5C17.1046 8.5 18 7.60457 18 6.5C18 5.39543 17.1046 4.5 16 4.5C14.8954 4.5 14 5.39543 14 6.5C14 7.60457 14.8954 8.5 16 8.5ZM16 10.5C18.2091 10.5 20 8.70914 20 6.5C20 4.29086 18.2091 2.5 16 2.5C13.7909 2.5 12 4.29086 12 6.5C12 8.70914 13.7909 10.5 16 10.5ZM8 12.5C9.10457 12.5 10 11.6046 10 10.5C10 9.39543 9.10457 8.5 8 8.5C6.89543 8.5 6 9.39543 6 10.5C6 11.6046 6.89543 12.5 8 12.5ZM8 14.5C10.2091 14.5 12 12.7091 12 10.5C12 8.29086 10.2091 6.5 8 6.5C5.79086 6.5 4 8.29086 4 10.5C4 12.7091 5.79086 14.5 8 14.5ZM18.9 10.7C18.4582 11.0314 18.3686 11.6582 18.7 12.1C18.9041 12.3721 19.2397 12.905 19.5209 13.5497C19.805 14.2015 20 14.8915 20 15.5C20 15.5172 19.9978 15.5273 19.9868 15.5466C19.9717 15.5728 19.9325 15.6258 19.8404 15.6972C19.6449 15.8488 19.3134 16.0051 18.8482 16.1391C17.9275 16.4042 16.7786 16.5 16 16.5C15.4477 16.5 15 16.9477 15 17.5C15 18.0523 15.4477 18.5 16 18.5C16.8881 18.5 18.2391 18.3958 19.4018 18.0609C19.9783 17.8949 20.5843 17.6512 21.0659 17.2778C21.5654 16.8904 22 16.3011 22 15.5C22 14.5085 21.695 13.5319 21.3541 12.7503C21.0103 11.9617 20.5959 11.2946 20.3 10.9C19.9686 10.4582 19.3418 10.3686 18.9 10.7ZM5.8 16.1C6.13137 15.6582 6.04183 15.0314 5.6 14.7C5.15817 14.3686 4.53137 14.4582 4.2 14.9C3.90407 15.2946 3.48973 15.9617 3.14585 16.7503C2.80505 17.5319 2.5 18.5085 2.5 19.5C2.5 20.3011 2.93457 20.8904 3.43411 21.2778C3.9157 21.6512 4.5217 21.8949 5.09825 22.0609C5.98755 22.317 6.98712 22.4382 7.8054 22.4811C7.86834 22.4935 7.93341 22.5 8 22.5C8.07977 22.5 8.16328 22.4991 8.25005 22.4974C8.33678 22.4991 8.42026 22.5 8.5 22.5C8.56658 22.5 8.63164 22.4935 8.69458 22.4811C9.51285 22.4382 10.5124 22.317 11.4018 22.0609C11.9783 21.8949 12.5843 21.6512 13.0659 21.2778C13.5654 20.8904 14 20.3011 14 19.5C14 18.5085 13.695 17.5319 13.3541 16.7503C13.0103 15.9617 12.5959 15.2946 12.3 14.9C11.9686 14.4582 11.3418 14.3686 10.9 14.7C10.4582 15.0314 10.3686 15.6582 10.7 16.1C10.9041 16.3721 11.2397 16.905 11.5209 17.5497C11.805 18.2014 12 18.8915 12 19.5C12 19.5171 11.9978 19.5273 11.9868 19.5466C11.9717 19.5728 11.9325 19.6258 11.8404 19.6972C11.6449 19.8488 11.3134 20.0051 10.8482 20.139C10.0218 20.3771 9.01137 20.4786 8.25004 20.4969C7.4887 20.4786 6.47828 20.3771 5.65175 20.139C5.18664 20.0051 4.85514 19.8488 4.65964 19.6972C4.56752 19.6258 4.52831 19.5728 4.51324 19.5466C4.50216 19.5273 4.5 19.5171 4.5 19.5C4.5 18.8914 4.69495 18.2014 4.97915 17.5497C5.26027 16.905 5.59593 16.3721 5.8 16.1Z',
    viewBox: '0 0 24 25',
  },
  TIMELINE: {
    format: 'data',
    class: 'icon-timeline',
    path: 'M2 7V2H7V7H2ZM0 1C0 0.447715 0.447715 0 1 0H8C8.55229 0 9 0.447715 9 1V8C9 8.55229 8.55229 9 8 9H1C0.447715 9 0 8.55229 0 8V1ZM11 1C11 0.447715 11.4477 0 12 0H21C21.5523 0 22 0.447715 22 1C22 1.55228 21.5523 2 21 2H12C11.4477 2 11 1.55228 11 1ZM11 7C11 6.44772 11.4477 6 12 6H21C21.5523 6 22 6.44772 22 7C22 7.55228 21.5523 8 21 8H12C11.4477 8 11 7.55228 11 7ZM11 13C11 12.4477 11.4477 12 12 12H21C21.5523 12 22 12.4477 22 13C22 13.5523 21.5523 14 21 14H12C11.4477 14 11 13.5523 11 13ZM12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20H21C21.5523 20 22 19.5523 22 19C22 18.4477 21.5523 18 21 18H12Z',
    viewBox: '0 0 22 20',
  },
  PLAY: {
    format: 'data',
    class: 'icon-play',
    path: 'M8 5V19L19 12L8 5Z',
    viewBox: '0 0 24 24',
  },
  PAUSE: {
    format: 'data',
    class: 'icon-play',
    path: 'M6 19H10V5H6V19ZM14 5V19H18V5H14Z',
    viewBox: '0 0 24 24',
  },
  VOLUME: {
    format: 'data',
    class: 'icon-volume',
    path: 'M3 9V15H7L12 20V4L7 9H3ZM16.5 12C16.5 10.23 15.48 8.71 14 7.97V16.02C15.48 15.29 16.5 13.77 16.5 12ZM14 3.23V5.29C16.89 6.15 19 8.83 19 12C19 15.17 16.89 17.85 14 18.71V20.77C18.01 19.86 21 16.28 21 12C21 7.72 18.01 4.14 14 3.23Z',
    viewBox: '0 0 24 24',
  },
  VOLUME_MUTE: {
    format: 'data',
    class: 'icon-volume',
    path: 'M16.5 12C16.5 10.23 15.48 8.71 14 7.97V10.18L16.45 12.63C16.48 12.43 16.5 12.22 16.5 12ZM19 12C19 12.94 18.8 13.82 18.46 14.64L19.97 16.15C20.63 14.91 21 13.5 21 12C21 7.72 18.01 4.14 14 3.23V5.29C16.89 6.15 19 8.83 19 12ZM4.27 3L3 4.27L7.73 9H3V15H7L12 20V13.27L16.25 17.52C15.58 18.04 14.83 18.45 14 18.7V20.76C15.38 20.45 16.63 19.81 17.69 18.95L19.73 21L21 19.73L12 10.73L4.27 3ZM12 4L9.91 6.09L12 8.18V4Z',
    viewBox: '0 0 24 24',
  },
  PLAYER_FULLSCREEN: {
    format: 'data',
    class: 'icon-player-fullscreen',
    path: 'M2 10H0V16H6V14H2V10ZM0 6H2V2H6V0H0V6ZM14 14H10V16H16V10H14V14ZM10 0V2H14V6H16V0H10Z',
    viewBox: '0 0 16 16',
  },
  MINUS: {
    format: 'data',
    class: 'icon-minus',
    path: 'M16 12L8 12',
    viewBox: '0 0 24 24',
  },
  MEDIA: {
    format: 'media',
    class: 'icon-media',
    markup: (
      <g>
        <rect
          x="4"
          y="4.5"
          width="16"
          height="16"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 15.5V9.5L15 12.5L10 15.5Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 25',
  },
  DRAG: {
    format: 'media',
    class: 'icon-drag',
    markup: (
      <g opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.5 8.5C5.32843 8.5 6 7.82843 6 7C6 6.17157 5.32843 5.5 4.5 5.5C3.67157 5.5 3 6.17157 3 7C3 7.82843 3.67157 8.5 4.5 8.5ZM4.5 13.5C5.32843 13.5 6 12.8284 6 12C6 11.1716 5.32843 10.5 4.5 10.5C3.67157 10.5 3 11.1716 3 12C3 12.8284 3.67157 13.5 4.5 13.5ZM6 17C6 17.8284 5.32843 18.5 4.5 18.5C3.67157 18.5 3 17.8284 3 17C3 16.1716 3.67157 15.5 4.5 15.5C5.32843 15.5 6 16.1716 6 17ZM9.5 8.5C10.3284 8.5 11 7.82843 11 7C11 6.17157 10.3284 5.5 9.5 5.5C8.67157 5.5 8 6.17157 8 7C8 7.82843 8.67157 8.5 9.5 8.5ZM11 12C11 12.8284 10.3284 13.5 9.5 13.5C8.67157 13.5 8 12.8284 8 12C8 11.1716 8.67157 10.5 9.5 10.5C10.3284 10.5 11 11.1716 11 12ZM9.5 18.5C10.3284 18.5 11 17.8284 11 17C11 16.1716 10.3284 15.5 9.5 15.5C8.67157 15.5 8 16.1716 8 17C8 17.8284 8.67157 18.5 9.5 18.5ZM16 7C16 7.82843 15.3284 8.5 14.5 8.5C13.6716 8.5 13 7.82843 13 7C13 6.17157 13.6716 5.5 14.5 5.5C15.3284 5.5 16 6.17157 16 7ZM14.5 13.5C15.3284 13.5 16 12.8284 16 12C16 11.1716 15.3284 10.5 14.5 10.5C13.6716 10.5 13 11.1716 13 12C13 12.8284 13.6716 13.5 14.5 13.5ZM16 17C16 17.8284 15.3284 18.5 14.5 18.5C13.6716 18.5 13 17.8284 13 17C13 16.1716 13.6716 15.5 14.5 15.5C15.3284 15.5 16 16.1716 16 17ZM19.5 8.5C20.3284 8.5 21 7.82843 21 7C21 6.17157 20.3284 5.5 19.5 5.5C18.6716 5.5 18 6.17157 18 7C18 7.82843 18.6716 8.5 19.5 8.5ZM21 12C21 12.8284 20.3284 13.5 19.5 13.5C18.6716 13.5 18 12.8284 18 12C18 11.1716 18.6716 10.5 19.5 10.5C20.3284 10.5 21 11.1716 21 12ZM19.5 18.5C20.3284 18.5 21 17.8284 21 17C21 16.1716 20.3284 15.5 19.5 15.5C18.6716 15.5 18 16.1716 18 17C18 17.8284 18.6716 18.5 19.5 18.5Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.5 8C5.32843 8 6 7.32843 6 6.5C6 5.67157 5.32843 5 4.5 5C3.67157 5 3 5.67157 3 6.5C3 7.32843 3.67157 8 4.5 8ZM4.5 13C5.32843 13 6 12.3284 6 11.5C6 10.6716 5.32843 10 4.5 10C3.67157 10 3 10.6716 3 11.5C3 12.3284 3.67157 13 4.5 13ZM6 16.5C6 17.3284 5.32843 18 4.5 18C3.67157 18 3 17.3284 3 16.5C3 15.6716 3.67157 15 4.5 15C5.32843 15 6 15.6716 6 16.5ZM9.5 8C10.3284 8 11 7.32843 11 6.5C11 5.67157 10.3284 5 9.5 5C8.67157 5 8 5.67157 8 6.5C8 7.32843 8.67157 8 9.5 8ZM11 11.5C11 12.3284 10.3284 13 9.5 13C8.67157 13 8 12.3284 8 11.5C8 10.6716 8.67157 10 9.5 10C10.3284 10 11 10.6716 11 11.5ZM9.5 18C10.3284 18 11 17.3284 11 16.5C11 15.6716 10.3284 15 9.5 15C8.67157 15 8 15.6716 8 16.5C8 17.3284 8.67157 18 9.5 18ZM16 6.5C16 7.32843 15.3284 8 14.5 8C13.6716 8 13 7.32843 13 6.5C13 5.67157 13.6716 5 14.5 5C15.3284 5 16 5.67157 16 6.5ZM14.5 13C15.3284 13 16 12.3284 16 11.5C16 10.6716 15.3284 10 14.5 10C13.6716 10 13 10.6716 13 11.5C13 12.3284 13.6716 13 14.5 13ZM16 16.5C16 17.3284 15.3284 18 14.5 18C13.6716 18 13 17.3284 13 16.5C13 15.6716 13.6716 15 14.5 15C15.3284 15 16 15.6716 16 16.5ZM19.5 8C20.3284 8 21 7.32843 21 6.5C21 5.67157 20.3284 5 19.5 5C18.6716 5 18 5.67157 18 6.5C18 7.32843 18.6716 8 19.5 8ZM21 11.5C21 12.3284 20.3284 13 19.5 13C18.6716 13 18 12.3284 18 11.5C18 10.6716 18.6716 10 19.5 10C20.3284 10 21 10.6716 21 11.5ZM19.5 18C20.3284 18 21 17.3284 21 16.5C21 15.6716 20.3284 15 19.5 15C18.6716 15 18 15.6716 18 16.5C18 17.3284 18.6716 18 19.5 18Z"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  ELLIPSE: {
    format: 'data',
    class: 'icon-ellipse',
    path: 'M16 8C16 12.4183 9 24 8 24C7 24 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z',
    viewBox: '0 0 16 24',
  },
  CHECK: {
    format: 'data',
    class: 'icon-check',
    path: 'M1 6.03906L5 10.0391L14 1.03906',
    viewBox: '0 0 15 12',
  },
  POINT: {
    format: 'media',
    class: 'icon-point',
    markup: (
      <g>
        <path
          d="M4 5.5H20V16.5H9L4 21V5.5Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 11.5H11"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 11.5H15"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 25',
  },
  USER_PLUS: {
    format: 'media',
    class: 'icon-user-plus',
    markup: (
      <g>
        <path
          d="M16 2.41407C15.0463 2.14433 14.04 2 13 2C6.92487 2 2 6.92487 2 13C2 19.0751 6.92487 24 13 24C19.0751 24 24 19.0751 24 13C24 11.96 23.8557 10.9537 23.5859 10"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path d="M21 2V8" strokeWidth="2" strokeLinecap="round" />
        <path d="M24 5H18" strokeWidth="2" strokeLinecap="round" />
        <circle
          cx="13"
          cy="10"
          r="3"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.60156 18.628C8.91712 17.017 10.8472 16 12.9984 16C15.092 16 16.9762 16.9633 18.2883 18.5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 26 26',
  },
  PICTURE: {
    format: 'media',
    class: 'icon-picture',
    markup: (
      <g>
        <rect
          x="4"
          y="4.5"
          width="16"
          height="16"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="8.5" cy="9" r="1.5" />
        <path
          d="M4 19.5L10.0952 13.5465L12.1905 15.593L16.381 11.5L20 15.0349"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 25',
  },
  SETTINGS: {
    format: 'media',
    class: 'icon-settings',
    markup: (
      <g>
        <circle cx="12" cy="12" r="3" strokeWidth="2" />
        <path
          d="M3.68222 9.67784H3.68233H4.25871C4.41562 9.15508 4.62542 8.64963 4.88502 8.16893L4.4768 7.76071C4.47666 7.76057 4.47652 7.76043 4.47638 7.76029C3.80668 7.09092 3.83258 6.02507 4.47664 5.38135C4.47674 5.38124 4.47685 5.38114 4.47696 5.38103C4.47699 5.381 4.47702 5.38097 4.47705 5.38094L5.38109 4.47694C5.38125 4.47678 5.3814 4.47662 5.38156 4.47647C5.3816 4.47642 5.38165 4.47638 5.38169 4.47633C6.02951 3.82809 7.09561 3.81089 7.76098 4.47705M3.68222 9.67784L18.6187 4.47671L18.6191 4.4771C17.9738 3.83108 16.9077 3.80817 16.2397 4.47649C16.2396 4.47664 16.2394 4.47679 16.2393 4.47694L15.8311 4.88512C15.3504 4.62552 14.845 4.41568 14.3222 4.25875V3.68229C14.3222 2.75372 13.5683 2 12.6399 2H11.3602C10.4318 2 9.6779 2.75372 9.6779 3.68229V4.25867C9.15512 4.4156 8.64966 4.62544 8.16894 4.88504L7.76098 4.47705M3.68222 9.67784C2.7539 9.67793 2 10.4316 2 11.3602M3.68222 9.67784L2 11.3602M7.76098 4.47705L7.05346 5.18373M7.76098 4.47705L7.76059 4.47665L7.05346 5.18373M7.05346 5.18373L7.6782 5.80852L5.80851 7.67821L5.18349 7.05319C4.91285 6.78287 4.92162 6.35027 5.18373 6.08847L6.08879 5.18346C6.3515 4.92031 6.78409 4.91405 7.05346 5.18373ZM8.16885 19.1149L7.76071 19.5231C7.76056 19.5232 7.76042 19.5234 7.76027 19.5235C7.09248 20.1917 6.0266 20.169 5.38132 19.5233C5.38122 19.5232 5.38113 19.5231 5.38103 19.523C5.38097 19.523 5.3809 19.5229 5.38084 19.5228L4.47677 18.6188L4.47634 18.6184L5.18345 17.9112L8.16885 19.1149ZM8.16885 19.1149C8.64959 19.3745 9.15506 19.5844 9.67786 19.7413V20.3177C9.67786 21.2463 10.4318 22 11.3602 22H12.6398C13.5682 22 14.3221 21.2463 14.3221 20.3177V19.7413C14.8449 19.5844 15.3504 19.3746 15.8311 19.115L16.2391 19.523C16.2392 19.5231 16.2393 19.5232 16.2395 19.5233C16.9049 20.1892 17.9707 20.1717 18.6183 19.5237C18.6185 19.5235 18.6187 19.5233 18.6189 19.5231L19.523 18.6191L8.16885 19.1149ZM19.5232 16.2392C20.1934 16.9086 20.1676 17.9748 19.5234 18.6186L19.5232 16.2392ZM19.5232 16.2392L19.115 15.8311C19.3746 15.3504 19.5844 14.8449 19.7413 14.3222H20.3177C21.2461 14.3222 22 13.5684 22 12.6399V11.3602C22 10.4316 21.2461 9.67792 20.3177 9.67792H19.7413C19.5844 9.15513 19.3746 8.64969 19.115 8.16901L19.523 7.76103L19.5234 7.76061L19.5232 16.2392ZM19.5235 5.38149C19.5235 5.38156 19.5236 5.38162 19.5237 5.38169L19.5235 5.38149ZM19.5235 5.38149C19.5234 5.38141 19.5233 5.38133 19.5232 5.38126M19.5235 5.38149L19.5232 5.38126M19.5232 5.38126L18.6192 4.47719L19.5232 5.38126ZM2 11.3602V12.6398M2 11.3602V12.6398M2 12.6398C2 13.5684 2.75391 14.3221 3.68233 14.3221M2 12.6398L3.68233 14.3221M3.68233 14.3221H4.25867M3.68233 14.3221H4.25867M4.25867 14.3221C4.4156 14.8449 4.62542 15.3503 4.88499 15.831L4.477 16.239C4.47686 16.2392 4.47672 16.2393 4.47658 16.2394L4.25867 14.3221ZM15.6148 5.10152C15.6148 5.10144 15.6149 5.10136 15.615 5.10128L15.6148 5.10152ZM14.0201 19.8256C14.0208 19.8254 14.0215 19.8252 14.0222 19.8251C14.0215 19.8252 14.0208 19.8254 14.0201 19.8256L14.0201 19.8256ZM9.97995 19.8256C9.97924 19.8254 9.97853 19.8253 9.97783 19.8251C9.97851 19.8252 9.97919 19.8254 9.97988 19.8256L9.97995 19.8256Z"
          strokeWidth="2"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  CLASSIFY: {
    format: 'media',
    class: 'icon-classify',
    markup: (
      <g>
        <path
          d="M4 4H20V17H9L4 21.5V4Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 11V7"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="14" r="1" />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  INVITE_USER: {
    format: 'media',
    class: 'icon-classify',
    markup: (
      <g>
        <path
          d="M14 3.22302C13.3568 3.07706 12.6874 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.3126 20.9229 10.6432 20.777 10"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M8.5 14.5707C9.40188 15.4548 10.6373 16 12 16C13.3627 16 14.5981 15.4548 15.5 14.5707"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 10.5C7 9.68181 7.6667 9 8.49018 9C9.31378 9 10 9.68181 10 10.5C10 11.2987 9.3333 12 8.49018 12C7.64707 12 7 11.2987 7 10.5ZM14 10.5C14 9.68181 14.6667 9 15.4902 9C16.3138 9 17 9.68181 17 10.5C17 11.2987 16.3333 12 15.4902 12C14.6471 12 14 11.2987 14 10.5Z"
          fill="#1286C8"
        />
        <path d="M20 1V7" strokeWidth="2" strokeLinecap="round" />
        <path d="M23 4H17" strokeWidth="2" strokeLinecap="round" />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  CTA: {
    format: 'media',
    class: 'icon-cta',
    markup: (
      <g>
        <path
          d="M20 12V4H4V20H12"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M19.6033 14.3775L12.0674 11.4187C11.6611 11.2591 11.2597 11.6605 11.4193 12.0668L14.3781 19.6027C14.5098 19.9381 14.9423 20.0283 15.1971 19.7735L16.7785 18.1921L18.5462 19.9599C18.7415 20.1551 19.0581 20.1551 19.2533 19.9599L19.9605 19.2527C20.1557 19.0575 20.1557 18.7409 19.9605 18.5456L18.1927 16.7779L19.7741 15.1965C20.0289 14.9417 19.9387 14.5092 19.6033 14.3775Z" />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  REMOVE_FROM_COLLECTION: {
    format: 'media',
    class: 'icon-remove-from-collection',
    markup: (
      <g>
        <path
          d="M8 11.5V8H17V21H8V18.5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 5V3H22V16H20"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 15H8C5.79086 15 4 13.2091 4 11V3M4 3L2 5M4 3L6 5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  DELETE: {
    format: 'media',
    class: 'icon-delete',
    markup: (
      <g>
        <rect
          x="5"
          y="6"
          width="14"
          height="16"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="8"
          y="2"
          width="8"
          height="4"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 6L22 6"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 10L10 18"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 10V18"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  FOLLOW: {
    format: 'media',
    class: 'icon-follow',
    markup: (
      <g>
        <circle
          cx="11"
          cy="7"
          r="4"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 21C3.82895 16.992 7.09599 14 11 14C12.2153 14 13.3689 14.29 14.4065 14.8103"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 18L15 21L22 14"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  GROUP: {
    format: 'media',
    class: 'icon-group',
    markup: (
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 8C17.1046 8 18 7.10457 18 6C18 4.89543 17.1046 4 16 4C14.8954 4 14 4.89543 14 6C14 7.10457 14.8954 8 16 8ZM16 10C18.2091 10 20 8.20914 20 6C20 3.79086 18.2091 2 16 2C13.7909 2 12 3.79086 12 6C12 8.20914 13.7909 10 16 10ZM8 12C9.10457 12 10 11.1046 10 10C10 8.89543 9.10457 8 8 8C6.89543 8 6 8.89543 6 10C6 11.1046 6.89543 12 8 12ZM8 14C10.2091 14 12 12.2091 12 10C12 7.79086 10.2091 6 8 6C5.79086 6 4 7.79086 4 10C4 12.2091 5.79086 14 8 14ZM18.9 10.2C18.4582 10.5314 18.3686 11.1582 18.7 11.6C18.9041 11.8721 19.2397 12.405 19.5209 13.0497C19.805 13.7015 20 14.3915 20 15C20 15.0172 19.9978 15.0273 19.9868 15.0466C19.9717 15.0728 19.9325 15.1258 19.8404 15.1972C19.6449 15.3488 19.3134 15.5051 18.8482 15.6391C17.9275 15.9042 16.7786 16 16 16C15.4477 16 15 16.4477 15 17C15 17.5523 15.4477 18 16 18C16.8881 18 18.2391 17.8958 19.4018 17.5609C19.9783 17.3949 20.5843 17.1512 21.0659 16.7778C21.5654 16.3904 22 15.8011 22 15C22 14.0085 21.695 13.0319 21.3541 12.2503C21.0103 11.4617 20.5959 10.7946 20.3 10.4C19.9686 9.95817 19.3418 9.86863 18.9 10.2ZM5.8 15.6C6.13137 15.1582 6.04183 14.5314 5.6 14.2C5.15817 13.8686 4.53137 13.9582 4.2 14.4C3.90407 14.7946 3.48973 15.4617 3.14585 16.2503C2.80505 17.0319 2.5 18.0085 2.5 19C2.5 19.8011 2.93457 20.3904 3.43411 20.7778C3.9157 21.1512 4.5217 21.3949 5.09825 21.5609C5.98755 21.817 6.98712 21.9382 7.8054 21.9811C7.86834 21.9935 7.93341 22 8 22C8.07977 22 8.16328 21.9991 8.25005 21.9974C8.33678 21.9991 8.42026 22 8.5 22C8.56658 22 8.63164 21.9935 8.69458 21.9811C9.51285 21.9382 10.5124 21.817 11.4018 21.5609C11.9783 21.3949 12.5843 21.1512 13.0659 20.7778C13.5654 20.3904 14 19.8011 14 19C14 18.0085 13.695 17.0319 13.3541 16.2503C13.0103 15.4617 12.5959 14.7946 12.3 14.4C11.9686 13.9582 11.3418 13.8686 10.9 14.2C10.4582 14.5314 10.3686 15.1582 10.7 15.6C10.9041 15.8721 11.2397 16.405 11.5209 17.0497C11.805 17.7014 12 18.3915 12 19C12 19.0171 11.9978 19.0273 11.9868 19.0466C11.9717 19.0728 11.9325 19.1258 11.8404 19.1972C11.6449 19.3488 11.3134 19.5051 10.8482 19.639C10.0218 19.8771 9.01137 19.9786 8.25004 19.9969C7.4887 19.9786 6.47828 19.8771 5.65175 19.639C5.18664 19.5051 4.85514 19.3488 4.65964 19.1972C4.56752 19.1258 4.52831 19.0728 4.51324 19.0466C4.50216 19.0273 4.5 19.0171 4.5 19C4.5 18.3914 4.69495 17.7014 4.97915 17.0497C5.26027 16.405 5.59593 15.8721 5.8 15.6Z"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  USER_EDITED: {
    format: 'media',
    class: 'icon-user-edited',
    markup: (
      <g>
        <circle
          cx="11"
          cy="7"
          r="4"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 21C3.82895 16.992 7.09599 14 11 14C11.6172 14 12.2184 14.0748 12.7967 14.2165"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 21L12 22L13 19L18 14L20 12L22 14L20 16L15 21Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  DROPDOWN_RIGHT: {
    format: 'data',
    class: 'icon-dropdown-right',
    path: 'M15 12L10 16V8L15 12Z',
    viewBox: '0 0 24 24',
  },
  DROPDOWN_UP: {
    format: 'data',
    class: 'icon-dropdown-up',
    path: 'M12 9L16 14H8L12 9Z',
    viewBox: '0 0 24 24',
  },
  DROPDOWN_DOWN: {
    format: 'data',
    class: 'icon-dropdown-down',
    path: 'M12 15L8 10H16L12 15Z',
    viewBox: '0 0 24 24',
  },
  CAPTURE_AREA: {
    format: 'media',
    class: 'icon-capture-area',
    markup: (
      <g>
        <path
          d="M4 7V4M4 4H7M4 4V1M4 4H1"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M20 23V20M20 20H23M20 20V17M20 20H17"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M4 10.5V20H13.5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="2 3"
        />
        <path
          d="M20 13.5L20 4L10.5 4"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="2 3"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  UPLOAD_PICTURE: {
    format: 'media',
    class: 'icon-upload-picture',
    markup: (
      <g>
        <path
          d="M21 9V3H3V19H16"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="8.5" cy="7.5" r="1.5" />
        <path
          d="M4 18L10.0952 12.0465L12.1905 14.093L16.381 10L21 9"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M20 21V13M20 13L17.5 15.5M20 13L22.5 15.5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  SOURCE: {
    format: 'media',
    class: 'icon-source',
    markup: (
      <g>
        <path d="M8 11H11V17L8 14V11Z" className="fill" />
        <path d="M12 11H15V17L12 14V11Z" className="fill" />
        <path
          d="M18 12H28"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 16H28"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 20H28"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 24H28"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 36 36',
  },
  TAGS: {
    format: 'media',
    class: 'icon-tags',
    markup: (
      <g>
        <path
          d="M24 10L7 10L7 26L24 26L29 18L24 10Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9585 15.9785H16.9585"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9585 19.9785H18.9585"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="23.4585" cy="18" r="1.5" className="fill" />
      </g>
    ),
    viewBox: '0 0 36 36',
  },
  ATTACH_PIC: {
    format: 'media',
    class: 'icon-attach-pic',
    markup: (
      <g>
        <rect
          x="8"
          y="10"
          width="20"
          height="16"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="13" cy="15" r="2" className="fill" />
        <path
          d="M8 24L15.619 18.7907L18.2381 20.5814L23.4762 17L28 20.093"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 36 36',
  },
  SAVE: {
    format: 'media',
    class: 'icon-save',
    markup: (
      <g>
        <circle cx="12" cy="12" r="9" strokeWidth="2" />
        <path
          d="M18 12C18 11.5667 17.9541 11.1442 17.8668 10.737M12 18C10.1453 18 8.48712 17.1584 7.38652 15.8364M6 12C6 12.5179 6.06563 13.0206 6.18903 13.5M12 6C14.0075 6 15.7848 6.98593 16.874 8.5"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <circle cx="12" cy="12" r="2.25" strokeWidth="1.5" />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  SAVE_1: {
    format: 'media',
    class: 'icon-save-1',
    markup: (
      <g>
        <path d="M8.71 7.7099L11 5.4099V14.9999C11 15.2651 11.1054 15.5195 11.2929 15.707C11.4804 15.8945 11.7348 15.9999 12 15.9999C12.2652 15.9999 12.5196 15.8945 12.7071 15.707C12.8946 15.5195 13 15.2651 13 14.9999V5.4099L15.29 7.7099C15.383 7.80363 15.4936 7.87802 15.6154 7.92879C15.7373 7.97956 15.868 8.00569 16 8.00569C16.132 8.00569 16.2627 7.97956 16.3846 7.92879C16.5064 7.87802 16.617 7.80363 16.71 7.7099C16.8037 7.61693 16.8781 7.50633 16.9289 7.38447C16.9797 7.26261 17.0058 7.13191 17.0058 6.9999C17.0058 6.86788 16.9797 6.73718 16.9289 6.61532C16.8781 6.49346 16.8037 6.38286 16.71 6.2899L12.71 2.2899C12.6149 2.19886 12.5028 2.12749 12.38 2.0799C12.1365 1.97988 11.8635 1.97988 11.62 2.0799C11.4972 2.12749 11.3851 2.19886 11.29 2.2899L7.29 6.2899C7.19676 6.38313 7.1228 6.49383 7.07234 6.61565C7.02188 6.73747 6.99591 6.86804 6.99591 6.9999C6.99591 7.13176 7.02188 7.26232 7.07234 7.38415C7.1228 7.50597 7.19676 7.61666 7.29 7.7099C7.38324 7.80313 7.49393 7.8771 7.61575 7.92756C7.73757 7.97802 7.86814 8.00399 8 8.00399C8.13186 8.00399 8.26243 7.97802 8.38425 7.92756C8.50607 7.8771 8.61676 7.80313 8.71 7.7099ZM21 11.9999C20.7348 11.9999 20.4804 12.1053 20.2929 12.2928C20.1054 12.4803 20 12.7347 20 12.9999V18.9999C20 19.2651 19.8946 19.5195 19.7071 19.707C19.5196 19.8945 19.2652 19.9999 19 19.9999H5C4.73478 19.9999 4.48043 19.8945 4.29289 19.707C4.10536 19.5195 4 19.2651 4 18.9999V12.9999C4 12.7347 3.89464 12.4803 3.70711 12.2928C3.51957 12.1053 3.26522 11.9999 3 11.9999C2.73478 11.9999 2.48043 12.1053 2.29289 12.2928C2.10536 12.4803 2 12.7347 2 12.9999V18.9999C2 19.7955 2.31607 20.5586 2.87868 21.1212C3.44129 21.6838 4.20435 21.9999 5 21.9999H19C19.7956 21.9999 20.5587 21.6838 21.1213 21.1212C21.6839 20.5586 22 19.7955 22 18.9999V12.9999C22 12.7347 21.8946 12.4803 21.7071 12.2928C21.5196 12.1053 21.2652 11.9999 21 11.9999Z" />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  TIMECODES: {
    format: 'media',
    class: 'icon-timecodes',
    markup: (
      <g>
        <circle cx="12" cy="12" r="8" strokeWidth="2" />
        <path
          d="M9 15L12 12V7"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  // LEFT: {
  //   format: 'media',
  //   class: 'icon-left',
  //   markup: (
  //     <g>
  //       <path
  //         fillRule="evenodd"
  //         clipRule="evenodd"
  //         d="M12.5 23C18.5751 23 23.5 18.0751 23.5 12C23.5 5.92487 18.5751 1 12.5 1C6.42487 1 1.5 5.92487 1.5 12C1.5 18.0751 6.42487 23 12.5 23ZM15.2071 7.70711C15.5976 7.31658 15.5976 6.68342 15.2071 6.29289C14.8166 5.90237 14.1834 5.90237 13.7929 6.29289L8.79289 11.2929C8.40237 11.6834 8.40237 12.3166 8.79289 12.7071L13.7929 17.7071C14.1834 18.0976 14.8166 18.0976 15.2071 17.7071C15.5976 17.3166 15.5976 16.6834 15.2071 16.2929L10.9142 12L15.2071 7.70711Z"
  //       />
  //     </g>
  //   ),
  //   viewBox: '0 0 25 24',
  // },
  // RIGHT: {
  //   format: 'media',
  //   class: 'icon-right',
  //   markup: (
  //     <g>
  //       <path
  //         fillRule="evenodd"
  //         clipRule="evenodd"
  //         d="M12.5 23C6.42487 23 1.5 18.0751 1.5 12C1.5 5.92487 6.42487 1 12.5 1C18.5751 1 23.5 5.92487 23.5 12C23.5 18.0751 18.5751 23 12.5 23ZM9.79289 7.70711C9.40237 7.31658 9.40237 6.68342 9.79289 6.29289C10.1834 5.90237 10.8166 5.90237 11.2071 6.29289L16.2071 11.2929C16.5976 11.6834 16.5976 12.3166 16.2071 12.7071L11.2071 17.7071C10.8166 18.0976 10.1834 18.0976 9.79289 17.7071C9.40237 17.3166 9.40237 16.6834 9.79289 16.2929L14.0858 12L9.79289 7.70711Z"
  //       />
  //     </g>
  //   ),
  //   viewBox: '0 0 25 24',
  // },
  PREVIEW: {
    format: 'media',
    class: 'icon-preview',
    markup: (
      <g>
        <path
          d="M22 12C22 13 17.5228 18 12 18C6.47715 18 2 13 2 12C2 11 6.47715 6 12 6C17.5228 6 22 11 22 12Z"
          strokeWidth="2"
        />
        <circle cx="12" cy="12" r="3" strokeWidth="2" />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  EXPORT: {
    format: 'media',
    class: 'icon-export',
    markup: (
      <g>
        <path
          d="M11 4L4 4L4 20L20 20L20 13"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 4H20M20 4V9M20 4L12 12"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  SEND: {
    format: 'media',
    class: 'icon-send',
    markup: (
      <g>
        <path d="M2.95087 2.88696L21.9986 11.545C22.3894 11.7227 22.3894 12.2778 21.9986 12.4554L2.93222 21.1219C2.16232 21.4719 1.33262 20.7675 1.55295 19.951L3.24496 13.6806C3.35507 13.2726 3.70982 12.9778 4.13113 12.9443L16 12.0002L4.19671 11.0559C3.77827 11.0225 3.42528 10.7312 3.31293 10.3268L1.57355 4.06497C1.34627 3.24678 2.17782 2.53557 2.95087 2.88696Z" />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  UP: {
    format: 'media',
    class: 'icon-up',
    markup: (
      <g>
        <path d="M3.5 10.5V1.5M3.5 1.5L0.5 4.5M3.5 1.5L6.5 4.5" />
      </g>
    ),
    viewBox: '0 0 7 11',
  },
  DOWN: {
    format: 'media',
    class: 'icon-up',
    markup: (
      <g>
        <path d="M3.5 0.5V9.5M3.5 9.5L0.5 6.5M3.5 9.5L6.5 6.5" />
      </g>
    ),
    viewBox: '0 0 7 11',
  },
  RIGHT: {
    format: 'media',
    class: 'icon-right',
    markup: (
      <g>
        <path d="M0.5 3.5L9.5 3.5M9.5 3.5L6.5 0.5M9.5 3.5L6.5 6.5" />
      </g>
    ),
    viewBox: '0 0 11 7',
  },
  LEFT: {
    format: 'media',
    class: 'icon-left',
    markup: (
      <g>
        <path d="M10.5 3.5L1.5 3.5M1.5 3.5L4.5 0.5M1.5 3.5L4.5 6.5" />
      </g>
    ),
    viewBox: '0 0 11 7',
  },

  EVIDENCE: {
    format: 'media',
    class: 'icon-evidence',
    markup: (
      <g>
        <path
          d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 14C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13C11 13.5523 11.4477 14 12 14Z"
          className="fill"
        />
        <path
          d="M7 15L12 7L17 15"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  TAB_SWITCH: {
    format: 'media',
    class: 'icon-tab-switch',
    markup: (
      <g>
        <path d="M1 0V10" />
        <path d="M8 1L4 5M4 5L8 9M4 5H19" />
        <path d="M19 9V19" />
        <path d="M12 10L16 14M16 14L12 18M16 14H1" />
      </g>
    ),
    viewBox: '0 0 20 19',
  },
  LOGIN: {
    format: 'media',
    class: 'icon-login',
    markup: (
      <g>
        <path
          d="M5 16L5 20L19 20L19 4L5 4L5 8"
          stroke="#1286C8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.121 8.46425L14.6565 11.9998M14.6565 11.9998L11.121 15.5353M14.6565 11.9998L4.99967 11.9998"
          stroke="#1286C8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  ARTICLE: {
    format: 'media',
    class: 'icon-article',
    markup: (
      <g>
        <rect
          x="0.666667"
          y="0.666667"
          width="14.6667"
          height="14.6667"
          rx="2"
          fill="#F3ECFF"
          stroke="#7E57C2"
          strokeWidth="1.33333"
        />
        <path d="M2.66797 3.99967C2.66797 3.63148 2.96645 3.33301 3.33464 3.33301H7.33464C7.70283 3.33301 8.0013 3.63148 8.0013 3.99967C8.0013 4.36786 7.70283 4.66634 7.33464 4.66634H3.33464C2.96645 4.66634 2.66797 4.36786 2.66797 3.99967Z" />
        <path d="M2.66797 6.66634C2.66797 6.29815 2.96645 5.99967 3.33464 5.99967H7.33464C7.70283 5.99967 8.0013 6.29815 8.0013 6.66634C8.0013 7.03453 7.70283 7.33301 7.33464 7.33301H3.33464C2.96645 7.33301 2.66797 7.03453 2.66797 6.66634Z" />
        <path d="M3.33464 8.66634C2.96645 8.66634 2.66797 8.96482 2.66797 9.33301C2.66797 9.7012 2.96645 9.99967 3.33464 9.99967H12.668C13.0362 9.99967 13.3346 9.7012 13.3346 9.33301C13.3346 8.96482 13.0362 8.66634 12.668 8.66634H3.33464Z" />
        <path d="M2.66797 11.9997C2.66797 11.6315 2.96645 11.333 3.33464 11.333H12.668C13.0362 11.333 13.3346 11.6315 13.3346 11.9997C13.3346 12.3679 13.0362 12.6663 12.668 12.6663H3.33464C2.96645 12.6663 2.66797 12.3679 2.66797 11.9997Z" />
        <path d="M10.0013 3.33301C9.63311 3.33301 9.33464 3.63148 9.33464 3.99967V6.66634C9.33464 7.03453 9.63311 7.33301 10.0013 7.33301H12.668C13.0362 7.33301 13.3346 7.03453 13.3346 6.66634V3.99967C13.3346 3.63148 13.0362 3.33301 12.668 3.33301H10.0013Z" />
      </g>
    ),
    viewBox: '0 0 16 16',
  },

  COLLECTION_EXPAND: {
    format: 'media',
    class: 'icon-collection-expand',
    markup: (
      <g>
        <rect x="2" y="4" width="18" height="15" rx="1" fill="#C0D7E9" />
        <path
          d="M20 7C20 6.44772 19.5523 6 19 6H11L9.05 3.4C8.86115 3.14819 8.56476 3 8.25 3H3C2.44772 3 2 3.44772 2 4V18C2 18.5523 2.44772 19 3 19H19C19.5523 19 20 18.5523 20 18V7Z"
          fill="url(#paint0_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 8C12 7.44772 11.5523 7 11 7C10.4477 7 10 7.44771 10 8V11H7C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H10V16C10 16.5523 10.4477 17 11 17C11.5523 17 12 16.5523 12 16V13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H12V8Z"
          fill="#1286C8"
        />
        <path
          d="M1 4V18C1 19.1046 1.89543 20 3 20H19C20.1046 20 21 19.1046 21 18V5C21 3.89543 20.1046 3 19 3H9.91421L9.5 2.58579C9.12493 2.21071 8.61622 2 8.08579 2H3C1.89543 2 1 2.89543 1 4Z"
          stroke="#0288D1"
          strokeWidth="2"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="11"
            y1="3"
            x2="11"
            y2="19"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E8F1F8" />
            <stop offset="1" stopColor="#D2E4F2" />
          </linearGradient>
        </defs>
      </g>
    ),
    viewBox: '0 0 22 22',
  },
  COLLECTION_COLLAPSE: {
    format: 'media',
    class: 'icon-collection-collapse',
    markup: (
      <g>
        <rect x="2" y="4" width="18" height="15" rx="1" fill="#95ABB8" />
        <path
          d="M20 7C20 6.44772 19.5523 6 19 6H11.5C11.1852 6 10.8889 5.85181 10.7 5.6L9.05 3.4C8.86115 3.14819 8.56476 3 8.25 3H3C2.44772 3 2 3.44772 2 4V18C2 18.5523 2.44772 19 3 19H19C19.5523 19 20 18.5523 20 18V7Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M15 11L7 11"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M1 4V18C1 19.1046 1.89543 20 3 20H19C20.1046 20 21 19.1046 21 18V5C21 3.89543 20.1046 3 19 3H9.91421L9.5 2.58579C9.12493 2.21071 8.61622 2 8.08579 2H3C1.89543 2 1 2.89543 1 4Z"
          stroke="#65737B"
          strokeWidth="2"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="11"
            y1="3"
            x2="11"
            y2="19"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#C1D3DD" />
            <stop offset="1" stopColor="#A0B2BD" />
          </linearGradient>
        </defs>
      </g>
    ),
    viewBox: '0 0 22 22',
  },
  COLLECTION_EMPTY: {
    format: 'media',
    class: 'icon-collection-empty',
    markup: (
      <g>
        <rect x="2" y="4" width="18" height="15" rx="1" fill="#C0D7E9" />
        <path
          d="M20 7C20 6.44772 19.5523 6 19 6H11L9.05 3.4C8.86115 3.14819 8.56476 3 8.25 3H3C2.44772 3 2 3.44772 2 4V18C2 18.5523 2.44772 19 3 19H19C19.5523 19 20 18.5523 20 18V7Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M1 4V18C1 19.1046 1.89543 20 3 20H19C20.1046 20 21 19.1046 21 18V5C21 3.89543 20.1046 3 19 3H9.91421L9.5 2.58579C9.12493 2.21071 8.61622 2 8.08579 2H3C1.89543 2 1 2.89543 1 4Z"
          stroke="#0288D1"
          strokeWidth="2"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="11"
            y1="3"
            x2="11"
            y2="19"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E8F1F8" />
            <stop offset="1" stopColor="#D2E4F2" />
          </linearGradient>
        </defs>
      </g>
    ),
    viewBox: '0 0 22 22',
  },
  GROUP_EMPTY: {
    format: 'media',
    class: 'icon-group-empty',
    markup: (
      <g>
        <mask
          id="path-1-outside-1"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="22"
          height="22"
          fill="black"
        >
          <rect fill="white" width="22" height="22" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 10C10.1204 10 11.1332 9.53939 11.8593 8.7972C12.501 9.53418 13.4461 10 14.5 10C16.433 10 18 8.433 18 6.5C18 4.567 16.433 3 14.5 3C13.6744 3 12.9156 3.28584 12.3171 3.76395C11.5983 2.69973 10.3809 2 9 2C6.79086 2 5 3.79086 5 6C5 8.20914 6.79086 10 9 10ZM16 19H19C19.5523 19 20 18.5523 20 18V15C20 12.7909 18.2091 11 16 11H12H6C3.79086 11 2 12.7909 2 15V19C2 19.5523 2.44772 20 3 20H15C15.5523 20 16 19.5523 16 19Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 10C10.1204 10 11.1332 9.53939 11.8593 8.7972C12.501 9.53418 13.4461 10 14.5 10C16.433 10 18 8.433 18 6.5C18 4.567 16.433 3 14.5 3C13.6744 3 12.9156 3.28584 12.3171 3.76395C11.5983 2.69973 10.3809 2 9 2C6.79086 2 5 3.79086 5 6C5 8.20914 6.79086 10 9 10ZM16 19H19C19.5523 19 20 18.5523 20 18V15C20 12.7909 18.2091 11 16 11H12H6C3.79086 11 2 12.7909 2 15V19C2 19.5523 2.44772 20 3 20H15C15.5523 20 16 19.5523 16 19Z"
          fill="#1286C8"
        />
        <path
          d="M11.8593 8.7972L13.3677 7.4839L11.945 5.84983L10.4298 7.3985L11.8593 8.7972ZM12.3171 3.76395L10.6597 4.88337L11.8725 6.67897L13.5654 5.32655L12.3171 3.76395ZM16 19V17H14V19H16ZM10.4298 7.3985C10.0643 7.77199 9.56059 8 9 8V12C10.6801 12 12.202 11.3068 13.2889 10.1959L10.4298 7.3985ZM14.5 8C14.0487 8 13.6457 7.80318 13.3677 7.4839L10.3509 10.1105C11.3563 11.2652 12.8435 12 14.5 12V8ZM16 6.5C16 7.32843 15.3284 8 14.5 8V12C17.5376 12 20 9.53757 20 6.5H16ZM14.5 5C15.3284 5 16 5.67157 16 6.5H20C20 3.46243 17.5376 1 14.5 1V5ZM13.5654 5.32655C13.8223 5.12137 14.1442 5 14.5 5V1C13.2046 1 12.0089 1.45031 11.0688 2.20135L13.5654 5.32655ZM9 4C9.68858 4 10.297 4.34625 10.6597 4.88337L13.9745 2.64453C12.8997 1.0532 11.0732 0 9 0V4ZM7 6C7 4.89543 7.89543 4 9 4V0C5.68629 0 3 2.68629 3 6H7ZM9 8C7.89543 8 7 7.10457 7 6H3C3 9.31371 5.68629 12 9 12V8ZM16 21H19V17H16V21ZM19 21C20.6569 21 22 19.6569 22 18H18C18 17.4477 18.4477 17 19 17V21ZM22 18V15H18V18H22ZM22 15C22 11.6863 19.3137 9 16 9V13C17.1046 13 18 13.8954 18 15H22ZM16 9H12V13H16V9ZM12 9H6V13H12V9ZM6 9C2.68629 9 0 11.6863 0 15H4C4 13.8954 4.89543 13 6 13V9ZM0 15V19H4V15H0ZM0 19C0 20.6569 1.34315 22 3 22V18C3.55228 18 4 18.4477 4 19H0ZM3 22H15V18H3V22ZM15 22C16.6569 22 18 20.6569 18 19H14C14 18.4477 14.4477 18 15 18V22Z"
          fill="#1286C8"
          mask="url(#path-1-outside-1)"
        />
        <circle cx="14.5" cy="6.5" r="3.5" fill="#B0CADF" />
        <path
          d="M10 13V19H19C19.5523 19 20 18.5523 20 18V15C20 12.7909 18.2091 11 16 11H12C10.8954 11 10 11.8954 10 13Z"
          fill="#B0CADF"
        />
        <circle cx="9" cy="6" r="4" fill="url(#paint0_linear)" />
        <path
          d="M2 15V19C2 19.5523 2.44772 20 3 20H15C15.5523 20 16 19.5523 16 19V15C16 12.7909 14.2091 11 12 11H6C3.79086 11 2 12.7909 2 15Z"
          fill="url(#paint1_linear)"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="9"
            y1="2"
            x2="9"
            y2="10"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E8F1F8" />
            <stop offset="1" stopColor="#D2E4F2" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="9"
            y1="11"
            x2="9"
            y2="20"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E8F1F8" />
            <stop offset="1" stopColor="#D2E4F2" />
          </linearGradient>
        </defs>
      </g>
    ),
    viewBox: '0 0 22 22',
  },
  GROUP_EXPAND: {
    format: 'media',
    class: 'icon-group-expand',
    markup: (
      <g>
        <mask
          id="path-1-outside-1"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="22"
          height="22"
          fill="black"
        >
          <rect fill="white" width="22" height="22" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 10C10.1204 10 11.1332 9.53939 11.8593 8.7972C12.501 9.53418 13.4461 10 14.5 10H12H9ZM16 19C16 19.5523 15.5523 20 15 20H3C2.44772 20 2 19.5523 2 19V14C2 11.7909 3.79086 10 6 10H9C6.79086 10 5 8.20914 5 6C5 3.79086 6.79086 2 9 2C10.3809 2 11.5983 2.69973 12.3171 3.76395C12.9156 3.28584 13.6744 3 14.5 3C16.433 3 18 4.567 18 6.5C18 8.433 16.433 10 14.5 10H16C18.2091 10 20 11.7909 20 14V18C20 18.5523 19.5523 19 19 19H16Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 10C10.1204 10 11.1332 9.53939 11.8593 8.7972C12.501 9.53418 13.4461 10 14.5 10H12H9ZM16 19C16 19.5523 15.5523 20 15 20H3C2.44772 20 2 19.5523 2 19V14C2 11.7909 3.79086 10 6 10H9C6.79086 10 5 8.20914 5 6C5 3.79086 6.79086 2 9 2C10.3809 2 11.5983 2.69973 12.3171 3.76395C12.9156 3.28584 13.6744 3 14.5 3C16.433 3 18 4.567 18 6.5C18 8.433 16.433 10 14.5 10H16C18.2091 10 20 11.7909 20 14V18C20 18.5523 19.5523 19 19 19H16Z"
          fill="#1286C8"
        />
        <path
          d="M11.8593 8.7972L13.3677 7.4839L11.945 5.84983L10.4298 7.3985L11.8593 8.7972ZM16 19V17H14V19H16ZM12.3171 3.76395L10.6597 4.88337L11.8725 6.67897L13.5654 5.32655L12.3171 3.76395ZM10.4298 7.3985C10.0643 7.77199 9.56059 8 9 8V12C10.6801 12 12.202 11.3068 13.2889 10.1959L10.4298 7.3985ZM14.5 8C14.0487 8 13.6457 7.80318 13.3677 7.4839L10.3509 10.1105C11.3563 11.2652 12.8435 12 14.5 12V8ZM12 12H14.5V8H12V12ZM12 8H9V12H12V8ZM15 22C16.6569 22 18 20.6569 18 19H14C14 18.4477 14.4477 18 15 18V22ZM3 22H15V18H3V22ZM0 19C0 20.6569 1.34315 22 3 22V18C3.55228 18 4 18.4477 4 19H0ZM0 14V19H4V14H0ZM6 8C2.68629 8 0 10.6863 0 14H4C4 12.8954 4.89543 12 6 12V8ZM9 8H6V12H9V8ZM9 8C7.89543 8 7 7.10457 7 6H3C3 9.31371 5.68629 12 9 12V8ZM7 6C7 4.89543 7.89543 4 9 4V0C5.68629 0 3 2.68629 3 6H7ZM9 4C9.68858 4 10.297 4.34625 10.6597 4.88337L13.9745 2.64453C12.8997 1.0532 11.0732 0 9 0V4ZM13.5654 5.32655C13.8223 5.12137 14.1442 5 14.5 5V1C13.2046 1 12.0089 1.45031 11.0688 2.20135L13.5654 5.32655ZM14.5 5C15.3284 5 16 5.67157 16 6.5H20C20 3.46243 17.5376 1 14.5 1V5ZM16 6.5C16 7.32843 15.3284 8 14.5 8V12C17.5376 12 20 9.53757 20 6.5H16ZM14.5 12H16V8H14.5V12ZM16 12C17.1046 12 18 12.8954 18 14H22C22 10.6863 19.3137 8 16 8V12ZM18 14V18H22V14H18ZM18 18C18 17.4477 18.4477 17 19 17V21C20.6569 21 22 19.6569 22 18H18ZM19 17H16V21H19V17Z"
          fill="#1286C8"
          mask="url(#path-1-outside-1)"
        />
        <circle cx="14.5" cy="6.5" r="3.5" fill="#B0CADF" />
        <path
          d="M10 12V19H19C19.5523 19 20 18.5523 20 18V14C20 11.7909 18.2091 10 16 10H12C10.8954 10 10 10.8954 10 12Z"
          fill="#B0CADF"
        />
        <circle cx="9" cy="6" r="4" fill="url(#paint0_linear)" />
        <path
          d="M2 14V19C2 19.5523 2.44772 20 3 20H15C15.5523 20 16 19.5523 16 19V14C16 11.7909 14.2091 10 12 10H6C3.79086 10 2 11.7909 2 14Z"
          fill="url(#paint1_linear)"
        />
        <path
          d="M12.5 7C12.5 6.17157 11.8284 5.5 11 5.5C10.1716 5.5 9.5 6.17157 9.5 7V9.5H7C6.17157 9.5 5.5 10.1716 5.5 11C5.5 11.8284 6.17157 12.5 7 12.5H9.5V15C9.5 15.8284 10.1716 16.5 11 16.5C11.8284 16.5 12.5 15.8284 12.5 15V12.5H15C15.8284 12.5 16.5 11.8284 16.5 11C16.5 10.1716 15.8284 9.5 15 9.5H12.5V7Z"
          fill="#1286C8"
          stroke="white"
          strokeLinecap="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="9"
            y1="2"
            x2="9"
            y2="10"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E8F1F8" />
            <stop offset="1" stopColor="#D2E4F2" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="9"
            y1="10"
            x2="9"
            y2="20"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E8F1F8" />
            <stop offset="1" stopColor="#D2E4F2" />
          </linearGradient>
        </defs>
      </g>
    ),
    viewBox: '0 0 22 22',
  },
  GROUP_COLLAPSE: {
    format: 'media',
    class: 'icon-group-collapse',
    markup: (
      <g>
        <mask
          id="path-1-outside-1"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="22"
          height="22"
          fill="black"
        >
          <rect fill="white" width="22" height="22" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 10C10.1204 10 11.1332 9.53939 11.8593 8.7972C12.501 9.53418 13.4461 10 14.5 10H12H11H9ZM16 19C16 19.5523 15.5523 20 15 20H3C2.44772 20 2 19.5523 2 19V14C2 11.7909 3.79086 10 6 10H9C6.79086 10 5 8.20914 5 6C5 3.79086 6.79086 2 9 2C10.3809 2 11.5983 2.69973 12.3171 3.76395C12.9156 3.28584 13.6744 3 14.5 3C16.433 3 18 4.567 18 6.5C18 8.433 16.433 10 14.5 10H16C18.2091 10 20 11.7909 20 14V18C20 18.5523 19.5523 19 19 19H16Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 10C10.1204 10 11.1332 9.53939 11.8593 8.7972C12.501 9.53418 13.4461 10 14.5 10H12H11H9ZM16 19C16 19.5523 15.5523 20 15 20H3C2.44772 20 2 19.5523 2 19V14C2 11.7909 3.79086 10 6 10H9C6.79086 10 5 8.20914 5 6C5 3.79086 6.79086 2 9 2C10.3809 2 11.5983 2.69973 12.3171 3.76395C12.9156 3.28584 13.6744 3 14.5 3C16.433 3 18 4.567 18 6.5C18 8.433 16.433 10 14.5 10H16C18.2091 10 20 11.7909 20 14V18C20 18.5523 19.5523 19 19 19H16Z"
          fill="#65737B"
        />
        <path
          d="M11.8593 8.7972L13.3677 7.4839L11.945 5.84983L10.4298 7.3985L11.8593 8.7972ZM16 19V17H14V19H16ZM12.3171 3.76395L10.6597 4.88337L11.8725 6.67897L13.5654 5.32655L12.3171 3.76395ZM10.4298 7.3985C10.0643 7.77199 9.56059 8 9 8V12C10.6801 12 12.202 11.3068 13.2889 10.1959L10.4298 7.3985ZM14.5 8C14.0487 8 13.6457 7.80318 13.3677 7.4839L10.3509 10.1105C11.3563 11.2652 12.8435 12 14.5 12V8ZM12 12H14.5V8H12V12ZM12 8H11V12H12V8ZM11 8H9V12H11V8ZM15 22C16.6569 22 18 20.6569 18 19H14C14 18.4477 14.4477 18 15 18V22ZM3 22H15V18H3V22ZM0 19C0 20.6569 1.34315 22 3 22V18C3.55228 18 4 18.4477 4 19H0ZM0 14V19H4V14H0ZM6 8C2.68629 8 0 10.6863 0 14H4C4 12.8954 4.89543 12 6 12V8ZM9 8H6V12H9V8ZM9 8C7.89543 8 7 7.10457 7 6H3C3 9.31371 5.68629 12 9 12V8ZM7 6C7 4.89543 7.89543 4 9 4V0C5.68629 0 3 2.68629 3 6H7ZM9 4C9.68858 4 10.297 4.34625 10.6597 4.88337L13.9745 2.64453C12.8997 1.0532 11.0732 0 9 0V4ZM13.5654 5.32655C13.8223 5.12137 14.1442 5 14.5 5V1C13.2046 1 12.0089 1.45031 11.0688 2.20135L13.5654 5.32655ZM14.5 5C15.3284 5 16 5.67157 16 6.5H20C20 3.46243 17.5376 1 14.5 1V5ZM16 6.5C16 7.32843 15.3284 8 14.5 8V12C17.5376 12 20 9.53757 20 6.5H16ZM14.5 12H16V8H14.5V12ZM16 12C17.1046 12 18 12.8954 18 14H22C22 10.6863 19.3137 8 16 8V12ZM18 14V18H22V14H18ZM18 18C18 17.4477 18.4477 17 19 17V21C20.6569 21 22 19.6569 22 18H18ZM19 17H16V21H19V17Z"
          fill="#65737B"
          mask="url(#path-1-outside-1)"
        />
        <circle cx="14.5" cy="6.5" r="3.5" fill="#95ABB8" />
        <path
          d="M10 11V18C10 18.5523 10.4477 19 11 19H19C19.5523 19 20 18.5523 20 18V14C20 11.7909 18.2091 10 16 10H11C10.4477 10 10 10.4477 10 11Z"
          fill="#95ABB8"
        />
        <circle cx="9" cy="6" r="4" fill="url(#paint0_linear)" />
        <path
          d="M2 14V19C2 19.5523 2.44772 20 3 20H15C15.5523 20 16 19.5523 16 19V14C16 11.7909 14.2091 10 12 10H6C3.79086 10 2 11.7909 2 14Z"
          fill="url(#paint1_linear)"
        />
        <path
          d="M5 11C5 12.1046 5.89543 13 7 13L15 13C16.1046 13 17 12.1046 17 11C17 9.89543 16.1046 9 15 9H7C5.89543 9 5 9.89543 5 11Z"
          fill="white"
          stroke="#65737B"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="9"
            y1="2"
            x2="9"
            y2="10"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#C1D3DD" />
            <stop offset="1" stopColor="#A0B2BD" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="9"
            y1="10"
            x2="9"
            y2="20"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#C1D3DD" />
            <stop offset="1" stopColor="#A0B2BD" />
          </linearGradient>
        </defs>
      </g>
    ),
    viewBox: '0 0 22 22',
  },
  LOCATION: {
    format: 'markup',
    class: 'icon-location',
    markup: (
      <g fill="none">
        <path
          d="M19 10C19 11.1498 18.5793 12.4212 17.8708 13.7285C17.167 15.0271 16.216 16.294 15.244 17.4165C14.2747 18.5358 13.3024 19.4912 12.5711 20.1674C12.3575 20.3649 12.1651 20.538 12 20.684C11.8349 20.538 11.6425 20.3649 11.4289 20.1674C10.6976 19.4912 9.72528 18.5358 8.75596 17.4165C7.78397 16.294 6.83296 15.0271 6.12919 13.7285C5.4207 12.4212 5 11.1498 5 10C5 7.53946 5.98444 5.8179 7.32199 4.69475C8.68627 3.54915 10.4531 3 12 3C13.5469 3 15.3137 3.54915 16.678 4.69475C18.0156 5.8179 19 7.53946 19 10Z"
          stroke="#26A69A"
          strokeWidth="2"
        />
        <circle cx="12" cy="10" r="3" stroke="#26A69A" strokeWidth="2" />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  PROFILESTAR: {
    format: 'markup',
    class: 'icon-profilestar',
    markup: (
      <g fill="none">
        <path
          d="M12 3L14.6131 8.40336L20.5595 9.21885L16.2281 13.3738L17.2901 19.2812L12 16.4457L6.70993 19.2812L7.77189 13.3738L3.44049 9.21885L9.38689 8.40336L12 3Z"
          stroke="#FFB400"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  REQUEST_REVIEW: {
    format: 'media',
    class: 'icon-request-evidence',
    markup: (
      <g>
        <path
          d="M14 3.22302C13.3568 3.07706 12.6874 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.3126 20.9229 10.6432 20.777 10"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 8.13417C9 7.27412 9.98745 6 12.1376 6C14.1762 6 15.53 7.13083 15.53 8.62797C15.53 10.1251 14.1762 11.2081 13.7462 11.5426C12.8702 12.2274 12.8542 12.7052 12.8542 13.5334C12.8542 13.8361 12.695 14.1864 11.9146 14.1864C11.2616 14.1864 11.0386 13.9475 11.0386 13.1193C11.0386 11.7496 11.6439 11.0966 12.1057 10.6984C12.2012 10.6174 12.3089 10.5348 12.421 10.4486C12.9261 10.0609 13.5232 9.60247 13.5232 8.89869C13.5232 8.16607 12.8861 7.81566 12.0898 7.81566C11.1494 7.81566 10.8708 8.22656 10.6361 8.57267C10.4653 8.8245 10.3178 9.04202 9.9556 9.04202C9.52555 9.04202 9 8.75535 9 8.13417ZM10.7201 16.5118C10.7201 15.8428 11.2616 15.2854 11.9305 15.2854C12.5995 15.2854 13.1569 15.8428 13.1569 16.5118C13.1569 17.1648 12.6154 17.7381 11.9305 17.7381C11.2457 17.7381 10.7201 17.1647 10.7201 16.5118Z"
          className="fill"
        />
        <path d="M20 1V7" strokeWidth="2" strokeLinecap="round" />
        <path d="M23 4H17" strokeWidth="2" strokeLinecap="round" />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  EDUCATION: {
    format: 'markup',
    class: 'icon-education',
    markup: (
      <g fill="none">
        <path
          d="M12.0004 15.887L2.94701 12.2373L12.0004 8.58758L21.0538 12.2373L12.0004 15.887Z"
          stroke="#26C6DA"
          strokeWidth="2"
        />
        <path
          d="M7 13.5093V20.5093C7 20.5093 7.5 22.5093 12 22.5093C16.5 22.5093 17 20.5093 17 20.5093V13.5093"
          stroke="#26C6DA"
          strokeWidth="2"
        />
        <path d="M20 12.5093V19.5093" stroke="#26C6DA" strokeWidth="2" />
      </g>
    ),
    viewBox: '0 0 24 27',
  },
  BRIEFCASE: {
    format: 'markup',
    class: 'icon-briefcase',
    markup: (
      <g fill="none">
        <rect
          x="2"
          y="6.50928"
          width="20"
          height="14"
          stroke="#C28E4C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 12.5093L12 14.5093L2 12.5093"
          stroke="#C28E4C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 6.50928V2.50928H8V6.50928"
          stroke="#C28E4C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="10.5093" r="1" fill="#C28E4C" />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  MEDAL: {
    format: 'markup',
    class: 'icon-medal',
    markup: (
      <g fill="none">
        <circle
          cx="12"
          cy="9"
          r="8"
          stroke="#7E57C2"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 5C9.79086 5 8 6.79086 8 9C8 11.2091 9.79086 13 12 13C14.2091 13 16 11.2091 16 9C16 7.89261 15.55 6.89032 14.8229 6.16603"
          stroke="#7E57C2"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 15.5V22.5L12 20L17 22.5V16"
          stroke="#7E57C2"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  SPLIT_HORIZONTAL: {
    format: 'media',
    class: 'icon-split-horizontal',
    markup: (
      <g>
        <rect
          x="3"
          y="18"
          width="12"
          height="18"
          transform="rotate(-90 3 18)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="3"
          y="18"
          width="12"
          height="9"
          transform="rotate(-90 3 18)"
          className="fill"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 9H18"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 12H18"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 15H18"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  SECTOR: {
    format: 'markup',
    class: 'icon-sector',
    markup: (
      <g fill="none">
        <path
          d="M12 2L1 9H23L12 2Z"
          stroke="#E65100"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 21H22"
          stroke="#E65100"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 21L12 9"
          stroke="#E65100"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 21L16 9"
          stroke="#E65100"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 21L20 9"
          stroke="#E65100"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 21L8 9"
          stroke="#E65100"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 21L4 9"
          stroke="#E65100"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  SPLIT_VERTICAL: {
    format: 'media',
    class: 'icon-split-vertical',
    markup: (
      <g>
        <rect
          x="6"
          y="3"
          width="12"
          height="18"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="6"
          y="3"
          width="12"
          height="9"
          className="fill"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 15H15"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 18H15"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  SCROLL: {
    format: 'markup',
    class: 'icon-scroll',
    markup: (
      <g fill="none">
        <path
          d="M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z"
          fill="black"
          fillOpacity="0.2"
        />
        <path
          d="M39.5 34.5L32.5 27.5L25.5 34.5"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 64 64',
  },
  // WARNING: {
  //   format: 'markup',
  //   class: 'icon-warning',
  //   markup: (
  //     <g>
  //       <path
  //         d="M11.1536 4.34345C11.5458 3.7207 12.4537 3.7207 12.8459 4.34345L21.4265 17.9671C21.8459 18.633 21.3674 19.5 20.5804 19.5H3.41908C2.63208 19.5 2.1535 18.633 2.57292 17.9671L11.1536 4.34345Z"
  //         fill="#FFB400"
  //       />
  //       <circle cx="12" cy="17" r="1" fill="white" />
  //       <path
  //         d="M11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V9Z"
  //         fill="white"
  //       />
  //     </g>
  //   ),
  //   viewBox: '0 0 24 24',
  // },
  ERROR_CIRCLE: {
    format: 'markup',
    class: 'icon-error-circle',
    markup: (
      <g>
        <path
          d="M12 5C8.13438 5 5 8.13438 5 12C5 15.8656 8.13438 19 12 19C15.8656 19 19 15.8656 19 12C19 8.13438 15.8656 5 12 5ZM14.5844 14.6594L13.5531 14.6547L12 12.8031L10.4484 14.6531L9.41563 14.6578C9.34688 14.6578 9.29063 14.6031 9.29063 14.5328C9.29063 14.5031 9.30156 14.475 9.32031 14.4516L11.3531 12.0297L9.32031 9.60938C9.30143 9.58647 9.29096 9.5578 9.29063 9.52812C9.29063 9.45937 9.34688 9.40312 9.41563 9.40312L10.4484 9.40781L12 11.2594L13.5516 9.40938L14.5828 9.40469C14.6516 9.40469 14.7078 9.45937 14.7078 9.52969C14.7078 9.55937 14.6969 9.5875 14.6781 9.61094L12.6484 12.0312L14.6797 14.4531C14.6984 14.4766 14.7094 14.5047 14.7094 14.5344C14.7094 14.6031 14.6531 14.6594 14.5844 14.6594Z"
          fill="currentColor"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  VERIFIED_CIRCLE: {
    format: 'markup',
    class: 'icon-verified-circle',
    markup: (
      <g>
        <circle cx="12" cy="12" r="12" fill="#E8F1F8" />
        <path
          d="M7.5 12L10.5 15L16.5 9"
          stroke="#1286C8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  MONEY: {
    format: 'markup',
    class: 'icon-money',
    markup: (
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C15.3457 23 18.3433 21.5051 20.3592 19.1503C20.7184 18.7308 20.6695 18.0995 20.2499 17.7404C19.8304 17.3812 19.1991 17.4301 18.8399 17.8497C17.1877 19.7795 14.7369 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 13.11 20.7995 14.1709 20.4337 15.15C20.2403 15.6673 20.503 16.2434 21.0204 16.4367C21.5377 16.6301 22.1138 16.3674 22.3071 15.85C22.7554 14.6504 23 13.3526 23 12C23 5.92487 18.0751 1 12 1ZM11.2285 17.07V18.316H12.8525V17.098C13.5898 16.9767 14.1871 16.664 14.6445 16.16C15.1111 15.656 15.3445 15.0167 15.3445 14.242C15.3445 13.85 15.2791 13.4907 15.1485 13.164C15.0271 12.8373 14.8825 12.5713 14.7145 12.366C14.5465 12.1607 14.3131 11.9647 14.0145 11.778C13.7251 11.582 13.4778 11.4373 13.2725 11.344C13.0671 11.2507 12.7965 11.1387 12.4605 11.008C11.8725 10.7933 11.4338 10.588 11.1445 10.392C10.8551 10.1867 10.7105 9.916 10.7105 9.58C10.7105 9.272 10.8178 9.034 11.0325 8.866C11.2471 8.68867 11.5458 8.6 11.9285 8.6C12.6658 8.6 13.1745 8.936 13.4545 9.608L14.9525 9.104C14.8031 8.60934 14.5511 8.18933 14.1965 7.844C13.8418 7.48934 13.3938 7.25134 12.8525 7.13V5.996H11.2285V7.116C10.5378 7.23734 9.99647 7.52667 9.60447 7.984C9.21247 8.44134 9.01647 8.97334 9.01647 9.58C9.01647 9.93467 9.07247 10.2613 9.18447 10.56C9.3058 10.8493 9.44113 11.0873 9.59047 11.274C9.74913 11.4607 9.96847 11.6427 10.2485 11.82C10.5285 11.988 10.7665 12.114 10.9625 12.198C11.1585 12.282 11.4198 12.3893 11.7465 12.52C12.3718 12.7627 12.8431 13.01 13.1605 13.262C13.4778 13.5047 13.6365 13.836 13.6365 14.256C13.6365 14.6853 13.5011 15.0167 13.2305 15.25C12.9691 15.4833 12.6098 15.6 12.1525 15.6C11.7231 15.6 11.3358 15.4647 10.9905 15.194C10.6451 14.9233 10.3745 14.564 10.1785 14.116L8.65247 14.676C8.8578 15.292 9.1798 15.81 9.61847 16.23C10.0665 16.6407 10.6031 16.9207 11.2285 17.07Z"
          fill="#7FB800"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  AWARDS: {
    format: 'markup',
    class: 'icon-awards',
    markup: (
      <g>
        <circle
          cx="12"
          cy="9"
          r="8"
          stroke="#FFB400"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 5C9.79086 5 8 6.79086 8 9C8 11.2091 9.79086 13 12 13C14.2091 13 16 11.2091 16 9C16 7.89261 15.55 6.89032 14.8229 6.16603"
          stroke="#FFB400"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 15.5V22.5L12 20L17 22.5V16"
          stroke="#FFB400"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  TEAM: {
    format: 'markup',
    class: 'icon-team',
    markup: (
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 8C17.1046 8 18 7.10457 18 6C18 4.89543 17.1046 4 16 4C14.8954 4 14 4.89543 14 6C14 7.10457 14.8954 8 16 8ZM16 10C18.2091 10 20 8.20914 20 6C20 3.79086 18.2091 2 16 2C13.7909 2 12 3.79086 12 6C12 8.20914 13.7909 10 16 10ZM8 12C9.10457 12 10 11.1046 10 10C10 8.89543 9.10457 8 8 8C6.89543 8 6 8.89543 6 10C6 11.1046 6.89543 12 8 12ZM8 14C10.2091 14 12 12.2091 12 10C12 7.79086 10.2091 6 8 6C5.79086 6 4 7.79086 4 10C4 12.2091 5.79086 14 8 14ZM18.9 10.2C18.4582 10.5314 18.3686 11.1582 18.7 11.6C18.9041 11.8721 19.2397 12.405 19.5209 13.0497C19.805 13.7015 20 14.3915 20 15C20 15.0172 19.9978 15.0273 19.9868 15.0466C19.9717 15.0728 19.9325 15.1258 19.8404 15.1972C19.6449 15.3488 19.3134 15.5051 18.8482 15.6391C17.9275 15.9042 16.7786 16 16 16C15.4477 16 15 16.4477 15 17C15 17.5523 15.4477 18 16 18C16.8881 18 18.2391 17.8958 19.4018 17.5609C19.9783 17.3949 20.5843 17.1512 21.0659 16.7778C21.5654 16.3904 22 15.8011 22 15C22 14.0085 21.695 13.0319 21.3541 12.2503C21.0103 11.4617 20.5959 10.7946 20.3 10.4C19.9686 9.95817 19.3418 9.86863 18.9 10.2ZM5.8 15.6C6.13137 15.1582 6.04183 14.5314 5.6 14.2C5.15817 13.8686 4.53137 13.9582 4.2 14.4C3.90407 14.7946 3.48973 15.4617 3.14585 16.2503C2.80505 17.0319 2.5 18.0085 2.5 19C2.5 19.8011 2.93457 20.3904 3.43411 20.7778C3.9157 21.1512 4.5217 21.3949 5.09825 21.5609C5.98755 21.817 6.98712 21.9382 7.8054 21.9811C7.86834 21.9935 7.93341 22 8 22C8.07977 22 8.16328 21.9991 8.25005 21.9974C8.33678 21.9991 8.42026 22 8.5 22C8.56658 22 8.63164 21.9935 8.69458 21.9811C9.51285 21.9382 10.5124 21.817 11.4018 21.5609C11.9783 21.3949 12.5843 21.1512 13.0659 20.7778C13.5654 20.3904 14 19.8011 14 19C14 18.0085 13.695 17.0319 13.3541 16.2503C13.0103 15.4617 12.5959 14.7946 12.3 14.4C11.9686 13.9582 11.3418 13.8686 10.9 14.2C10.4582 14.5314 10.3686 15.1582 10.7 15.6C10.9041 15.8721 11.2397 16.405 11.5209 17.0497C11.805 17.7014 12 18.3915 12 19C12 19.0171 11.9978 19.0273 11.9868 19.0466C11.9717 19.0728 11.9325 19.1258 11.8404 19.1972C11.6449 19.3488 11.3134 19.5051 10.8482 19.639C10.0218 19.8771 9.01137 19.9786 8.25004 19.9969C7.4887 19.9786 6.47828 19.8771 5.65175 19.639C5.18664 19.5051 4.85514 19.3488 4.65964 19.1972C4.56752 19.1258 4.52831 19.0728 4.51324 19.0466C4.50216 19.0273 4.5 19.0171 4.5 19C4.5 18.3914 4.69495 17.7014 4.97915 17.0497C5.26027 16.405 5.59593 15.8721 5.8 15.6Z"
          fill="#7E57C2"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  AUDIENCE: {
    format: 'markup',
    class: 'icon-audience',
    markup: (
      <g>
        <path
          d="M18 7L21 3H11.5C7.91015 3 5 5.91015 5 9.5V12M18 7H14C11.7909 7 10 8.79086 10 11V11C10 11.5523 9.55228 12 9 12H5M18 7V8.76393C18 8.91918 18.0361 9.07229 18.1056 9.21115L20 13H18V16C18 17.1046 17.1046 18 16 18H13V20C13 20.5523 12.5523 21 12 21H5V12"
          stroke="#D81B60"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  DOMAIN: {
    format: 'markup',
    class: 'icon-domain',
    markup: (
      <g>
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="#26A69A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 12H22"
          stroke="#26A69A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 2V22"
          stroke="#26A69A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.00008 3C6.30733 9.18634 6.30175 14.6933 8.00018 21"
          stroke="#26A69A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0287 3C17.7215 9.18634 17.7271 14.6933 16.0286 21"
          stroke="#26A69A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 6.98572C10.4043 8.54936 13.9269 8.50674 20 6.98572"
          stroke="#26A69A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 17.1568C10.4043 15.5932 13.9269 15.6358 20 17.1568"
          stroke="#26A69A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  TOPICS: {
    format: 'markup',
    class: 'icon-topics',
    markup: (
      <g>
        <path
          d="M18 1L1 1L1 15L18 15L23 8L18 1Z"
          stroke="#26C6DA"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.9585 5.97919H10.9585"
          stroke="#26C6DA"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.9585 9.97919H12.9585"
          stroke="#26C6DA"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="17.4585" cy="8" r="1.5" fill="#26C6DA" />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  ADJUST_CLAIM: {
    format: 'markup',
    class: 'icon-adjust-claim',
    markup: (
      <g>
        <rect x="1" y="4" width="2" height="4" fill="#1286C8" />
        <rect x="18" y="16" width="2" height="4" fill="#1286C8" />
        <rect x="4" y="4" width="2" height="4" fill="#1286C8" />
        <rect x="21" y="16" width="2" height="4" fill="#1286C8" />
        <rect x="8" y="6" width="15" height="2" rx="1" fill="#1286C8" />
        <rect x="1" y="11" width="4" height="2" rx="1" fill="#1286C8" />
        <rect x="6" y="11" width="17" height="2" rx="1" fill="#1286C8" />
        <rect x="1" y="16" width="15" height="2" rx="1" fill="#1286C8" />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  ADD_POINT: {
    format: 'markup',
    class: 'icon-add-point',
    markup: (
      <g>
        <path
          d="M12 6H3V21.5L8 17H19V13"
          stroke="#1286C8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 12H10"
          stroke="#1286C8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 12H14"
          stroke="#1286C8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23 6H15"
          stroke="#1286C8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 2L19 10"
          stroke="#1286C8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  QTP: {
    format: 'markup',
    class: 'icon-qtp',
    markup: (
      <g>
        <path
          d="M5.61415 17.8217L6.62702 14.0322C6.65666 13.8867 6.64447 13.5719 6.35855 13.477C6.07264 13.3821 4.77028 13.8778 4.63664 14.0327C3.94761 15.0897 2.64294 17.0142 2.2726 17.6174C1.80967 18.3714 1.45632 19.3681 2.27211 21.6665C2.92473 23.5053 4.343 23.5557 4.88804 23.5062C6.00164 23.4044 6.62586 23.1938 7.36291 23.0871C8.28423 22.9538 8.99173 22.4446 9.05959 21.9426L9.69167 19.6232L11.8918 19.273C13.6545 18.811 13.816 16.8713 11.7779 17.2235L5.61415 17.8217Z"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M12 23.5C18.0751 23.5 23 18.5751 23 12.5C23 6.42487 18.0751 1.5 12 1.5M3.9532 5C2.12105 6.96488 1 9.60152 1 12.5C1 13.0948 1.04721 13.6786 1.1381 14.2479"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M12 23.5C18.0751 23.5 23 18.5751 23 12.5C23 6.42487 18.0751 1.5 12 1.5C5.92487 1.5 1 6.42487 1 12.5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <circle cx="8.5" cy="7" r="1.5" fill="#A4B4BD" />
        <circle cx="17.5" cy="7" r="1.5" fill="#A4B4BD" />
        <path
          d="M10 11.5L10.534 11.589C12.1667 11.8611 13.8333 11.8611 15.466 11.589L16 11.5"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
    ),
    viewBox: '0 0 24 25',
  },
  RETWEET_ARROWS: {
    format: 'markup',
    class: 'icon-retweet-arrows',
    markup: (
      <g>
        <path d="M10.4344 12.1032C10.3782 12.0344 10.3001 12 10.2002 12H4.80006V8.39992H6.59995C6.76243 8.39992 6.90313 8.34052 7.0218 8.22175C7.14054 8.10301 7.19991 7.96241 7.19991 7.7998C7.19991 7.6499 7.15292 7.52168 7.05927 7.41549L4.05937 3.81543C3.9406 3.67805 3.78748 3.60925 3.59999 3.60925C3.41243 3.60925 3.25937 3.67795 3.14067 3.81543L0.140704 7.41549C0.0467919 7.52168 0 7.6499 0 7.7998C0 7.96241 0.0594667 8.10301 0.178105 8.22175C0.296874 8.34052 0.437578 8.39992 0.600053 8.39992H2.40008V12.3001V13.8V13.903V14.025C2.40008 14.0438 2.40317 14.0798 2.4094 14.133C2.41568 14.1861 2.42513 14.2221 2.43761 14.2407C2.45002 14.2596 2.46726 14.2846 2.48913 14.3158C2.51087 14.347 2.53908 14.3691 2.57336 14.3814C2.60774 14.3938 2.65 14.4001 2.70004 14.4001H11.7001C11.7812 14.4001 11.8516 14.3704 11.9109 14.311C11.9702 14.2517 11.9999 14.1814 11.9999 14.1002C11.9999 14.0375 11.9781 13.9722 11.9344 13.9031L10.4344 12.1032Z" />
        <path d="M17.8217 9.77828C17.7031 9.65974 17.5624 9.60017 17.3999 9.60017H15.5999V5.70016V4.20009V4.09699V3.97513C15.5999 3.95635 15.5968 3.92046 15.5905 3.8672C15.5842 3.81404 15.5747 3.77815 15.5624 3.75936C15.5499 3.74061 15.5327 3.71556 15.5108 3.68437C15.4889 3.6532 15.4609 3.63127 15.4264 3.61873C15.3921 3.60631 15.35 3.59998 15.2999 3.59998H6.29983C6.21859 3.59998 6.14842 3.62969 6.08892 3.68903C6.02965 3.74843 6 3.81876 6 3.89994C6 3.96866 6.02174 4.03115 6.06557 4.08743L7.56551 5.88746C7.62176 5.96246 7.69991 5.99996 7.79986 5.99996H13.1999V9.59994H11.3999C11.2375 9.59994 11.0968 9.65938 10.9781 9.77792C10.8593 9.89682 10.7999 10.0376 10.7999 10.2C10.7999 10.35 10.8469 10.478 10.9407 10.5844L13.9406 14.1843C14.0656 14.3282 14.2187 14.4 14.4 14.4C14.5811 14.4 14.7341 14.3282 14.8592 14.1843L17.8591 10.5844C17.9527 10.478 17.9998 10.35 17.9998 10.2C18 10.0377 17.9404 9.89705 17.8217 9.77828Z" />
      </g>
    ),
    viewBox: '0 0 18 18',
  },
  LINK_2: {
    format: 'markup',
    class: 'icon-link-2',
    markup: (
      <g>
        <g clipPath="url(#clip0)">
          <path d="M22.3528 1.64757C20.1561 -0.549182 16.5946 -0.549182 14.3979 1.64752L9.69658 6.3488C7.42431 8.62116 7.63469 12.2418 9.69658 14.3038C10.0419 14.6491 10.4239 14.9306 10.8273 15.1618L11.6853 14.3038C12.2481 13.7409 12.05 13.0829 12.0399 12.6081C11.9164 12.5206 11.7962 12.4259 11.6853 12.315C10.6272 11.257 10.5797 9.44321 11.6853 8.33752C11.8495 8.17332 16.2869 3.73599 16.3865 3.63633C17.4834 2.53951 19.2672 2.53951 20.364 3.63633C21.4608 4.73316 21.4608 6.51699 20.364 7.61382L17.2565 10.7213C17.3464 11.2185 17.8857 12.3963 17.6083 14.3392C17.6218 14.3258 17.638 14.3173 17.6515 14.3038L22.3528 9.60254C24.5495 7.40579 24.5495 3.84432 22.3528 1.64757Z" />
          <path d="M14.668 9.33192C14.3228 8.98664 13.9407 8.70511 13.5374 8.47388L12.6793 9.33192C12.1165 9.8947 12.3146 10.5527 12.3247 11.0275C12.4483 11.115 12.5684 11.2097 12.6793 11.3206C13.7374 12.3787 13.785 14.1924 12.6793 15.2981C12.5148 15.4627 7.70988 20.2675 7.61374 20.3637C6.51691 21.4605 4.73309 21.4605 3.63626 20.3637C2.53943 19.2668 2.53943 17.483 3.63626 16.3862L7.10815 12.9143C7.01829 12.4171 6.47894 11.2393 6.7564 9.29644C6.74285 9.30975 6.72654 9.31842 6.71304 9.33188L1.64749 14.3975C-0.549164 16.5943 -0.549164 20.1557 1.64749 22.3525C3.84424 24.5491 7.40566 24.5491 9.60241 22.3525L14.668 17.2869C16.8981 15.0568 16.7763 11.4401 14.668 9.33192Z" />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  FOLDER_2: {
    format: 'markup',
    class: 'icon-folder-2',
    markup: (
      <g>
        <g clipPath="url(#clip0)">
          <path
            d="M3 20.105H21V7.10503H13L10 4.10503H3V20.105Z"
            stroke="#1286C8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15 13.105H9"
            stroke="#1286C8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 10.105L12 16.105"
            stroke="#1286C8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  QUESTION: {
    format: 'markup',
    class: 'icon-question',
    markup: (
      <g>
        <circle cx="12" cy="12.5" r="10" strokeWidth="2" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 8.63417C9 7.77412 9.98745 6.5 12.1376 6.5C14.1762 6.5 15.53 7.63083 15.53 9.12797C15.53 10.6251 14.1762 11.7081 13.7462 12.0426C12.8702 12.7274 12.8542 13.2052 12.8542 14.0334C12.8542 14.3361 12.695 14.6864 11.9146 14.6864C11.2616 14.6864 11.0386 14.4475 11.0386 13.6193C11.0386 12.2496 11.6439 11.5966 12.1057 11.1984C12.2012 11.1174 12.3089 11.0348 12.421 10.9486C12.9261 10.5609 13.5232 10.1025 13.5232 9.39869C13.5232 8.66607 12.8861 8.31566 12.0898 8.31566C11.1494 8.31566 10.8708 8.72656 10.6361 9.07267C10.4653 9.3245 10.3178 9.54202 9.9556 9.54202C9.52555 9.54202 9 9.25535 9 8.63417ZM10.7201 17.0118C10.7201 16.3428 11.2616 15.7854 11.9305 15.7854C12.5995 15.7854 13.1569 16.3428 13.1569 17.0118C13.1569 17.6648 12.6154 18.2381 11.9305 18.2381C11.2457 18.2381 10.7201 17.6647 10.7201 17.0118Z"
          className="fill"
        />
      </g>
    ),
    viewBox: '0 0 24 25',
  },
  TRANSCRIPT: {
    format: 'markup',
    class: 'icon-transcript',
    markup: (
      <g>
        <path d="M0 2.5H4" strokeWidth="2" />
        <path d="M6 2.5H16" strokeWidth="2" />
        <path d="M0 6.5L16 6.5" strokeWidth="2" />
        <path d="M0 10.5L11 10.5" strokeWidth="2" />
        <path d="M0 14.5L7 14.5" strokeWidth="2" />
        <path d="M9 14.5L16 14.5" strokeWidth="2" />
        <path d="M13 10.5H16" strokeWidth="2" />
      </g>
    ),
    viewBox: '0 0 16 17',
  },
  APPROVED: {
    format: 'markup',
    class: 'icon-approved',
    markup: (
      <g>
        <path
          d="M5 13L9 17L18 8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  REVIEW_TIMELINE: {
    format: 'markup',
    class: 'icon-review-timeline',
    markup: (
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9ZM9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM6.88636 9.00007C6.88636 9.86615 6.18426 10.5682 5.31818 10.5682C4.4521 10.5682 3.75 9.86615 3.75 9.00007C3.75 8.13398 4.4521 7.43188 5.31818 7.43188C6.18426 7.43188 6.88636 8.13398 6.88636 9.00007ZM8.38636 9.00007C8.38636 10.6946 7.01269 12.0682 5.31818 12.0682C3.62367 12.0682 2.25 10.6946 2.25 9.00007C2.25 7.30556 3.62367 5.93188 5.31818 5.93188C6.14644 5.93188 6.89805 6.26008 7.45005 6.79351C8.007 6.5487 8.53457 6.4064 9.07786 6.40947C9.60074 6.41243 10.0839 6.54954 10.5688 6.77561C11.119 6.25274 11.863 5.93188 12.682 5.93188C14.3765 5.93188 15.7501 7.30556 15.7501 9.00007C15.7501 10.6946 14.3765 12.0682 12.682 12.0682C10.9874 12.0682 9.61377 10.6946 9.61377 9.00007C9.61377 8.67197 9.66527 8.35591 9.76062 8.05951C9.49501 7.95329 9.27661 7.91062 9.06938 7.90945C8.84094 7.90816 8.58273 7.957 8.24803 8.0864C8.33793 8.375 8.38636 8.68188 8.38636 9.00007ZM14.2501 9.00007C14.2501 9.86615 13.548 10.5682 12.682 10.5682C11.8159 10.5682 11.1138 9.86615 11.1138 9.00007C11.1138 8.13398 11.8159 7.43188 12.682 7.43188C13.548 7.43188 14.2501 8.13398 14.2501 9.00007Z"
        />
      </g>
    ),
    viewBox: '0 0 18 18',
  },
  EVIDENCE_TIMELINE: {
    format: 'markup',
    class: 'icon-evidence-timeline',
    markup: (
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12.0001 5C12.3449 5 12.6654 5.17762 12.8481 5.47L18.8481 15.07C19.1408 15.5383 18.9985 16.1553 18.5301 16.448C18.0618 16.7407 17.4448 16.5983 17.1521 16.13L12.0001 7.8868L6.84813 16.13C6.55542 16.5983 5.93847 16.7407 5.47013 16.448C5.0018 16.1553 4.85943 15.5383 5.15214 15.07L11.1521 5.47C11.3349 5.17762 11.6553 5 12.0001 5ZM11.9999 14.4C12.6627 14.4 13.1999 13.8627 13.1999 13.2C13.1999 12.5373 12.6627 12 11.9999 12C11.3372 12 10.7999 12.5373 10.7999 13.2C10.7999 13.8627 11.3372 14.4 11.9999 14.4Z"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  QTP_TIMELINE: {
    format: 'markup',
    class: 'icon-qtp-timeline',
    markup: (
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12.1376 6C9.98745 6 9 7.27412 9 8.13417C9 8.75535 9.52555 9.04202 9.9556 9.04202C10.3178 9.04202 10.4653 8.8245 10.6361 8.57267C10.8708 8.22656 11.1494 7.81566 12.0898 7.81566C12.8861 7.81566 13.5232 8.16607 13.5232 8.89869C13.5232 9.60247 12.9261 10.0609 12.421 10.4486L12.421 10.4487C12.3088 10.5348 12.2012 10.6174 12.1057 10.6984C11.6439 11.0966 11.0386 11.7496 11.0386 13.1193C11.0386 13.9475 11.2616 14.1864 11.9146 14.1864C12.695 14.1864 12.8542 13.8361 12.8542 13.5334C12.8542 12.7052 12.8702 12.2274 13.7462 11.5426C14.1762 11.2081 15.53 10.1251 15.53 8.62797C15.53 7.13083 14.1762 6 12.1376 6ZM11.9305 15.2854C11.2616 15.2854 10.7201 15.8428 10.7201 16.5118C10.7201 17.1647 11.2457 17.7381 11.9305 17.7381C12.6154 17.7381 13.1569 17.1648 13.1569 16.5118C13.1569 15.8428 12.5995 15.2854 11.9305 15.2854Z"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  VERIFIED_TIMELINE: {
    format: 'markup',
    class: 'icon-verified-timeline',
    markup: (
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM18.7071 8.70711C19.0976 8.31658 19.0976 7.68342 18.7071 7.29289C18.3166 6.90237 17.6834 6.90237 17.2929 7.29289L10 14.5858L6.70711 11.2929C6.31658 10.9024 5.68342 10.9024 5.29289 11.2929C4.90237 11.6834 4.90237 12.3166 5.29289 12.7071L9.29289 16.7071C9.68342 17.0976 10.3166 17.0976 10.7071 16.7071L18.7071 8.70711Z"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  REJECTED_TIMELINE: {
    format: 'markup',
    class: 'icon-rejected-timeline',
    markup: (
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.3287 19.7429C16.6049 21.1536 14.4013 22 12 22C6.47715 22 2 17.5228 2 12C2 9.59873 2.84636 7.39514 4.25705 5.67127L18.3287 19.7429ZM19.7429 18.3287L5.67127 4.25705C7.39514 2.84636 9.59873 2 12 2C17.5228 2 22 6.47715 22 12C22 14.4013 21.1536 16.6049 19.7429 18.3287ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
        />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  VIDEO_PLAY: {
    format: 'markup',
    class: 'icon-video-play',
    markup: (
      <g>
        <path d="M19.5879 2.6897C19.3575 1.83289 18.6819 1.15747 17.8252 0.926759C16.2602 0.498535 9.99977 0.498535 9.99977 0.498535C9.99977 0.498535 3.73963 0.498535 2.17456 0.910523C1.33435 1.14099 0.642335 1.83301 0.411866 2.6897C0 4.25465 0 7.50014 0 7.50014C0 7.50014 0 10.762 0.411866 12.3106C0.642579 13.1673 1.31787 13.8427 2.17469 14.0734C3.75611 14.5017 10 14.5017 10 14.5017C10 14.5017 16.2602 14.5017 17.8252 14.0897C18.682 13.8592 19.3575 13.1837 19.5882 12.3271C19.9999 10.762 19.9999 7.51662 19.9999 7.51662C19.9999 7.51662 20.0164 4.25465 19.5879 2.6897ZM8.00661 10.4984V4.50184L13.2124 7.50014L8.00661 10.4984Z" />
      </g>
    ),
    viewBox: '0 0 20 15',
  },
  QUESTION_HAMBURGER: {
    format: 'markup',
    class: 'icon-question-hamburger',
    markup: (
      <g>
        <rect x="13" y="5" width="13" height="2" />
        <rect x="13" y="13" width="13" height="2" />
        <rect x="10" y="21" width="16" height="2" />
        <path d="M3.79053 17.5801V16.7988C3.79053 15.9036 3.95329 15.159 4.27881 14.5649C4.60433 13.9709 5.17399 13.3564 5.98779 12.7217C6.95622 11.9567 7.57878 11.3626 7.85547 10.9395C8.1403 10.5163 8.28271 10.0117 8.28271 9.42578C8.28271 8.74219 8.05485 8.21729 7.59912 7.85107C7.14339 7.48486 6.48828 7.30176 5.63379 7.30176C4.86068 7.30176 4.14453 7.41162 3.48535 7.63135C2.82617 7.85107 2.18327 8.11556 1.55664 8.4248L0.53125 6.27637C2.18327 5.35677 3.95329 4.89697 5.84131 4.89697C7.43636 4.89697 8.70182 5.2876 9.6377 6.06885C10.5736 6.8501 11.0415 7.92839 11.0415 9.30371C11.0415 9.91406 10.952 10.4593 10.7729 10.9395C10.5939 11.4115 10.3213 11.8631 9.95508 12.2944C9.59701 12.7257 8.97445 13.2873 8.0874 13.979C7.33057 14.5731 6.82194 15.0654 6.56152 15.4561C6.30924 15.8467 6.18311 16.3716 6.18311 17.0308V17.5801H3.79053ZM3.29004 21.4741C3.29004 20.2453 3.88818 19.6309 5.08447 19.6309C5.67041 19.6309 6.118 19.7936 6.42725 20.1191C6.73649 20.4365 6.89111 20.8882 6.89111 21.4741C6.89111 22.0519 6.73242 22.5117 6.41504 22.8535C6.10579 23.1872 5.66227 23.354 5.08447 23.354C4.50667 23.354 4.06315 23.1912 3.75391 22.8657C3.44466 22.5321 3.29004 22.0682 3.29004 21.4741Z" />
      </g>
    ),
    viewBox: '0 0 26 26',
  },
  POINTING_ARROW: {
    format: 'markup',
    class: 'icon-pointing-arrow',
    markup: (
      <g>
        <path d="M20.7071 0.292893C20.3166 -0.0976311 19.6834 -0.0976311 19.2929 0.292893L12.9289 6.65685C12.5384 7.04738 12.5384 7.68054 12.9289 8.07107C13.3195 8.46159 13.9526 8.46159 14.3431 8.07107L20 2.41421L25.6569 8.07107C26.0474 8.46159 26.6805 8.46159 27.0711 8.07107C27.4616 7.68054 27.4616 7.04738 27.0711 6.65685L20.7071 0.292893ZM1.1396 26.9902C4.4981 26.5167 9.45193 24.6446 13.5774 20.5734C17.7302 16.4753 21 10.1904 21 1L19 1C19 9.66674 15.9365 15.4354 12.1726 19.1498C8.3814 22.8911 3.83523 24.5904 0.860403 25.0098L1.1396 26.9902Z" />
      </g>
    ),
    viewBox: '0 0 28 27',
  },
  ACTIVITY: {
    format: 'markup',
    class: 'icon-activity',
    markup: (
      <g>
        <path
          d="M4 16.5L4 20.5L20 20.5L20 16.5M4 8.5L4 4.5L20 4.5L20 8.5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 12.5H6L8 9.49997L10.5 17L13.5 7.5L16.5 15.5L18 12.5H20"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
    viewBox: '0 0 24 25',
  },
  HAMBURGER: {
    format: 'markup',
    class: 'icon-hamburger',
    markup: (
      <g>
        <path d="M5 8.5C4.44771 8.5 4 8.05228 4 7.5C4 6.94771 4.44772 6.5 5 6.5L19 6.50002C19.5523 6.50002 20 6.94774 20 7.50002C20 8.05231 19.5523 8.50002 19 8.50002L5 8.5Z" />
        <path d="M4.00001 12.5C4 13.0523 4.44772 13.5 5 13.5L19 13.5C19.5523 13.5 20 13.0523 20 12.5C20 11.9477 19.5523 11.5 19 11.5L5.00001 11.5C4.44772 11.5 4.00001 11.9477 4.00001 12.5Z" />
        <path d="M4.00001 17.5C4.00001 18.0523 4.44773 18.5 5.00001 18.5L19 18.5C19.5523 18.5 20 18.0523 20 17.5C20 16.9477 19.5523 16.5 19 16.5L5.00001 16.5C4.44773 16.5 4.00001 16.9477 4.00001 17.5Z" />
      </g>
    ),
    viewBox: '0 0 24 25',
  },
  VIDEO: {
    format: 'markup',
    class: 'icon-video',
    markup: (
      <g>
        <rect
          x="0.666667"
          y="0.666667"
          width="14.6667"
          height="14.6667"
          rx="2"
          strokeWidth="1.33333"
        />
        <path d="M10.5855 7.72256C10.7829 7.85455 10.7829 8.1448 10.5855 8.27679L6.76859 10.8284C6.5471 10.9765 6.25 10.8177 6.25 10.5513L6.25 5.44804C6.25 5.18162 6.5471 5.02286 6.76859 5.17093L10.5855 7.72256Z" />
      </g>
    ),
    viewBox: '0 0 16 16',
  },
  CURATION: {
    format: 'markup',
    class: 'icon-curation',
    markup: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1"
          y="13.5"
          width="4"
          height="8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 14.5H7.09333C7.69289 14.5 8.28756 14.6078 8.84894 14.8184L11.1511 15.6816C11.7124 15.8922 12.3071 16 12.9067 16H15C15.5 16 16.5 16.3 16.5 17.5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 20.5H5.15229C6.03301 20.5 6.89601 20.7475 7.64286 21.2143L9.3117 22.2573C10.0882 22.7427 10.9856 23 11.9013 23V23C12.6247 23 13.3391 22.8394 13.9929 22.5297L21.4301 19.0068C22.0173 18.7287 22.2611 18.0222 21.9706 17.4411V17.4411C21.7037 16.9073 21.075 16.6635 20.5179 16.8777L15 19H10.5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 14.5V2.5H8V11"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 4.5H4V11"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 5.5H12"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 5.5H17"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 8.5H17"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 11.5H14"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    viewBox: '0 0 24 25',
  },
  LIST_TEXT: {
    format: 'markup',
    class: 'icon-list-text',
    markup: (
      <g>
        <path d="M21.002 3.74854H6.00728C5.17915 3.74854 4.50781 4.41988 4.50781 5.24801C4.50781 6.07614 5.17915 6.74748 6.00728 6.74748H21.002C21.8301 6.74748 22.5015 6.07614 22.5015 5.24801C22.5015 4.41988 21.8301 3.74854 21.002 3.74854Z" />
        <path d="M3.00735 5.24804C3.00566 4.85101 2.84657 4.47085 2.565 4.19091C1.98016 3.60954 1.03559 3.60954 0.450744 4.19091C0.169124 4.47085 0.0100394 4.85101 0.00839939 5.24804C-0.0027998 5.34518 -0.0027998 5.4433 0.00839939 5.54044C0.0253622 5.63814 0.0530087 5.73368 0.0908704 5.82534C0.131122 5.91414 0.178777 5.99942 0.23332 6.08025C0.287161 6.16431 0.349998 6.24224 0.420754 6.31267C0.48898 6.38061 0.564376 6.44097 0.645675 6.4926C0.724632 6.5501 0.810243 6.59794 0.900586 6.63505C0.999973 6.6866 1.10592 6.72446 1.21548 6.74751C1.31261 6.75839 1.41073 6.75839 1.50787 6.74751C1.90383 6.74784 2.28385 6.59152 2.565 6.31267C2.63576 6.24224 2.69859 6.16431 2.75243 6.08025C2.80698 5.99942 2.85463 5.91414 2.89488 5.82534C2.94273 5.73481 2.98045 5.63926 3.00735 5.54044C3.01854 5.4433 3.01854 5.34518 3.00735 5.24804Z" />
        <path d="M3.00676 11.9956C3.01791 11.8985 3.01791 11.8003 3.00676 11.7032C2.98085 11.6064 2.94308 11.5133 2.8943 11.4258C2.85569 11.3338 2.80794 11.2459 2.75185 11.1634C2.69988 11.0803 2.63681 11.0046 2.56441 10.9385C1.97957 10.3571 1.035 10.3571 0.450157 10.9385C0.168537 11.2184 0.00945255 11.5986 0.0078125 11.9956C0.0107177 12.1932 0.0488137 12.3886 0.120273 12.5729C0.157853 12.6616 0.203025 12.7469 0.255226 12.8278C0.312252 12.9093 0.377573 12.9847 0.450157 13.0527C0.516415 13.125 0.592045 13.1881 0.675078 13.2402C0.754035 13.2977 0.839598 13.3455 0.929988 13.3826C1.02141 13.4211 1.11705 13.4488 1.21489 13.4651C1.31081 13.4866 1.40898 13.4967 1.50729 13.4951C1.60442 13.5063 1.70254 13.5063 1.79968 13.4951C1.89509 13.4787 1.98824 13.451 2.07709 13.4126C2.16991 13.3758 2.25801 13.3279 2.33949 13.2702C2.42253 13.218 2.49816 13.155 2.56441 13.0827C2.63667 13.0165 2.69974 12.9408 2.75185 12.8578C2.80948 12.7789 2.85733 12.6933 2.8943 12.6029C2.94551 12.5034 2.98333 12.3975 3.00676 12.288C3.01829 12.1909 3.01829 12.0927 3.00676 11.9956Z" />
        <path d="M3.00685 18.7436C3.01796 18.6465 3.01796 18.5484 3.00685 18.4512C2.98094 18.3521 2.94317 18.2565 2.89439 18.1663C2.85414 18.0776 2.80648 17.9923 2.75194 17.9114C2.69983 17.8284 2.63676 17.7528 2.56451 17.6865C1.97966 17.1051 1.03509 17.1051 0.450249 17.6865C0.377993 17.7528 0.314921 17.8284 0.262815 17.9114C0.208271 17.9923 0.160616 18.0776 0.120365 18.1663C0.0814723 18.2576 0.0537789 18.3533 0.0378939 18.4512C0.0167607 18.5473 0.00673295 18.6453 0.00790442 18.7436C0.00959132 19.1407 0.168676 19.5208 0.450249 19.8008C0.516507 19.873 0.592137 19.9361 0.67517 19.9882C0.754126 20.0458 0.83969 20.0936 0.93008 20.1307C1.0215 20.1691 1.11714 20.1968 1.21498 20.2131C1.3109 20.2346 1.40907 20.2447 1.50738 20.2431C1.60451 20.2543 1.70264 20.2543 1.79977 20.2431C1.89518 20.2268 1.98833 20.1991 2.07718 20.1606C2.17 20.1238 2.2581 20.076 2.33958 20.0182C2.42262 19.9661 2.49825 19.903 2.56451 19.8308C2.63676 19.7645 2.69983 19.6889 2.75194 19.6058C2.80962 19.527 2.85746 19.4414 2.89439 19.3509C2.94556 19.2514 2.98337 19.1455 3.00685 19.036C3.01838 18.9389 3.01838 18.8408 3.00685 18.7436Z" />
        <path d="M22.5015 10.4961H6.00728C5.17915 10.4961 4.50781 11.1674 4.50781 11.9956C4.50781 12.8237 5.17915 13.495 6.00728 13.495H22.5015C23.3296 13.495 24.001 12.8237 24.001 11.9956C24.001 11.1674 23.3296 10.4961 22.5015 10.4961Z" />
        <path d="M15.7539 17.2441H6.00728C5.17915 17.2441 4.50781 17.9155 4.50781 18.7436C4.50781 19.5717 5.17915 20.2431 6.00728 20.2431H15.7539C16.582 20.2431 17.2533 19.5717 17.2533 18.7436C17.2533 17.9155 16.582 17.2441 15.7539 17.2441Z" />
      </g>
    ),
    viewBox: '0 0 24 24',
  },
  CHARGE: {
    format: 'markup',
    class: 'icon-charge',
    markup: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0764 22C10.0061 22 9.93489 21.986 9.86692 21.9568C9.629 21.8546 9.50032 21.5959 9.56279 21.3454L11.353 14.1673H6.52941C6.35481 14.1673 6.19143 14.0816 6.09272 13.9381C5.994 13.7946 5.97268 13.6119 6.03565 13.4497L9.57429 4.33711C9.65318 4.13394 9.84934 4 10.0681 4H14.9373C15.1162 4 15.283 4.09 15.3808 4.23927C15.4785 4.38855 15.4939 4.57688 15.4218 4.73997L13.3264 9.4776H17.4706C17.6642 9.4776 17.8424 9.5829 17.9352 9.75214C18.028 9.92138 18.0207 10.1276 17.916 10.2899L10.522 21.7576C10.4221 21.9127 10.252 22 10.0764 22V22Z"
          fill="#F23C51"
        />
      </svg>
    ),
    viewBox: '0 0 24 25',
  },
  ANALYTICS_CHANNEL: {
    format: 'markup',
    markup: (
      <svg
        width="67"
        height="67"
        viewBox="0 0 67 67"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="33.5" cy="33.5" r="33.5" fill="#E0F2F1" />
        <rect
          opacity="0.3"
          x="22"
          y="24"
          width="29"
          height="24"
          rx="2"
          fill="#26A69A"
        />
        <rect
          x="18.666"
          y="21.333"
          width="26.6667"
          height="21.3333"
          stroke="#26A69A"
          strokeWidth="2.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.333 35.9995V27.9995L35.9997 31.9995L29.333 35.9995Z"
          fill="#26A69A"
          stroke="#26A69A"
          strokeWidth="2.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    viewBox: '0 0 67 67',
  },
  ANALYTICS_BROWSER: {
    format: 'markup',
    markup: (
      <svg
        width="67"
        height="67"
        viewBox="0 0 67 67"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="33.5" cy="33.5" r="33.5" fill="#E1F4FF" />
        <path
          d="M46.8058 40.1944L37.4727 30.8613C37.282 30.6706 36.998 30.6133 36.746 30.7173C36.4967 30.82 36.334 31.0626 36.334 31.3333V44.6663C36.334 44.9356 36.4967 45.1796 36.746 45.2823C36.9967 45.3863 37.2807 45.329 37.4727 45.1383L39.4926 43.1183L41.1286 46.305C41.2099 46.4637 41.3513 46.5823 41.5219 46.637C41.5872 46.657 41.6552 46.6677 41.7219 46.6677C41.8299 46.6677 41.9379 46.641 42.0339 46.589L44.6458 45.201C44.9671 45.0317 45.0925 44.6357 44.9271 44.3117L43.4192 41.3331H46.3338C46.6031 41.3331 46.8471 41.1704 46.9498 40.9211C47.0538 40.6718 46.9965 40.3851 46.8058 40.1944Z"
          fill="#0288D1"
        />
        <path
          d="M34.3329 43.9995H18.3332C17.2306 43.9995 16.3333 43.1022 16.3333 41.9995V22.6665H45.666V36.6662C45.666 37.0342 45.9647 37.3329 46.3327 37.3329C46.7007 37.3329 46.9994 37.0342 46.9994 36.6662V19.3332C46.9994 17.496 45.5034 16 43.6661 16H18.3332C16.496 16 15 17.496 15 19.3332V41.9995C15 43.8368 16.496 45.3327 18.3332 45.3327H34.3329C34.7009 45.3327 34.9996 45.0341 34.9996 44.6661C34.9996 44.2981 34.7009 43.9995 34.3329 43.9995ZM23.6665 18.6666C24.0345 18.6666 24.3332 18.9653 24.3332 19.3332C24.3332 19.7012 24.0345 19.9999 23.6665 19.9999C23.2985 19.9999 22.9998 19.7012 22.9998 19.3332C22.9998 18.9653 23.2985 18.6666 23.6665 18.6666ZM20.9999 18.6666C21.3679 18.6666 21.6666 18.9653 21.6666 19.3332C21.6666 19.7012 21.3679 19.9999 20.9999 19.9999C20.6319 19.9999 20.3332 19.7012 20.3332 19.3332C20.3332 18.9653 20.6319 18.6666 20.9999 18.6666ZM18.3332 18.6666C18.7012 18.6666 18.9999 18.9653 18.9999 19.3332C18.9999 19.7012 18.7012 19.9999 18.3332 19.9999C17.9653 19.9999 17.6666 19.7012 17.6666 19.3332C17.6666 18.9653 17.9653 18.6666 18.3332 18.6666Z"
          fill="#0288D1"
        />
        <rect
          opacity="0.3"
          x="20"
          y="21.334"
          width="32"
          height="29"
          rx="2"
          fill="#0288D1"
        />
      </svg>
    ),
    viewBox: '0 0 67 67',
  },
  ANALYTICS_PHONE: {
    format: 'markup',
    markup: (
      <svg
        width="67"
        height="67"
        viewBox="0 0 67 67"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="33.5" cy="33.5" r="33.5" fill="#F3ECFF" />
        <rect
          opacity="0.3"
          x="26.3994"
          y="20"
          width="20"
          height="32"
          rx="2"
          fill="#7E57C2"
        />
        <path
          d="M38.6 15H24.2C22.44 15 21 16.44 21 18.2V43.8C21 45.56 22.44 47 24.2 47H38.6C40.36 47 41.8 45.56 41.8 43.8V18.2C41.8 16.44 40.36 15 38.6 15ZM32.2 43.8H30.6C29.8 43.8 29 43.16 29 42.2C29 41.4 29.8 40.6 30.6 40.6H32.2C33.16 40.6 33.8 41.4 33.8 42.2C33.8 43.16 33.16 43.8 32.2 43.8ZM38.6 37.4H24.2V18.2H38.6V37.4Z"
          fill="#7E57C2"
        />
      </svg>
    ),
    viewBox: '0 0 67 67',
  },
  ANALYTICS_EMAIL: {
    format: 'markup',
    markup: (
      <svg
        width="67"
        height="67"
        viewBox="0 0 67 67"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="33.5" cy="33.5" r="33.5" fill="#FFEFF5" />
        <rect
          opacity="0.3"
          x="19"
          y="23.9834"
          width="32"
          height="24"
          rx="2"
          fill="#D81B60"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.3658 34.0291L16.2531 25.287C15.4685 24.7642 15 23.8892 15 22.9464C15 21.3211 16.3211 20.0001 17.9448 20H44.0552C45.6789 20 47 21.321 47 22.9448C47 23.8892 46.5316 24.7642 45.7469 25.287L32.6342 34.0291C32.1378 34.36 31.5689 34.5255 30.9999 34.5255C30.4311 34.5255 29.8622 34.3601 29.3658 34.0291ZM31 36.4008C31.9534 36.4008 32.8782 36.1202 33.6743 35.5895L46.7864 26.8477C46.8594 26.7991 46.9304 26.7484 46.9999 26.6963V41.0212C46.9999 42.6342 45.6965 43.967 44.0541 43.967H17.9458C16.3328 43.967 15 42.6635 15 41.0212V26.6964C15.0694 26.7484 15.1403 26.7989 15.2131 26.8474L28.3258 35.5895C29.1219 36.1202 30.0466 36.4008 31 36.4008Z"
          fill="#D81B60"
        />
      </svg>
    ),
    viewBox: '0 0 67 67',
  },
  COMMUNITY_EVIDENCE: {
    format: 'markup',
    markup: (
      <svg
        width="67"
        height="67"
        viewBox="0 0 67 67"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="33.5" cy="33.5" r="33.5" fill="#E0F2F1" />
        <path
          d="M47.167 33.9998C47.167 41.8239 40.8244 48.1665 33.0003 48.1665C25.1763 48.1665 18.8337 41.8239 18.8337 33.9998C18.8337 26.1758 25.1763 19.8332 33.0003 19.8332C40.8244 19.8332 47.167 26.1758 47.167 33.9998Z"
          stroke="#26A69A"
          strokeWidth="2.83333"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.9997 36.8333C33.7821 36.8333 34.4163 36.1991 34.4163 35.4167C34.4163 34.6343 33.7821 34 32.9997 34C32.2173 34 31.583 34.6343 31.583 35.4167C31.583 36.1991 32.2173 36.8333 32.9997 36.8333Z"
          fill="#26A69A"
        />
        <path
          d="M25.917 38.2498L33.0003 26.9165L40.0837 38.2498"
          stroke="#26A69A"
          strokeWidth="2.83333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    viewBox: '0 0 67 67',
  },
  COMMUNITY_QUESTIONS: {
    format: 'markup',
    markup: (
      <svg
        width="67"
        height="67"
        viewBox="0 0 67 67"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="33.5" cy="33.5" r="33.5" fill="#E1F4FF" />
        <circle
          cx="33.0003"
          cy="33.9998"
          r="14.1667"
          stroke="#0288D1"
          strokeWidth="2.83333"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.75 28.5234C28.75 27.305 30.1489 25.5 33.1949 25.5C36.0829 25.5 38.0008 27.102 38.0008 29.223C38.0008 31.3439 36.0829 32.8782 35.4738 33.352C34.2328 34.3222 34.2102 34.9991 34.2102 36.1724C34.2102 36.6011 33.9846 37.0974 32.879 37.0974C31.9539 37.0974 31.6381 36.759 31.6381 35.5857C31.6381 33.6453 32.4955 32.7202 33.1498 32.1561C33.2851 32.0413 33.4376 31.9242 33.5965 31.8022C34.3119 31.253 35.1579 30.6035 35.1579 29.6065C35.1579 28.5686 34.2554 28.0722 33.1272 28.0722C31.795 28.0722 31.4003 28.6543 31.0678 29.1446C30.8259 29.5014 30.6169 29.8095 30.1038 29.8095C29.4945 29.8095 28.75 29.4034 28.75 28.5234ZM31.1863 40.3913C31.1863 39.4437 31.9535 38.654 32.901 38.654C33.8488 38.654 34.6384 39.4437 34.6384 40.3913C34.6384 41.3164 33.8712 42.1287 32.901 42.1287C31.9309 42.1287 31.1863 41.3164 31.1863 40.3913Z"
          fill="#0288D1"
        />
      </svg>
    ),
    viewBox: '0 0 67 67',
  },
  COMMUNITY_REVIEWS: {
    format: 'markup',
    markup: (
      <svg
        width="67"
        height="67"
        viewBox="0 0 67 67"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="33.5" cy="33.5" r="33.5" fill="#F3ECFF" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.7917 43.9165C26.5301 43.9165 28.75 41.6966 28.75 38.9582C28.75 36.2198 26.5301 33.9998 23.7917 33.9998C21.0533 33.9998 18.8333 36.2198 18.8333 38.9582C18.8333 41.6966 21.0533 43.9165 23.7917 43.9165ZM23.7917 46.7498C28.0949 46.7498 31.5833 43.2614 31.5833 38.9582C31.5833 37.8798 31.3643 36.8526 30.9682 35.9186C31.8544 35.5564 32.5426 35.4132 33.1613 35.4167C33.7365 35.42 34.3329 35.5506 35.0561 35.8621C34.6447 36.8111 34.4167 37.8581 34.4167 38.9583C34.4167 43.2616 37.9051 46.75 42.2083 46.75C46.5116 46.75 50 43.2616 50 38.9583C50 34.6551 46.5116 31.1667 42.2083 31.1667C40.0392 31.1667 38.0772 32.053 36.6645 33.4833C35.5127 32.9241 34.3894 32.5903 33.1773 32.5834C31.925 32.5764 30.6993 32.9194 29.3731 33.5215C27.9578 32.0687 25.9801 31.1665 23.7917 31.1665C19.4884 31.1665 16 34.655 16 38.9582C16 43.2614 19.4884 46.7498 23.7917 46.7498ZM42.2083 43.9167C44.9467 43.9167 47.1667 41.6967 47.1667 38.9583C47.1667 36.2199 44.9467 34 42.2083 34C39.4699 34 37.25 36.2199 37.25 38.9583C37.25 41.6967 39.4699 43.9167 42.2083 43.9167Z"
          fill="#7E57C2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.5408 25.6107C25.2334 25.6756 24.9792 25.7702 24.8102 25.8471C21.0824 30.3445 18.8333 35.2483 18.8333 38.9582C18.8333 40.7853 16 40.7853 16 38.9582C16 34.226 18.796 28.5917 22.818 23.8125L22.9689 23.6332L23.1696 23.512C23.8968 23.0728 25.7144 22.3626 27.6426 22.8893C28.3974 23.0954 28.8422 23.8744 28.636 24.6291C28.4299 25.3839 27.6509 25.8286 26.8962 25.6225C26.455 25.502 25.982 25.5176 25.5408 25.6107ZM35.2704 28.6314C35.5723 28.5455 35.8411 28.5105 36.0264 28.4997C38.6403 29.589 41.0872 31.031 43.049 32.655C45.0893 34.344 46.5164 36.1557 47.1425 37.8876C47.4085 38.6234 48.2206 39.0042 48.9564 38.7382C49.6922 38.4721 50.0731 37.66 49.807 36.9242C48.9467 34.5445 47.1152 32.3429 44.8558 30.4725C42.581 28.5894 39.782 26.9662 36.8402 25.7708L36.623 25.6825L36.389 25.6689C35.5408 25.6196 33.6018 25.8392 32.1418 27.2044C31.5703 27.7388 31.5403 28.6353 32.0746 29.2068C32.609 29.7783 33.5055 29.8083 34.077 29.274C34.411 28.9616 34.8367 28.7548 35.2704 28.6314Z"
          fill="#7E57C2"
        />
      </svg>
    ),
    viewBox: '0 0 67 67',
  },
  SPEEDOMETER: {
    format: 'markup',
    markup: (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_13551:243503)">
          <path
            d="M9.41414 3.31645V1.87305C7.15547 2.0027 5.03734 2.88039 3.34668 4.38715L5.96137 7.00184C6.57266 6.49293 7.26535 6.10922 8.00781 5.86359C8.1207 5.33445 8.21848 4.88965 8.28414 4.59418C8.41977 3.98379 8.85355 3.51215 9.41414 3.31645Z"
            fill="#26A69A"
          />
          <path
            d="M5.13293 7.82997L2.51828 5.21533C1.01023 6.90552 0.131445 9.0238 0.000976562 11.283H3.6993C3.81648 10.0088 4.31258 8.81388 5.13293 7.82997Z"
            fill="#26A69A"
          />
          <path
            d="M16.3008 11.283H19.9991C19.8687 9.0238 18.9899 6.90552 17.4818 5.21533L14.8672 7.82997C15.6875 8.81384 16.1836 10.0088 16.3008 11.283Z"
            fill="#26A69A"
          />
          <path
            d="M16.301 12.4551C16.1072 14.5839 14.9386 15.8828 14.4746 16.3467C14.2454 16.5759 14.2454 16.9475 14.4746 17.1768L16.2525 18.9547C16.3671 19.0693 16.5173 19.1266 16.6675 19.1266C16.8177 19.1266 16.9679 19.0693 17.0825 18.9547C18.8373 17.2 19.8606 14.9104 20.0006 12.4551H16.301Z"
            fill="#26A69A"
          />
          <path
            d="M3.69961 12.4551H0C0.140039 14.9104 1.16328 17.2 2.91809 18.9547C3.0327 19.0693 3.18289 19.1266 3.33309 19.1266C3.48328 19.1266 3.63352 19.0693 3.74813 18.9547L5.52594 17.1768C5.75512 16.9476 5.75512 16.5759 5.52594 16.3467C5.06199 15.8828 3.89336 14.5839 3.69961 12.4551Z"
            fill="#26A69A"
          />
          <path
            d="M10.5859 1.87305V3.31648C11.1465 3.51219 11.5803 3.98383 11.7159 4.59426C11.7816 4.88973 11.8794 5.33449 11.9923 5.86363C12.7347 6.1093 13.4274 6.49297 14.0387 7.00187L16.6534 4.38719C14.9627 2.88035 12.8446 2.0027 10.5859 1.87305Z"
            fill="#26A69A"
          />
          <path
            d="M9.99938 4.38965C9.72477 4.38965 9.48695 4.58039 9.42738 4.84848C9.29746 5.43305 8.1582 10.5967 8.1582 11.8792C8.1582 12.8944 8.98414 13.7204 9.99934 13.7204C11.0145 13.7204 11.8405 12.8944 11.8405 11.8792C11.8405 10.5967 10.7012 5.43305 10.5713 4.84848C10.5118 4.58039 10.274 4.38965 9.99938 4.38965Z"
            fill="#26A69A"
          />
        </g>
        <defs>
          <clipPath id="clip0_13551:243503">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    viewBox: '0 0 20 21',
  },
  BULB: {
    format: 'markup',
    markup: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2C12.3282 2 12.5859 2.25777 12.5859 2.58594V4.96875C12.5859 5.29684 12.3282 5.55469 12 5.55469C11.6718 5.55469 11.4141 5.29684 11.4141 4.96875V2.58594C11.4141 2.25777 11.6718 2 12 2ZM4.95672 5.78519C4.72786 5.55633 4.72786 5.18551 4.95672 4.95664C5.18559 4.72777 5.55641 4.72777 5.78528 4.95664L7.44239 6.61375C7.67125 6.84262 7.67125 7.21344 7.44239 7.4423C7.21352 7.67121 6.84274 7.67121 6.61383 7.4423L4.95672 5.78519ZM10.7343 6.87891C11.1563 6.7734 11.5781 6.72656 12 6.72656C14.8828 6.72656 17.2734 9.04684 17.2734 12C17.2734 13.4062 16.7227 14.7304 15.7383 15.7265C15.2226 16.2304 14.9297 16.9687 14.9297 17.7305V17.8594C14.9297 18.3813 14.7036 18.8605 14.3438 19.1925V20.2422C14.3438 21.2148 13.5586 22 12.5859 22H12H11.4141C10.4414 22 9.65625 21.2148 9.65625 20.2422V19.1926C9.29639 18.8605 9.07029 18.3813 9.07029 17.8594V17.7305C9.07029 16.957 8.78904 16.2422 8.30854 15.7617C6.96092 14.4375 6.43358 12.539 6.89061 10.6641C7.34768 8.80074 8.85936 7.3125 10.7343 6.87891ZM2.58594 12.5859H4.96875C5.29262 12.5859 5.55469 12.3238 5.55469 11.9999C5.55469 11.676 5.29262 11.414 4.96875 11.414H2.58594C2.26207 11.414 2 11.676 2 11.9999C2 12.3238 2.26207 12.5859 2.58594 12.5859ZM21.4143 12.5859H19.0315C18.7076 12.5859 18.4455 12.3238 18.4455 11.9999C18.4455 11.676 18.7076 11.414 19.0315 11.414H21.4143C21.7381 11.414 22.0002 11.676 22.0002 11.9999C22.0002 12.3238 21.7381 12.5859 21.4143 12.5859ZM16.5576 6.61383C16.3287 6.8427 16.3287 7.21352 16.5576 7.44239C16.7865 7.67129 17.1572 7.67129 17.3862 7.44239L19.0433 5.78528C19.2721 5.55641 19.2721 5.18559 19.0433 4.95672C18.8144 4.72786 18.4436 4.72786 18.2147 4.95672L16.5576 6.61383Z"
          fill="#FFAB48"
        />
      </svg>
    ),
    viewBox: '0 0 24 25',
  },
  FILLED_GREEN_CHECK: {
    format: 'markup',
    markup: (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_13571:241247)">
          <path
            d="M10 0.5C4.48578 0.5 0 4.98578 0 10.5C0 16.0142 4.48578 20.5 10 20.5C15.5142 20.5 20 16.0142 20 10.5C20 4.98578 15.5142 0.5 10 0.5Z"
            fill="#26A69A"
          />
          <path
            d="M15.0682 8.38074L9.65152 13.7973C9.48901 13.9598 9.2757 14.0416 9.06238 14.0416C8.84906 14.0416 8.63574 13.9598 8.47324 13.7973L5.76495 11.089C5.43903 10.7632 5.43903 10.2365 5.76495 9.91074C6.09073 9.58481 6.61731 9.58481 6.94324 9.91074L9.06238 12.0299L13.89 7.20245C14.2157 6.87653 14.7423 6.87653 15.0682 7.20245C15.394 7.52823 15.394 8.05481 15.0682 8.38074Z"
            fill="#FAFAFA"
          />
        </g>
        <defs>
          <clipPath id="clip0_13571:241247">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    viewBox: '0 0 20 21',
  },
  ZOOM_IN: {
    format: 'markup',
    markup: (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_13551:243791)">
          <path
            d="M19.6144 17.9219L16.7317 15.045C16.4566 14.7699 16.082 14.6411 15.719 14.6587L14.3318 13.2714C16.6936 10.1487 16.4536 5.68259 13.6089 2.83497C10.4979 -0.276044 5.44943 -0.276044 2.33841 2.84083C-0.778495 5.95769 -0.778495 11.0003 2.33256 14.1114C5.18021 16.959 9.64629 17.1961 12.769 14.8343L14.1562 16.2215C14.1387 16.5844 14.2675 16.959 14.5426 17.2342L17.4195 20.111C17.9346 20.6261 18.7745 20.6261 19.2896 20.111L19.6086 19.792C20.1295 19.2769 20.1295 18.4428 19.6144 17.9219ZM11.8851 12.3876C9.72525 14.5474 6.21621 14.5533 4.05634 12.3934C1.89647 10.2336 1.89647 6.73037 4.06219 4.56461C6.22207 2.40473 9.73115 2.39888 11.891 4.55875C14.0509 6.71863 14.0421 10.2219 11.8851 12.3876Z"
            fill="#26A69A"
          />
          <path
            d="M10.1411 7.6433H8.83577V6.33801C8.83577 5.86683 8.45531 5.48633 7.98999 5.48633H7.98123C7.51587 5.48633 7.13544 5.86679 7.13544 6.33801V7.6433H5.83015C5.35898 7.6433 4.97852 8.02376 4.97852 8.48912V8.49498C4.97852 8.96034 5.35898 9.34076 5.83015 9.34076H7.13544V10.6461C7.13544 11.1173 7.51591 11.4977 7.98123 11.4977H7.98708C8.4524 11.4977 8.83286 11.1173 8.83286 10.6461V9.34076H10.1382C10.6093 9.34076 10.9898 8.9603 10.9898 8.49498V8.48912C10.9956 8.02376 10.6152 7.6433 10.1411 7.6433Z"
            fill="#26A69A"
          />
        </g>
        <defs>
          <clipPath id="clip0_13551:243791">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    viewBox: '0 0 20 21',
  },
  NEW_TAB: {
    format: 'markup',
    class: 'icon-new-tab',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
      </g>
    ),
  },
  DOLLAR: {
    format: 'markup',
    class: 'dollar',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <path
          d="M12 0C5.37284 0 0 5.37284 0 12C0 18.6272 5.37284 24 12 24C18.6272 24 24 18.6272 24 12C24 5.37284 18.6272 0 12 0ZM15.4469 16.7309C14.9235 17.3679 14.242 17.7975 13.4469 18.0148C13.1012 18.1086 12.9432 18.2914 12.963 18.6519C12.9778 19.0074 12.963 19.358 12.958 19.7136C12.958 20.0296 12.7951 20.1975 12.484 20.2074C12.2815 20.2123 12.079 20.2173 11.8765 20.2173C11.6988 20.2173 11.521 20.2173 11.3432 20.2123C11.0074 20.2074 10.8494 20.0148 10.8494 19.6889C10.8444 19.4321 10.8444 19.1704 10.8444 18.9136C10.8395 18.3407 10.8198 18.321 10.2716 18.2321C9.57037 18.1185 8.87901 17.9605 8.23704 17.6494C7.73333 17.4025 7.67901 17.279 7.82222 16.7457C7.93086 16.3506 8.03951 15.9556 8.16296 15.5654C8.25185 15.279 8.3358 15.1506 8.48889 15.1506C8.57778 15.1506 8.69136 15.1951 8.84445 15.2741C9.55556 15.6444 10.3111 15.8519 11.1062 15.9506C11.2395 15.9654 11.3728 15.9753 11.5062 15.9753C11.8765 15.9753 12.237 15.9062 12.5877 15.7531C13.4716 15.3679 13.6099 14.3457 12.8642 13.7333C12.6123 13.5259 12.321 13.3728 12.0198 13.2395C11.2444 12.8988 10.4395 12.642 9.70864 12.2025C8.52346 11.4914 7.77284 10.5185 7.86173 9.07654C7.96049 7.44691 8.88395 6.42963 10.3802 5.88642C10.9975 5.6642 11.0025 5.66914 11.0025 5.02716C11.0025 4.80988 10.9975 4.59259 11.0074 4.37037C11.0222 3.88642 11.1012 3.80247 11.5852 3.78765C11.6395 3.78765 11.6988 3.78765 11.7531 3.78765C11.8469 3.78765 11.9407 3.78765 12.0346 3.78765C12.0741 3.78765 12.1136 3.78765 12.1481 3.78765C13.0667 3.78765 13.0667 3.82716 13.0716 4.81975C13.0765 5.55062 13.0765 5.55062 13.8025 5.6642C14.3605 5.75309 14.8889 5.91605 15.4025 6.14321C15.684 6.26667 15.7926 6.4642 15.7037 6.76543C15.5753 7.20988 15.4519 7.65926 15.3136 8.09877C15.2247 8.36543 15.1407 8.48889 14.9827 8.48889C14.8938 8.48889 14.7852 8.45432 14.6469 8.38519C13.9358 8.03951 13.1901 7.8716 12.4099 7.8716C12.3111 7.8716 12.2074 7.87654 12.1086 7.88148C11.8765 7.8963 11.6494 7.92593 11.4321 8.01975C10.6617 8.35556 10.5383 9.20494 11.1951 9.7284C11.5259 9.99506 11.9062 10.1827 12.2963 10.3457C12.9778 10.6272 13.6593 10.8988 14.3062 11.2543C16.3407 12.3901 16.8938 14.9728 15.4469 16.7309Z"
          fill="#FFB400"
        />
      </g>
    ),
  },
  LOGOUT: {
    format: 'markup',
    class: 'logout',
    viewBox: '0 0 48 48',
    markup: (
      <g>
        <path d="M18.75 22.5H36.15L31.05 17.4L33.2 15.25L42 24.05L33.3 32.75L31.15 30.6L36.25 25.5H18.75ZM23.55 6V9H9Q9 9 9 9Q9 9 9 9V39Q9 39 9 39Q9 39 9 39H23.55V42H9Q7.8 42 6.9 41.1Q6 40.2 6 39V9Q6 7.8 6.9 6.9Q7.8 6 9 6Z" />
      </g>
    ),
  },
  FLAG: {
    format: 'markup',
    class: 'flag',
    viewBox: '0 0 48 48',
    markup: (
      <g>
        <path d="M10 42V8H27.15L28.1 12.3H40V30.8H27.2L26.25 26.55H13V42ZM25 19.4ZM29.75 27.8H37V15.3H25.55L24.6 11H13V23.55H28.8Z" />
      </g>
    ),
  },
  ALGORITHM: {
    format: 'markup',
    class: 'flag',
    viewBox: '0 0 48 48',
    markup: (
      <g>
        <path d="M18.45 42V35.65H14.9Q13.7 35.65 12.8 34.75Q11.9 33.85 11.9 32.65V27.1H9.9Q8.9 27.1 8.4 26.175Q7.9 25.25 8.45 24.2L11.9 18Q13.2 12.55 17.025 9.275Q20.85 6 26 6Q31.75 6 35.875 10.125Q40 14.25 40 20Q40 24.25 37.65 27.5Q35.3 30.75 31.25 32.7V42ZM21.45 39H28.25V30.75L29.65 30.1Q33 28.55 35 25.875Q37 23.2 37 20Q37 15.45 33.775 12.225Q30.55 9 26 9Q21.55 9 18.425 11.975Q15.3 14.95 15.05 18.6L12 24.1H14.9V32.65H21.45ZM24.45 27.3H27.45L27.6 25.1Q28.3 24.95 28.8 24.625Q29.3 24.3 29.65 23.95L31.75 24.65L33.15 22.25L31.65 21.05Q31.9 20.35 31.9 19.6Q31.9 18.85 31.65 18.15L33.15 16.95L31.75 14.55L29.65 15.25Q29.3 14.9 28.775 14.6Q28.25 14.3 27.6 14.1L27.45 11.9H24.45L24.3 14.1Q23.65 14.3 23.125 14.6Q22.6 14.9 22.25 15.25L20.15 14.55L18.75 16.95L20.25 18.15Q20 18.85 20 19.6Q20 20.35 20.25 21.05L18.75 22.25L20.15 24.65L22.25 23.95Q22.6 24.3 23.1 24.625Q23.6 24.95 24.3 25.1ZM25.95 23.1Q24.5 23.1 23.475 22.075Q22.45 21.05 22.45 19.6Q22.45 18.15 23.475 17.125Q24.5 16.1 25.95 16.1Q27.4 16.1 28.425 17.125Q29.45 18.15 29.45 19.6Q29.45 21.05 28.425 22.075Q27.4 23.1 25.95 23.1ZM24.5 24Q24.5 24 24.5 24Q24.5 24 24.5 24Q24.5 24 24.5 24Q24.5 24 24.5 24Q24.5 24 24.5 24Q24.5 24 24.5 24Z" />
      </g>
    ),
  },
  RECLASSIFY: {
    format: 'markup',
    class: 'reclassify',
    viewBox: '0 0 48 48',
    markup: (
      <g>
        <path d="M30.5 42.5V31.05H33.5V37.5Q36.7 34.9 38.6 31.4Q40.5 27.9 40.5 24Q40.5 17.4 36.5 12.725Q32.5 8.05 26.5 7.15V4.1Q33.8 5 38.65 10.55Q43.5 16.1 43.5 24Q43.5 28.4 41.425 32.4Q39.35 36.4 35.85 39.5H41.95V42.5ZM21.5 43.9Q17.9 43.45 14.775 41.75Q11.65 40.05 9.375 37.425Q7.1 34.8 5.8 31.375Q4.5 27.95 4.5 24Q4.5 19.6 6.575 15.6Q8.65 11.6 12.15 8.5H6.05V5.5H17.5V16.95H14.5V10.5Q11.3 13.05 9.4 16.575Q7.5 20.1 7.5 24Q7.5 30.6 11.5 35.275Q15.5 39.95 21.5 40.85ZM21.15 32.5 13.4 24.75 15.5 22.65 21.15 28.3 32.5 16.95 34.6 19.05Z" />
      </g>
    ),
  },
  READ: {
    format: 'markup',
    class: 'read',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z" />
      </g>
    ),
  },
  EXPAND_LESS: {
    format: 'markup',
    class: 'expand_less',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z" />
      </g>
    ),
  },
  EXPAND_MORE: {
    format: 'markup',
    class: 'expand_more',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z" />
      </g>
    ),
  },
  FILTER: {
    format: 'markup',
    class: 'filter',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <path d="M7,6h10l-5.01,6.3L7,6z M4.25,5.61C6.27,8.2,10,13,10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-6 c0,0,3.72-4.8,5.74-7.39C20.25,4.95,19.78,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z" />
      </g>
    ),
  },
  CALL_TO_ACTION: {
    format: 'markup',
    class: 'filter',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 15h14v3H5z" />
      </g>
    ),
  },
  NEXT_ARROW: {
    format: 'markup',
    class: 'next-arrow',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M22 12l-4-4v3H3v2h15v3l4-4z" />
      </g>
    ),
  },
  MIC: {
    format: 'markup',
    class: 'mic',
    viewBox: '0 0 24 24',
    markup: (
      <React.Fragment>
        <g>
          <rect fill="none" height="24" width="24" />
          <rect fill="none" height="24" width="24" />
          <rect fill="none" height="24" width="24" />
        </g>
        <g>
          <g />
          <g>
            <path d="M12,14c1.66,0,3-1.34,3-3V5c0-1.66-1.34-3-3-3S9,3.34,9,5v6C9,12.66,10.34,14,12,14z" />
            <path d="M17,11c0,2.76-2.24,5-5,5s-5-2.24-5-5H5c0,3.53,2.61,6.43,6,6.92V21h2v-3.08c3.39-0.49,6-3.39,6-6.92H17z" />
          </g>
        </g>
      </React.Fragment>
    ),
  },
  CHAT: {
    format: 'markup',
    class: 'chat',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2 10h8v2H6v-2zm0-3h12v2H6V9zm0-3h12v2H6V6z" />
      </g>
    ),
  },
  TIME: {
    format: 'markup',
    class: 'time',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
      </g>
    ),
  },
  SAVE_DISK: {
    format: 'markup',
    class: 'time',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm2 16H5V5h11.17L19 7.83V19zm-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zM6 6h9v4H6z" />
      </g>
    ),
  },
  GOAL: {
    format: 'markup',
    class: 'time',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <rect fill="none" height="24" width="24" />
        <path d="M11.71,17.99C8.53,17.84,6,15.22,6,12c0-3.31,2.69-6,6-6c3.22,0,5.84,2.53,5.99,5.71l-2.1-0.63C15.48,9.31,13.89,8,12,8 c-2.21,0-4,1.79-4,4c0,1.89,1.31,3.48,3.08,3.89L11.71,17.99z M22,12c0,0.3-0.01,0.6-0.04,0.9l-1.97-0.59C20,12.21,20,12.1,20,12 c0-4.42-3.58-8-8-8s-8,3.58-8,8s3.58,8,8,8c0.1,0,0.21,0,0.31-0.01l0.59,1.97C12.6,21.99,12.3,22,12,22C6.48,22,2,17.52,2,12 C2,6.48,6.48,2,12,2S22,6.48,22,12z M18.23,16.26L22,15l-10-3l3,10l1.26-3.77l4.27,4.27l1.98-1.98L18.23,16.26z" />
      </g>
    ),
  },
  GOOGLE: {
    format: 'markup',
    class: 'time',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24"
        viewBox="0 0 24 24"
        width="24"
      >
        <path
          d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
          fill="#4285F4"
        />
        <path
          d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
          fill="#34A853"
        />
        <path
          d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
          fill="#FBBC05"
        />
        <path
          d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
          fill="#EA4335"
        />
        <path d="M1 1h22v22H1z" fill="none" />
      </svg>
    ),
  },
  UPLOAD_FILE: {
    format: 'markup',
    class: 'upload_file',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <g>
          <rect fill="none" height="24" width="24" />
        </g>
        <g>
          <path d="M18,15v3H6v-3H4v3c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-3H18z M7,9l1.41,1.41L11,7.83V16h2V7.83l2.59,2.58L17,9l-5-5L7,9z" />
        </g>
      </g>
    ),
  },
  SCHOOLOGY_LOGO: {
    format: 'markup',
    markup: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_213_2)">
          <rect width="24" height="24" fill="white" />
          <circle cx="12" cy="12" r="12" fill="#8DD3F2" />
          <circle cx="12" cy="12" r="10" fill="#333333" />
          <path
            d="M16.5327 14.1362C16.5327 15.0737 16.1738 15.811 15.4561 16.3481C14.7432 16.8804 13.7495 17.1465 12.4751 17.1465C11.3276 17.1465 10.3926 16.9048 9.66992 16.4214C8.94727 15.938 8.4834 15.2349 8.27832 14.312L10.3657 14.041C10.478 14.5 10.7124 14.8638 11.0688 15.1323C11.4253 15.396 11.9136 15.5278 12.5337 15.5278C13.1782 15.5278 13.6543 15.4253 13.9619 15.2202C14.2744 15.0151 14.4307 14.6953 14.4307 14.2607C14.4307 13.9385 14.2939 13.6675 14.0205 13.4478C13.7471 13.2231 13.3491 13.0474 12.8267 12.9204C11.7769 12.6665 11.0347 12.4468 10.6001 12.2612C10.1704 12.0708 9.82617 11.8584 9.56738 11.624C9.30859 11.3896 9.1084 11.1162 8.9668 10.8037C8.83008 10.4863 8.76172 10.1323 8.76172 9.7417C8.76172 8.88721 9.10352 8.21094 9.78711 7.71289C10.4756 7.21484 11.3813 6.96582 12.5044 6.96582C13.5981 6.96582 14.4526 7.18311 15.0679 7.61768C15.6831 8.04736 16.0811 8.71631 16.2617 9.62451L14.167 9.83691C13.9521 8.94336 13.3833 8.49658 12.4604 8.49658C11.9429 8.49658 11.5474 8.59424 11.2739 8.78955C11.0005 8.97998 10.8638 9.25586 10.8638 9.61719C10.8638 9.85645 10.9297 10.0566 11.0615 10.2178C11.1934 10.374 11.3716 10.5083 11.5962 10.6206C11.8257 10.728 12.2896 10.8721 12.9878 11.0527C13.9058 11.2773 14.6113 11.5288 15.1045 11.8071C15.5977 12.0806 15.959 12.4126 16.1885 12.8032C16.418 13.1938 16.5327 13.6382 16.5327 14.1362Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_213_2">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  READER_PRICING: {
    format: 'markup',
    markup: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="15.7" r="15.5" fill="#C4DDF1" />
        <path
          d="M26.9375 13.3563H18.5391L16 5.54376L13.4609 13.3563H5.0625L11.8984 18.0438L9.26172 25.8563L16 20.9734L22.7383 25.8563L20.1016 18.0438L26.9375 13.3563Z"
          fill="#1286C8"
          stroke="#093E5D"
          strokeWidth="1.56043"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  CLASSROOM_PRICING: {
    format: 'markup',
    markup: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="15.7" r="15.5" fill="#1286C8" />
        <g clipPath="url(#clip0_289_955)">
          <path
            d="M16 19.6061C15.7451 19.6061 15.4922 19.5944 15.2427 19.5724C13.9552 19.4574 12.7103 19.0536 11.6004 18.3911C10.4906 17.7286 9.5443 16.8244 8.83203 15.7458L4.47656 23.5124H10.0918L12.9238 28.1999L16.9536 19.5529C16.637 19.5882 16.3186 19.6059 16 19.6061ZM23.1777 15.736C22.1463 17.2982 20.6352 18.483 18.8721 19.112L16.8643 23.488L19.0762 28.1999L21.9082 23.5124H27.5234L23.1777 15.736Z"
            fill="#E8F1F8"
          />
          <path
            d="M16.0005 13.3563C17.2949 13.3563 18.3442 12.3069 18.3442 11.0125C18.3442 9.71809 17.2949 8.66876 16.0005 8.66876C14.7061 8.66876 13.6567 9.71809 13.6567 11.0125C13.6567 12.3069 14.7061 13.3563 16.0005 13.3563Z"
            fill="#E8F1F8"
          />
          <path
            d="M16 3.98114C12.123 3.98114 8.96875 7.13544 8.96875 11.0124C8.96875 14.8893 12.123 18.0436 16 18.0436C19.877 18.0436 23.0312 14.8893 23.0312 11.0124C23.0312 7.13544 19.877 3.98114 16 3.98114ZM16 14.9186C15.2274 14.9186 14.4722 14.6895 13.8298 14.2603C13.1874 13.8311 12.6867 13.221 12.3911 12.5072C12.0954 11.7935 12.0181 11.0081 12.1688 10.2503C12.3195 9.49258 12.6916 8.79655 13.2379 8.25025C13.7842 7.70396 14.4802 7.33192 15.2379 7.1812C15.9957 7.03047 16.7811 7.10783 17.4949 7.40349C18.2086 7.69914 18.8187 8.19981 19.2479 8.84219C19.6772 9.48457 19.9062 10.2398 19.9062 11.0124C19.9051 12.048 19.4932 13.0409 18.7609 13.7732C18.0285 14.5056 17.0356 14.9175 16 14.9186Z"
            fill="#E8F1F8"
          />
        </g>
        <defs>
          <clipPath id="clip0_289_955">
            <rect
              width="25"
              height="25"
              fill="white"
              transform="translate(3.5 3.19995)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  CUSTOM_CLASSROOM_PRICING: {
    format: 'markup',
    markup: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="15.7" r="15.5" fill="#C4DDF1" />
        <g clipPath="url(#clip0_289_963)">
          <path
            d="M18.3438 21.9499V20.778C18.3438 19.362 19.8838 18.0226 20.8828 17.067C22.291 15.7209 23.0313 13.9123 23.0313 11.7936C23.0313 7.88736 19.9195 4.76236 16 4.76236C15.0759 4.75978 14.1605 4.93989 13.3062 5.29233C12.452 5.64477 11.6759 6.16259 11.0224 6.81601C10.369 7.46944 9.85119 8.24558 9.49875 9.09982C9.14631 9.95405 8.9662 10.8695 8.96878 11.7936C8.96878 13.8366 9.74075 15.7677 11.1172 17.067C12.1109 18.005 13.6563 19.3473 13.6563 20.778V21.9499M14.4375 26.6374H17.5625H14.4375ZM13.6563 24.2936H18.3438H13.6563ZM16 21.9499V15.6999V21.9499Z"
            fill="#1286C8"
          />
          <path
            d="M18.3438 21.9499V20.778C18.3438 19.362 19.8838 18.0226 20.8828 17.067C22.291 15.7209 23.0313 13.9123 23.0313 11.7936C23.0313 7.88736 19.9195 4.76236 16 4.76236C15.0759 4.75978 14.1605 4.93989 13.3062 5.29233C12.452 5.64477 11.6759 6.16259 11.0224 6.81601C10.369 7.46944 9.85119 8.24558 9.49875 9.09982C9.14631 9.95405 8.9662 10.8695 8.96878 11.7936C8.96878 13.8366 9.74075 15.7677 11.1172 17.067C12.1109 18.005 13.6563 19.3473 13.6563 20.778V21.9499M14.4375 26.6374H17.5625M13.6563 24.2936H18.3438M16 21.9499V15.6999"
            stroke="#093E5D"
            strokeWidth="1.56043"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.8549 14.9186C17.8549 14.9186 16.8048 15.6998 15.9997 15.6998C15.1947 15.6998 14.1445 14.9186 14.1445 14.9186"
            stroke="#093E5D"
            strokeWidth="1.56043"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_289_963">
            <rect
              width="25"
              height="25"
              fill="white"
              transform="translate(3.5 3.19995)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  PRICING_FEATURE_CHECK: {
    format: 'markup',
    markup: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 3.2937C9.60787 3.2937 3.59375 9.30782 3.59375 16.7C3.59375 24.0921 9.60787 30.1062 17 30.1062C24.3921 30.1062 30.4062 24.0921 30.4062 16.7C30.4062 9.30782 24.3921 3.2937 17 3.2937ZM23.9771 12.2069L15.3146 22.5194C15.2195 22.6326 15.1013 22.724 14.9678 22.7875C14.8344 22.851 14.6889 22.8851 14.5411 22.8875H14.5237C14.3792 22.8874 14.2362 22.857 14.1042 22.7981C13.9722 22.7393 13.854 22.6533 13.7574 22.5459L10.0449 18.4209C9.95058 18.3208 9.87724 18.203 9.82914 18.0743C9.78105 17.9455 9.75918 17.8084 9.76482 17.6711C9.77045 17.5338 9.80348 17.399 9.86197 17.2746C9.92045 17.1502 10.0032 17.0388 10.1054 16.9469C10.2075 16.8549 10.327 16.7843 10.4569 16.7392C10.5867 16.6941 10.7242 16.6755 10.8614 16.6843C10.9986 16.6931 11.1326 16.7293 11.2555 16.7906C11.3785 16.852 11.488 16.9373 11.5776 17.0416L14.4966 20.2848L22.3979 10.8805C22.5752 10.6756 22.8259 10.5486 23.096 10.5271C23.3661 10.5056 23.6338 10.5912 23.8412 10.7655C24.0487 10.9397 24.1792 11.1886 24.2046 11.4584C24.23 11.7281 24.1483 11.997 23.9771 12.2069Z"
          fill="#1286C8"
        />
      </svg>
    ),
  },
  PRICING_FEATURE_CHECK_SMALL: {
    format: 'markup',
    markup: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 3.2937C9.60787 3.2937 3.59375 9.30782 3.59375 16.7C3.59375 24.0921 9.60787 30.1062 17 30.1062C24.3921 30.1062 30.4062 24.0921 30.4062 16.7C30.4062 9.30782 24.3921 3.2937 17 3.2937ZM23.9771 12.2069L15.3146 22.5194C15.2195 22.6326 15.1013 22.724 14.9678 22.7875C14.8344 22.851 14.6889 22.8851 14.5411 22.8875H14.5237C14.3792 22.8874 14.2362 22.857 14.1042 22.7981C13.9722 22.7393 13.854 22.6533 13.7574 22.5459L10.0449 18.4209C9.95058 18.3208 9.87724 18.203 9.82914 18.0743C9.78105 17.9455 9.75918 17.8084 9.76482 17.6711C9.77045 17.5338 9.80348 17.399 9.86197 17.2746C9.92045 17.1502 10.0032 17.0388 10.1054 16.9469C10.2075 16.8549 10.327 16.7843 10.4569 16.7392C10.5867 16.6941 10.7242 16.6755 10.8614 16.6843C10.9986 16.6931 11.1326 16.7293 11.2555 16.7906C11.3785 16.852 11.488 16.9373 11.5776 17.0416L14.4966 20.2848L22.3979 10.8805C22.5752 10.6756 22.8259 10.5486 23.096 10.5271C23.3661 10.5056 23.6338 10.5912 23.8412 10.7655C24.0487 10.9397 24.1792 11.1886 24.2046 11.4584C24.23 11.7281 24.1483 11.997 23.9771 12.2069Z"
          fill="#1286C8"
        />
      </svg>
    ),
  },
  NEWSPAPER_OUTLINE: {
    format: 'markup',
    class: 'icon-newspaper-outline',
    viewBox: '0 0 16 16',
    markup: (
      <g>
        <g clipPath="url(#clip0_667_727)">
          <path
            d="M11.5 12.9956V2.25C11.4994 2.05127 11.4202 1.86083 11.2797 1.72031C11.1392 1.57978 10.9487 1.50058 10.75 1.5H2.25C2.05127 1.50058 1.86083 1.57978 1.72031 1.72031C1.57978 1.86083 1.50058 2.05127 1.5 2.25V13.25C1.50099 13.5812 1.633 13.8986 1.86721 14.1328C2.10142 14.367 2.41878 14.499 2.75 14.5H13"
            strokeWidth="1.00246"
            strokeLinejoin="round"
          />
          <path
            d="M13 14.5C12.6022 14.5 12.2206 14.342 11.9393 14.0607C11.658 13.7794 11.5 13.3978 11.5 13V4H13.75C13.9489 4 14.1397 4.07902 14.2803 4.21967C14.421 4.36032 14.5 4.55109 14.5 4.75V13C14.5 13.3978 14.342 13.7794 14.0607 14.0607C13.7794 14.342 13.3978 14.5 13 14.5Z"
            strokeWidth="1.00246"
            strokeLinejoin="round"
          />
          <path
            d="M7.5 4H9.5M7.5 6H9.5M3.5 8H9.5M3.5 10H9.5M3.5 12H9.5"
            strokeWidth="1.00246"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            className="fill"
            d="M5.5 6.5H3.5C3.36739 6.5 3.24021 6.44732 3.14645 6.35355C3.05268 6.25978 3 6.13261 3 6V4C3 3.86739 3.05268 3.74021 3.14645 3.64645C3.24021 3.55268 3.36739 3.5 3.5 3.5H5.5C5.63261 3.5 5.75978 3.55268 5.85355 3.64645C5.94732 3.74021 6 3.86739 6 4V6C6 6.13261 5.94732 6.25978 5.85355 6.35355C5.75978 6.44732 5.63261 6.5 5.5 6.5Z"
          />
        </g>
        <defs>
          <clipPath id="clip0_667_727">
            <rect width="16" height="16" className="fill" />
          </clipPath>
        </defs>
      </g>
    ),
  },
  DOCUMENT_TEXT_OUTLINE: {
    format: 'markup',
    class: 'icon-document-text-outline',
    viewBox: '0 0 16 16',
    markup: (
      <g>
        <path
          d="M13 6.91406V13C13 13.3978 12.842 13.7794 12.5607 14.0607C12.2794 14.342 11.8978 14.5 11.5 14.5H4.5C4.10218 14.5 3.72064 14.342 3.43934 14.0607C3.15804 13.7794 3 13.3978 3 13V3C3 2.60218 3.15804 2.22064 3.43934 1.93934C3.72064 1.65804 4.10218 1.5 4.5 1.5H7.58594C7.85106 1.50004 8.10532 1.60536 8.29281 1.79281L12.7072 6.20719C12.8946 6.39468 13 6.64894 13 6.91406Z"
          strokeWidth="1.00246"
          strokeLinejoin="round"
        />
        <path
          d="M8 1.75V5.5C8 5.76522 8.10536 6.01957 8.29289 6.20711C8.48043 6.39464 8.73478 6.5 9 6.5H12.75M5.5 9H10.5M5.5 11.5H10.5"
          strokeWidth="1.00246"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ),
  },
  LIBRARY_OUTLINE: {
    format: 'markup',
    class: 'icon-library-outline',
    viewBox: '0 0 16 16',
    markup: (
      <g>
        <g clipPath="url(#clip0_667_58)">
          <path
            d="M2.5 3H1.5C1.22386 3 1 3.22386 1 3.5V14C1 14.2761 1.22386 14.5 1.5 14.5H2.5C2.77614 14.5 3 14.2761 3 14V3.5C3 3.22386 2.77614 3 2.5 3Z"
            strokeWidth="1.00246"
            strokeLinejoin="round"
          />
          <path
            d="M3.5 7H7.5M3.5 12.5H7.5"
            strokeWidth="1.00246"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7 5H4C3.72386 5 3.5 5.22386 3.5 5.5V14C3.5 14.2761 3.72386 14.5 4 14.5H7C7.27614 14.5 7.5 14.2761 7.5 14V5.5C7.5 5.22386 7.27614 5 7 5Z"
            strokeWidth="1.00246"
            strokeLinejoin="round"
          />
          <path
            d="M10.5 1.5H8.5C8.22386 1.5 8 1.72386 8 2V14C8 14.2761 8.22386 14.5 8.5 14.5H10.5C10.7761 14.5 11 14.2761 11 14V2C11 1.72386 10.7761 1.5 10.5 1.5Z"
            strokeWidth="1.00246"
            strokeLinejoin="round"
          />
          <path
            d="M13.2018 3.00349L11.9393 3.13631C11.5918 3.17287 11.3399 3.49787 11.379 3.85818L12.4702 13.9079C12.5096 14.2682 12.8256 14.5329 13.1731 14.4966L14.4356 14.3638C14.7831 14.3272 15.0349 14.0022 14.9959 13.6419L13.9062 3.59381C13.8652 3.23193 13.5493 2.96693 13.2018 3.00349Z"
            strokeWidth="1.00246"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_667_58">
            <rect width="16" height="16" className="fill" />
          </clipPath>
        </defs>
      </g>
    ),
  },
  COURSE_FILLED_STAR: {
    format: 'markup',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enable-background="new 0 0 24 24"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
      >
        <g>
          <path d="M0 0h24v24H0V0z" fill="none" />
          <path d="M0 0h24v24H0V0z" fill="none" />
        </g>
        <g>
          <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z" />
        </g>
      </svg>
    ),
  },
  COURSE_STAR: {
    format: 'markup',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M12 7.13l.97 2.29.47 1.11 1.2.1 2.47.21-1.88 1.63-.91.79.27 1.18.56 2.41-2.12-1.28-1.03-.64-1.03.62-2.12 1.28.56-2.41.27-1.18-.91-.79-1.88-1.63 2.47-.21 1.2-.1.47-1.11.97-2.27M12 2L9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2z" />
      </svg>
    ),
  },
  TOPIC: {
    format: 'markup',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enableBackground="new 0 0 24 24"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="#000000"
      >
        <g>
          <rect fill="none" height="24" width="24" />
          <path d="M20,6h-8l-2-2H4C2.9,4,2.01,4.9,2.01,6L2,18c0,1.1,0.9,2,2,2h16.77c0.68,0,1.23-0.56,1.23-1.23V8C22,6.9,21.1,6,20,6z M20,18L4,18V6h5.17l2,2H20V18z M18,12H6v-2h12V12z M14,16H6v-2h8V16z" />
        </g>
      </svg>
    ),
  },
  BLOGS: {
    format: 'markup',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M15 4v7H5.17l-.59.59-.58.58V4h11m1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1z" />
      </svg>
    ),
  },
  PROFILE_SETTINGS: {
    format: 'markup',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
      </svg>
    ),
  },
  EQUAL: {
    format: 'markup',
    viewBox: '0 0 30 30',
    markup: (
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        width="30px"
        height="30px"
        viewBox="0 0 22.354 22.354"
      >
        <g>
          <g>
            <rect y="3.78" width="22.354" height="5.132" />
            <rect y="13.441" width="22.354" height="5.133" />
          </g>
        </g>
      </svg>
    ),
  },
  CALENDAR: {
    format: 'media',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enable-background="new 0 0 24 24"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
      >
        <g>
          <rect fill="none" height="24" width="24" />
        </g>
        <g>
          <path d="M19,4h-1V2h-2v2H8V2H6v2H5C3.89,4,3.01,4.9,3.01,6L3,20c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V6C21,4.9,20.1,4,19,4z M19,20 H5V10h14V20z M19,8H5V6h14V8z M9,14H7v-2h2V14z M13,14h-2v-2h2V14z M17,14h-2v-2h2V14z M9,18H7v-2h2V18z M13,18h-2v-2h2V18z M17,18 h-2v-2h2V18z" />
        </g>
      </svg>
    ),
  },
  DANGER_WARNING: {
    format: 'media',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
      >
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
      </svg>
    ),
  },
  THUMBS_DOWN: {
    format: 'media',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
      >
        <path d="M0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none" />
        <path d="M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm0 12-4.34 4.34L12 14H3v-2l3-7h9v10zm4-12h4v12h-4z" />
      </svg>
    ),
  },
  THUMBS_UP: {
    format: 'media',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
      >
        <path d="M0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none" />
        <path d="M9 21h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.58 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2zM9 9l4.34-4.34L12 10h9v2l-3 7H9V9zM1 9h4v12H1z" />
      </svg>
    ),
  },
  FOLDER_OPEN_OUTLINE: {
    format: 'markup',
    class: 'icon-folder-open-outline',
    viewBox: '0 0 24 24',
    markup: (
      <g>
        <path
          d="M3 9V5.625C3 5.12772 3.19754 4.65081 3.54917 4.29917C3.90081 3.94754 4.37772 3.75 4.875 3.75H8.43234C8.80256 3.75001 9.16448 3.85961 9.4725 4.065L10.7775 4.935C11.0855 5.14039 11.4474 5.24999 11.8177 5.25H19.125C19.6223 5.25 20.0992 5.44754 20.4508 5.79917C20.8025 6.15081 21 6.62772 21 7.125V9"
          stroke="url(#paint0_linear_5414_14802)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.4954 10.6195L21.7351 18.375C21.7351 18.8717 21.538 19.3481 21.1871 19.6997C20.8361 20.0512 20.3601 20.2491 19.8634 20.25H4.1368C3.64009 20.2491 3.16402 20.0512 2.8131 19.6997C2.46218 19.3481 2.26508 18.8717 2.26508 18.375L1.50477 10.6195C1.48827 10.4131 1.51468 10.2055 1.58234 10.0098C1.65001 9.81415 1.75745 9.63458 1.89792 9.48245C2.03838 9.33031 2.20882 9.20891 2.39851 9.12588C2.5882 9.04285 2.79302 8.99999 3.00008 9H21.0048C21.2114 9.00063 21.4157 9.04397 21.6049 9.12729C21.794 9.2106 21.9639 9.3321 22.1038 9.48417C22.2438 9.63623 22.3508 9.81557 22.4182 10.011C22.4856 10.2063 22.5119 10.4135 22.4954 10.6195Z"
          stroke="url(#paint1_linear_5414_14802)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_5414_14802"
            x1="21"
            y1="9"
            x2="4.33116"
            y2="1.22445"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="var(--color-start)" />
            <stop offset="1" stopColor="var(--color-stop)" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_5414_14802"
            x1="22.5002"
            y1="20.25"
            x2="0.256164"
            y2="14.6007"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="var(--color-start)" />
            <stop offset="1" stopColor="var(--color-stop)" />
          </linearGradient>
        </defs>
      </g>
    ),
  },
  GRADE: {
    format: 'markup',
    class: 'icon-grade',
    viewBox: '0 0 26 25',
    markup: (
      <g>
        <g clipPath="url(#clip0_5414_18296)">
          <path
            d="M13 16.4063C12.7451 16.4063 12.4922 16.3945 12.2427 16.3726C10.9552 16.2575 9.7103 15.8537 8.60042 15.1912C7.49055 14.5287 6.5443 13.6245 5.83203 12.5459L1.47656 20.3125H7.0918L9.92383 25L13.9536 16.353C13.637 16.3883 13.3186 16.406 13 16.4063ZM20.1777 12.5361C19.1463 14.0983 17.6352 15.2831 15.8721 15.9121L13.8643 20.2881L16.0762 25L18.9082 20.3125H24.5234L20.1777 12.5361Z"
            fill="currentColor"
          />
          <path
            d="M13 10.1565C14.2944 10.1565 15.3437 9.10716 15.3437 7.81274C15.3437 6.51833 14.2944 5.46899 13 5.46899C11.7056 5.46899 10.6562 6.51833 10.6562 7.81274C10.6562 9.10716 11.7056 10.1565 13 10.1565Z"
            fill="currentColor"
          />
          <path
            d="M13 0.78125C9.12305 0.78125 5.96875 3.93555 5.96875 7.8125C5.96875 11.6895 9.12305 14.8437 13 14.8437C16.877 14.8437 20.0312 11.6895 20.0312 7.8125C20.0312 3.93555 16.877 0.78125 13 0.78125ZM13 11.7187C12.2274 11.7187 11.4722 11.4897 10.8298 11.0604C10.1874 10.6312 9.68675 10.0211 9.39109 9.30736C9.09544 8.59358 9.01808 7.80817 9.16881 7.05043C9.31953 6.29269 9.69156 5.59666 10.2379 5.05036C10.7842 4.50406 11.4802 4.13203 12.2379 3.98131C12.9957 3.83058 13.7811 3.90794 14.4949 4.2036C15.2086 4.49925 15.8187 4.99992 16.2479 5.6423C16.6772 6.28468 16.9062 7.03992 16.9062 7.8125C16.9051 8.84814 16.4932 9.84104 15.7609 10.5734C15.0285 11.3057 14.0356 11.7176 13 11.7187Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_5414_18296">
            <rect
              width="25"
              height="25"
              fill="white"
              transform="translate(0.5)"
            />
          </clipPath>
        </defs>
      </g>
    ),
  },
  GRADE_CHECK: {
    format: 'markup',
    class: 'icon-grade-check',
    viewBox: '0 0 26 25',
    markup: (
      <g>
        <g clipPath="url(#clip0_5734_8967)">
          <path
            d="M19.8348 8V4.9685C19.8348 2.91052 18.1665 1.24219 16.1085 1.24219H6.17163C4.11364 1.24219 2.44531 2.91051 2.44531 4.9685V19.8738C2.44531 21.9318 4.11364 23.6001 6.17163 23.6001H10.5781"
            stroke="currentColor"
            strokeWidth="1.56505"
          />
          <path
            d="M6.17188 5.58936H15.4877M6.17188 9.93672H11.5781"
            stroke="currentColor"
            strokeWidth="1.55645"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.57812 14H8.57813M6.57812 19H8.3054"
            stroke="currentColor"
            strokeWidth="1.55645"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.0006 17.2398C24.0006 13.8279 21.2325 11.0598 17.8206 11.0598C14.4087 11.0598 11.6406 13.8279 11.6406 17.2398C11.6406 20.6517 14.4087 23.4198 17.8206 23.4198C21.2325 23.4198 24.0006 20.6517 24.0006 17.2398Z"
            stroke="currentColor"
            strokeWidth="1.76526"
            strokeMiterlimit="10"
          />
          <path
            d="M20.9066 14.6648L16.5806 19.8148L14.7266 17.7548"
            stroke="currentColor"
            strokeWidth="1.76526"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_5734_8967">
            <rect
              width="24.8421"
              height="24.8421"
              fill="white"
              transform="translate(0.578125)"
            />
          </clipPath>
        </defs>
      </g>
    ),
  },
  GRADE_I: {
    format: 'markup',
    class: 'icon-grade-i',
    viewBox: '0 0 26 25',
    markup: (
      <g>
        <g clipPath="url(#clip0_5687_8980)">
          <path
            d="M19.8348 8V4.9685C19.8348 2.91052 18.1665 1.24219 16.1085 1.24219H6.17163C4.11364 1.24219 2.44531 2.91051 2.44531 4.9685V19.8738C2.44531 21.9318 4.11364 23.6001 6.17163 23.6001H10.5781"
            stroke="currentColor"
            strokeWidth="1.56505"
          />
          <path
            d="M6.17188 5.58936H15.4877M6.17188 9.93672H11.5781"
            stroke="currentColor"
            strokeWidth="1.55645"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.57812 14H8.57813M6.57812 19H8.3054"
            stroke="currentColor"
            strokeWidth="1.55645"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g clipPath="url(#clip1_5687_8980)">
            <path
              d="M23.3197 16.4206C23.3197 12.9336 20.4906 10.1045 17.0036 10.1045C13.5166 10.1045 10.6875 12.9336 10.6875 16.4206C10.6875 19.9076 13.5166 22.7367 17.0036 22.7367C20.4906 22.7367 23.3197 19.9076 23.3197 16.4206Z"
              stroke="currentColor"
              strokeWidth="1.81061"
              strokeMiterlimit="10"
            />
            <path
              d="M16.6877 13.2496L16.8765 17.2613L17.065 13.2496C17.0662 13.224 17.0621 13.1984 17.053 13.1744C17.044 13.1503 17.0301 13.1284 17.0123 13.11C16.9944 13.0915 16.973 13.0768 16.9493 13.0669C16.9257 13.057 16.9002 13.052 16.8745 13.0523C16.8492 13.0525 16.8241 13.0578 16.8009 13.068C16.7776 13.0781 16.7566 13.0928 16.7392 13.1113C16.7218 13.1297 16.7082 13.1514 16.6994 13.1752C16.6905 13.199 16.6865 13.2243 16.6877 13.2496Z"
              stroke="currentColor"
              strokeWidth="2.11379"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16.8867 20.861C16.6974 20.861 16.5124 20.8049 16.355 20.6997C16.1976 20.5946 16.075 20.4451 16.0025 20.2702C15.9301 20.0954 15.9112 19.9029 15.9481 19.7173C15.985 19.5317 16.0761 19.3612 16.21 19.2273C16.3438 19.0935 16.5143 19.0023 16.7 18.9654C16.8856 18.9285 17.078 18.9474 17.2529 19.0199C17.4278 19.0923 17.5772 19.215 17.6824 19.3723C17.7875 19.5297 17.8437 19.7147 17.8437 19.904C17.8437 20.1578 17.7428 20.4012 17.5634 20.5807C17.3839 20.7602 17.1405 20.861 16.8867 20.861Z"
              fill="currentColor"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_5687_8980">
            <rect
              width="24.8421"
              height="24.8421"
              fill="white"
              transform="translate(0.578125)"
            />
          </clipPath>
          <clipPath id="clip1_5687_8980">
            <rect
              width="16.8429"
              height="16.8429"
              fill="white"
              transform="translate(8.57812 7.99927)"
            />
          </clipPath>
        </defs>
      </g>
    ),
  },
  CHECKMARK_CIRCLE: {
    format: 'markup',
    class: 'icon-checkmark-circle',
    viewBox: '0 0 20 20',
    markup: (
      <g>
        <path
          d="M10 0.0917969C4.62391 0.0917969 0.25 4.4657 0.25 9.8418C0.25 15.2179 4.62391 19.5918 10 19.5918C15.3761 19.5918 19.75 15.2179 19.75 9.8418C19.75 4.4657 15.3761 0.0917969 10 0.0917969ZM15.0742 6.57414L8.77422 14.0741C8.70511 14.1565 8.61912 14.223 8.52207 14.2691C8.42502 14.3153 8.31918 14.3401 8.21172 14.3418H8.19906C8.09394 14.3418 7.99 14.3196 7.89398 14.2768C7.79797 14.234 7.71202 14.1715 7.64172 14.0934L4.94172 11.0934C4.87315 11.0206 4.81981 10.9349 4.78483 10.8413C4.74986 10.7477 4.73395 10.648 4.73805 10.5481C4.74215 10.4482 4.76617 10.3502 4.8087 10.2597C4.85124 10.1693 4.91142 10.0882 4.98572 10.0214C5.06002 9.9545 5.14694 9.90316 5.24136 9.87037C5.33579 9.83758 5.43581 9.82399 5.53556 9.8304C5.63531 9.83682 5.73277 9.86311 5.82222 9.90773C5.91166 9.95235 5.99128 10.0144 6.05641 10.0902L8.17938 12.449L13.9258 5.60945C14.0547 5.46043 14.237 5.36811 14.4335 5.35246C14.6299 5.33681 14.8246 5.39908 14.9754 5.52581C15.1263 5.65254 15.2212 5.83356 15.2397 6.02973C15.2582 6.22589 15.1988 6.42145 15.0742 6.57414Z"
          fill="currentColor"
        />
      </g>
    ),
  },
  STP: {
    format: 'markup',
    class: 'icon-stp',
    viewBox: '0 0 40 40',
    markup: (
      <g>
        <path
          d="M30 4H7.07692C5.37759 4 4 5.79086 4 8V32C4 34.2091 5.37759 36 7.07692 36H32.9231C34.6224 36 36 34.2091 36 32V10.3025C34.5 8.64949 31.5 5.5 30 4Z"
          stroke="currentColor"
          strokeWidth="2.49669"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.5577 4H14.4423C13.6457 4 13 4.39175 13 4.875V10.125C13 10.6082 13.6457 11 14.4423 11H26.5577C27.3543 11 28 10.6082 28 10.125V4.875C28 4.39175 27.3543 4 26.5577 4Z"
          stroke="currentColor"
          strokeWidth="2.49669"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 30H25"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <mask id="path-4-inside-1_4755_7994" fill="white">
          <rect x="9" y="25" width="21" height="12" rx="2" />
        </mask>
        <rect
          x="9"
          y="25"
          width="21"
          height="12"
          rx="2"
          stroke="currentColor"
          strokeWidth="2.5"
          mask="url(#path-4-inside-1_4755_7994)"
        />
      </g>
    ),
  },
  CLASSROOM: {
    format: 'media',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h2v5l-1-.75L9 9V4zm9 16H6V4h1v9l3-2.25L13 13V4h5v16z" />
      </svg>
    ),
  },
  POSITIVE_FEEDBACK: {
    format: 'media',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        viewBox="0 0 24 24"
      >
        <path d="m7.982,19.299c-.061.223-.262.369-.482.369C3,18.5,0,14.502,0,10,0,4.486,4.486,0,10,0c4.949,0,9.103,3.542,9.876,8.422.043.272-.144.529-.416.572-.268.041-.528-.142-.572-.416-.695-4.391-4.434-7.578-8.888-7.578C5.037,1,1,5.038,1,10c0,4.052,2.727,7.623,6.631,8.686.267.072.424.348.352.613Zm16.018-1.799v4c0,1.379-1.121,2.5-2.5,2.5h-6.879c-1.9,0-3.55-1.353-3.923-3.216l-.63-2.154c-.187-.926.04-1.833.612-2.531h0c.572-.698,1.418-1.099,2.32-1.099h3.183l-.58-3.265c-.008-.065-.019-.556-.007-.598.121-.444.402-.794.792-.985.393-.193.848-.199,1.28-.02.255.106.503.368.682.719l2.193,4.148h.956c1.379,0,2.5,1.121,2.5,2.5Zm-3.958-1.637c-.159-.092-.292-.226-.382-.395l-2.197-4.155c-.103-.203-.196-.266-.197-.266-.143-.059-.305-.061-.438.003-.11.054-.195.154-.246.285l.014.291.572,3.2c.053.291-.026.589-.217.816-.193.229-.472.358-.768.358h-3.183c-.602,0-1.165.267-1.547.732s-.533,1.071-.415,1.66l.63,2.154c.289,1.438,1.527,2.453,2.952,2.453h5.382l.039-7.137Zm2.958,1.637c0-.827-.673-1.5-1.5-1.5h-.459l-.038,7h.497c.827,0,1.5-.673,1.5-1.5v-4Zm-7.955-10c.196-.194.198-.511.004-.707-.193-.197-.51-.198-.707-.004l-4.34,4.294c-.559.553-1.466.552-2.022,0l-2.128-2.103c-.197-.195-.514-.191-.707.004-.194.197-.192.513.004.707l2.128,2.103c.473.467,1.093.701,1.714.701s1.242-.234,1.715-.702l4.34-4.294Z" />
      </svg>
    ),
  },
  NEGATIVE_FEEDBACK: {
    format: 'media',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        viewBox="0 0 24 24"
      >
        <path d="m19,0H5C2.243,0,0,2.243,0,5v14c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5V5c0-2.757-2.243-5-5-5Zm-8,6c0-.553.447-1,1-1s1,.447,1,1v7.5c0,.553-.447,1-1,1s-1-.447-1-1v-7.5Zm1,13c-.828,0-1.5-.672-1.5-1.5s.672-1.5,1.5-1.5,1.5.672,1.5,1.5-.672,1.5-1.5,1.5Z" />
      </svg>
    ),
  },
  WORDS: {
    format: 'media',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z" />
      </svg>
    ),
  },
  CHART: {
    format: 'media',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enable-background="new 0 0 24 24"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
      >
        <g>
          <rect fill="none" height="24" width="24" />
        </g>
        <g>
          <g>
            <path d="M21,8c-1.45,0-2.26,1.44-1.93,2.51l-3.55,3.56c-0.3-0.09-0.74-0.09-1.04,0l-2.55-2.55C12.27,10.45,11.46,9,10,9 c-1.45,0-2.27,1.44-1.93,2.52l-4.56,4.55C2.44,15.74,1,16.55,1,18c0,1.1,0.9,2,2,2c1.45,0,2.26-1.44,1.93-2.51l4.55-4.56 c0.3,0.09,0.74,0.09,1.04,0l2.55,2.55C12.73,16.55,13.54,18,15,18c1.45,0,2.27-1.44,1.93-2.52l3.56-3.55 C21.56,12.26,23,11.45,23,10C23,8.9,22.1,8,21,8z" />
            <polygon points="15,9 15.94,6.93 18,6 15.94,5.07 15,3 14.08,5.07 12,6 14.08,6.93" />
            <polygon points="3.5,11 4,9 6,8.5 4,8 3.5,6 3,8 1,8.5 3,9" />
          </g>
        </g>
      </svg>
    ),
  },
  PUZZLE: {
    format: 'media',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M10.5 4.5c.28 0 .5.22.5.5v2h6v6h2c.28 0 .5.22.5.5s-.22.5-.5.5h-2v6h-2.12c-.68-1.75-2.39-3-4.38-3s-3.7 1.25-4.38 3H4v-2.12c1.75-.68 3-2.39 3-4.38 0-1.99-1.24-3.7-2.99-4.38L4 7h6V5c0-.28.22-.5.5-.5m0-2C9.12 2.5 8 3.62 8 5H4c-1.1 0-1.99.9-1.99 2v3.8h.29c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-.3c0-1.49 1.21-2.7 2.7-2.7s2.7 1.21 2.7 2.7v.3H17c1.1 0 2-.9 2-2v-4c1.38 0 2.5-1.12 2.5-2.5S20.38 11 19 11V7c0-1.1-.9-2-2-2h-4c0-1.38-1.12-2.5-2.5-2.5z" />
      </svg>
    ),
  },
  OFFLINE: {
    format: 'media',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="#f23c51"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" />
      </svg>
    ),
  },
  ONLINE: {
    format: 'media',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="#7fb800"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" />
      </svg>
    ),
  },
  WARNING: {
    format: 'media',
    viewBox: '0 0 24 24',
    markup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="#c28e4c"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" />
      </svg>
    ),
  },
  EXCEL: {
    format: 'media',
    viewBox: '0 0 32 32',
    markup: (
      <svg
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient
            id="a"
            x1="4.494"
            y1="-2092.086"
            x2="13.832"
            y2="-2075.914"
            gradientTransform="translate(0 2100)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#18884f" />
            <stop offset="0.5" stopColor="#117e43" />
            <stop offset="1" stopColor="#0b6631" />
          </linearGradient>
        </defs>
        <title>file_type_excel</title>
        <path
          d="M19.581,15.35,8.512,13.4V27.809A1.192,1.192,0,0,0,9.705,29h19.1A1.192,1.192,0,0,0,30,27.809h0V22.5Z"
          style={{ fill: '#185c37' }}
        />
        <path
          d="M19.581,3H9.705A1.192,1.192,0,0,0,8.512,4.191h0V9.5L19.581,16l5.861,1.95L30,16V9.5Z"
          style={{ fill: '#21a366' }}
        />
        <path d="M8.512,9.5H19.581V16H8.512Z" style={{ fill: '#107c41' }} />
        <path
          d="M16.434,8.2H8.512V24.45h7.922a1.2,1.2,0,0,0,1.194-1.191V9.391A1.2,1.2,0,0,0,16.434,8.2Z"
          style={{ opacity: 0.10000000149011612, isolation: 'isolate' }}
        />
        <path
          d="M15.783,8.85H8.512V25.1h7.271a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.783,8.85Z"
          style={{ opacity: 0.20000000298023224, isolation: 'isolate' }}
        />
        <path
          d="M15.783,8.85H8.512V23.8h7.271a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.783,8.85Z"
          style={{ opacity: 0.20000000298023224, isolation: 'isolate' }}
        />
        <path
          d="M15.132,8.85H8.512V23.8h6.62a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.132,8.85Z"
          style={{ opacity: 0.20000000298023224, isolation: 'isolate' }}
        />
        <path
          d="M3.194,8.85H15.132a1.193,1.193,0,0,1,1.194,1.191V21.959a1.193,1.193,0,0,1-1.194,1.191H3.194A1.192,1.192,0,0,1,2,21.959V10.041A1.192,1.192,0,0,1,3.194,8.85Z"
          style={{ fill: 'url(#a)' }}
        />
        <path
          d="M5.7,19.873l2.511-3.884-2.3-3.862H7.758L9.013,14.6c.116.234.2.408.238.524h.017c.082-.188.169-.369.26-.546l1.342-2.447h1.7l-2.359,3.84,2.419,3.905H10.821l-1.45-2.711A2.355,2.355,0,0,1,9.2,16.8H9.176a1.688,1.688,0,0,1-.168.351L7.515,19.873Z"
          style={{ fill: '#fff' }}
        />
        <path
          d="M28.806,3H19.581V9.5H30V4.191A1.192,1.192,0,0,0,28.806,3Z"
          style={{ fill: '#33c481' }}
        />
        <path d="M19.581,16H30v6.5H19.581Z" style={{ fill: '#107c41' }} />
      </svg>
    ),
  },
  CSV: {
    format: 'media',
    viewBox: '-4 0 64 64',
    markup: (
      <svg
        width="64px"
        height="64px"
        viewBox="-4 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.106 0c-2.802 0-5.073 2.272-5.073 5.074v53.841c0 2.803 2.271 5.074 5.073 5.074h45.774c2.801 0 5.074-2.271 5.074-5.074v-38.605l-18.903-20.31h-31.945z"
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#45B058"
        />

        <path
          d="M20.306 43.197c.126.144.198.324.198.522 0 .378-.306.72-.703.72-.18 0-.378-.072-.504-.234-.702-.846-1.891-1.387-3.007-1.387-2.629 0-4.627 2.017-4.627 4.88 0 2.845 1.999 4.879 4.627 4.879 1.134 0 2.25-.486 3.007-1.369.125-.144.324-.233.504-.233.415 0 .703.359.703.738 0 .18-.072.36-.198.504-.937.972-2.215 1.693-4.015 1.693-3.457 0-6.176-2.521-6.176-6.212s2.719-6.212 6.176-6.212c1.8.001 3.096.721 4.015 1.711zm6.802 10.714c-1.782 0-3.187-.594-4.213-1.495-.162-.144-.234-.342-.234-.54 0-.361.27-.757.702-.757.144 0 .306.036.432.144.828.739 1.98 1.314 3.367 1.314 2.143 0 2.827-1.152 2.827-2.071 0-3.097-7.112-1.386-7.112-5.672 0-1.98 1.764-3.331 4.123-3.331 1.548 0 2.881.467 3.853 1.278.162.144.252.342.252.54 0 .36-.306.72-.703.72-.144 0-.306-.054-.432-.162-.882-.72-1.98-1.044-3.079-1.044-1.44 0-2.467.774-2.467 1.909 0 2.701 7.112 1.152 7.112 5.636.001 1.748-1.187 3.531-4.428 3.531zm16.994-11.254l-4.159 10.335c-.198.486-.685.81-1.188.81h-.036c-.522 0-1.008-.324-1.207-.81l-4.142-10.335c-.036-.09-.054-.18-.054-.288 0-.36.323-.793.81-.793.306 0 .594.18.72.486l3.889 9.992 3.889-9.992c.108-.288.396-.486.72-.486.468 0 .81.378.81.793.001.09-.017.198-.052.288z"
          fill="#ffffff"
        />

        <g fillRule="evenodd" clipRule="evenodd">
          <path
            d="M56.001 20.357v1h-12.8s-6.312-1.26-6.128-6.707c0 0 .208 5.707 6.003 5.707h12.925z"
            fill="#349C42"
          />

          <path
            d="M37.098.006v14.561c0 1.656 1.104 5.791 6.104 5.791h12.8l-18.904-20.352z"
            opacity=".5"
            fill="#ffffff"
          />
        </g>
      </svg>
    ),
  },
};

export default ICONS;
